import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: {
        translation: {
          "header": {
            "notifications": "Notifiche", "settings": "Impostazioni", "help": "Aiuto", "my_profile": "Il mio profilo", "logout": "Disconnetti", "change_lang": "Cambia lingua", "loading": "Caricamento..."
          },

"auth": {
  "access_portal": "Accedi al portale",
  "login": "Accedi",
  "email": "Email",
  "password": "Password",
  "forgot_password": "Password dimenticata?",
  "errors": {
    "email_req": "Email obbligatoria",
    "pass_req": "Password obbligatoria",
    "invalid_credentials": "Email o password errati"
  
},


  "reset_title": "Reset Password",
  "reset_desc": "Inserisci la tua email per ricevere le istruzioni.",
  "send_link": "Invia Link di Reset",
  "back_to_login": "Torna al Login",
  "success_msg": "Email inviata con successo!",
  "update_password": {
    "title": "Nuova Password",
    "desc": "Inserisci la tua nuova password qui sotto.",
    "new_password": "Nuova password",
    "confirm_password": "Conferma password",
    "button": "Aggiorna Password",
    "success": "Password aggiornata con successo!",
    "error_match": "Le password non corrispondono"
  }
},


          "hero": {
            "welcome": "Benvenuto su", 
            "subtitle": "Digitalizza la gestione dei tuoi dipendenti. Elimina la carta e gestisci buste paga, contratti e documenti aziendali in un unico portale sicuro.",
            "cta_button": "Accedi al Portale", "gdpr_note": "Sistema protetto e conforme alle normative sulla conservazione digitale"
          },
          "cta": {
            "title": "Porta la tua azienda nel futuro digitale", 
            "description": "Unisciti alle aziende che hanno eliminato il cartaceo con OrizonDesk Portal per la gestione documentale intelligente.",
            "button_contact": "Contatta Team Orizon", "feature_card": "Attivazione immediata", "feature_setup": "Setup veloce", "feature_support": "Supporto tecnico",
            "button_learn_more": "Cos'è OrizonDesk?"
          },
          "features": {
            "main_title": "Perché passare al Digitale con OrizonDesk",
            "main_subtitle": "La soluzione SaaS completa per eliminare i faldoni cartacei e automatizzare la distribuzione dei documenti",
            "security_title": "Archivio Sicuro",
            "security_desc": "Buste paga e documenti sensibili protetti da crittografia end-to-end e accesso sicuro per ogni dipendente.",
            "speed_title": "Distribuzione Rapida",
            "speed_desc": "Consegna istantanea dei documenti ai dipendenti con un clic, eliminando tempi di attesa e sprechi di carta.",
            "privacy_title": "Conformità Totale",
            "privacy_desc": "Piena aderenza al GDPR e alle normative vigenti sulla privacy e conservazione dei dati personali.",
            "support_title": "Supporto Dedicato",
            "support_desc": "Assistenza specializzata per accompagnare la tua azienda nella transizione digitale dal cartaceo."
          },
          "footer": {
            "rights": "Tutti i diritti riservati.",
            "gdpr_text": "Conforme al GDPR e alle normative italiane sulla privacy",
            "privacy": "Privacy",
            "terms": "Termini di servizio",
            "contact": "Contatti"
          },
          "landing": {
            "seo_title": "OrizonDesk - Autenticazione Sicura | Digitalizzazione Documenti",
            "seo_description": "Piattaforma sicura per la gestione di buste paga e documenti aziendali. Elimina la carta e gestisci i tuoi dipendenti in modo digitale e conforme al GDPR.",
            "seo_keywords": "buste paga digitali, gestione documenti, GDPR, sicurezza dati, portale dipendenti, Italia",
            "footer_privacy": "Privacy",
            "footer_terms": "Termini di servizio",
            "footer_contact": "Contatti",
            "footer_rights": "Tutti i diritti riservati.",
            "footer_gdpr": "Conforme al GDPR e alle normative italiane sulla privacy"
            },
            "testimonials": {
                "title": "Cosa Dicono i Nostri Clienti",
                "subtitle": "Testimonianze reali da aziende che hanno scelto OrizonDesk Portale per la loro gestione documenti dei dipendenti in sicurezza"
            },

            
            "dashboard": {
  "welcome_card": {
    "loading": "Caricamento...",
    "morning": "Buongiorno",
    "afternoon": "Buon pomeriggio",
    "evening": "Buonasera",
    "subtitle": "Gestisci i documenti di {{azienda}} in totale sicurezza."
  }
},

"dipendente": {
  "welcome_card_dipendente": {
    "loading_dipendente": "Caricamento...",
    "morning_dipendente": "Buongiorno",
    "afternoon_dipendente": "Buon pomeriggio",
    "evening_dipendente": "Buonasera",
    "subtitle_dipendente": "Visualizza e scarica i tuoi documenti personali di {{azienda}} in totale sicurezza."
  }
},

"owner_welcome": {
  "loading": "Caricamento...",
  "morning": "Buongiorno",
  "afternoon": "Buon pomeriggio",
  "evening": "Buonasera",
  "role_subtitle": "Siete loggati come CEO di {{azienda}}."
},

  "create_company": {
    "back": "Indietro",
    "title": "Registra una nuova azienda",
    "subtitle": "Inserisci i dati per creare il nuovo portale aziendale",
    "admin_section": "Dati dell'amministratore",
    "company_section": "Dati dell'azienda",
    "plan_section": "Dettagli del Piano",
    "success": "Azienda e amministratore registrati con successo!",
    "button": "Crea azienda",
    "labels": {
      "name": "Nome",
      "surname": "Cognome",
      "cf": "Codice Fiscale",
      "phone": "Telefono",
      "email": "Email di accesso",
      "company_name": "Nome dell'azienda",
      "address": "Indirizzo",
      "vat": "Partita IVA",
      "plan": "Scegli il piano",
      "start": "Contratto dal",
      "end": "Contratto al",
      "max_emp": "Max. dipendenti:",
      "cloud_space": "Spazio Cloud:"
    },
    "plans": {
      "basic": "BASIC (10 dipendenti / 5GB)",
      "premium": "PREMIUM (50 dipendenti / 15GB)",
      "enterprise": "ENTERPRISE (∞ dipendenti / 100GB)"
    },
    "info": {
      "password_auto": "Il Codice Fiscale (CF) verrà utilizzato come password iniziale per l'accesso."
    },
    "errors": {
      "email_req": "L'email è obbligatoria",
      "cf_req": "Il codice fiscale è obbligatorio",
      "name_req": "Il nome è obbligatorio",
      "company_req": "Il nome dell'azienda è obbligatorio",
      "date_req": "La data di scadenza è obbligatoria"
    }
  },

"hero_owner": {
  "title": "Espandi il tuo Business",
  "subtitle": "Crea una nuova azienda nel sistema Orizon. Potrai gestire nuovi dipendenti, documenti e permessi per ogni singola entità.",
  "button": "Registra Nuova Azienda"
},

"home_superadmin": {
    "sections": {
      "quick_actions": "Azioni Rapide"
    },
    "stats": {
      "active_sessions": "I Miei Documenti",
      "total_employees": "Totale Dipendenti",
      "pending_notif": "Notifiche Pending",
      "total_aziende": "Totale Aziende",
      "avg_time": "STATO PIANO",
    "check_usage": "controlla il consumo di risorse",
      "vs_last_month": "rispetto al mese scorso"
    },
    "actions": {
      "profile": { "title": "Gestisci Profilo", "desc": "Aggiorna le tue informazioni personali" },
      "settings": { "title": "Impostazioni Sistema", "desc": "Configura le preferenze dell'applicazione" },
      "create_employee": { "title": "Registra Dipendente", "desc": "Crea un nuovo portale per il collaboratore" },
      "support": { "title": "Supporto e Aiuto", "desc": "Accedi alla documentazione e al supporto" },
      "trash": { "title": "Cestino Documenti", "desc": "Gestisci i file eliminati" },
      "holidays_management": { "title": "Gestione Ferie", "desc": "Approva o rifiuta le richieste dei dipendenti" },
      "inventory": { "title": "Sistema di Inventario", "desc": "Gestisci la tue tabelle" 
}
    }
  },
  "home_dipendente": {
    "stats": {
      "my_documents": "I Miei Documenti",
      "monthly_hours": "Ore Mensili",
      "pending_notif": "Notifiche",
      "avg_session": "Sessione Media",
      "vs_last_month": "rispetto al mese scorso"
    },
    "actions": {
      "notifications": { "title": "Centro Notifiche", "desc": "Visualizza le tue notifiche recenti" }
    },

   
    "activities_title": "Attività Recenti",
    "activities_subtitle": "Le tue ultime azioni nell'applicazione",
    "no_activities": "Nessuna attività recente da visualizzare",
    "activities": {
      "login_title": "Accesso effettuato",
      "login_desc": "Hai effettuato l'accesso al sistema da un nuovo dispositivo"
    }
  },

"create_employee": {
  "back": "Indietro",
  "title": "Registra Nuovo Dipendente",
  "subtitle": "L'utente verrà associato automaticamente a:",
  "section_title": "Informazioni Personali",
  "labels": {
    "name": "Nome",
    "surname": "Cognome",
    "cf": "Codice Fiscale",
    "email": "Email",
    "phone": "Telefono",
    "role": "Ruolo Utente"
  },

  "roles": {
    "user": "Dipendente (User)",
    "admin": "Amministratore Aziendale (Admin)"
  },

  "placeholders": {
    "cf": "Inserisci CF"
  },
  "submit_btn": "Crea Portale Dipendente",
  "success_msg": "Invito inviato con successo.",
  "errors": {
    "email_req": "Email obbligatoria",
    "cf_req": "Codice Fiscale obbligatorio",
    "name_req": "Nome obbligatorio",
    "no_company": "Errore: Impossibile identificare l'azienda di origine.",

 
  "limit_title": "Limite raggiunto",
  "limit_reached": "L'azienda ha raggiunto il limite massimo di {{max}} dipendenti.",
  "upgrade_now": "Vai allo stato e aggiorna"
  }
},


"legal": {
  "back": "Torna indietro",
  "title": "Informazioni Legali e Privacy",
  "version": "Orizon Desk Portal • Versione 1.2.1 • 2026",
  "terms": {
    "title": "Termini di Utilizzo",
    "p1": "Orizon Desk Portal è una piattaforma aziendale chiusa destinata esclusivamente ai dipendenti e alla direzione dell'azienda. Accedendo al portale, l'utente si impegna a rispettare le regole interne di comunicazione digitale.",
    "li1": "È vietata la condivisione dei dati di accesso (email e password) con terzi.",
    "li2": "Qualsiasi tentativo di accesso non autorizzato a sezioni del sistema per le quali l'utente non dispone di permessi è considerato una violazione della disciplina lavorativa.",
    "li3": "Il portale può essere utilizzato esclusivamente per la visualizzazione di documenti personali, la registrazione del lavoro e la comunicazione interna."
  },
  "privacy": {
    "title": "Trasparenza e Accesso",
    "sub": "Chi ha accesso ai tuoi documenti?",
    "user_title": "Dipendente",
    "user_desc": "Ha piena visibilità delle proprie buste paga, CUD, certificati medici... Può visualizzarli e scaricarli in qualsiasi momento.",
    "admin_title": "Amministratori",
    "admin_desc": "Il personale HR e contabile autorizzato può caricare, aggiornare o eliminare documenti. Questo accesso è necessario per la distribuzione digitale della documentazione.",
    "note": "Nota sulla privacy: Gli amministratori aziendali accedono ai documenti esclusivamente nell'ambito delle loro mansioni lavorative. Ogni accesso è registrato dal sistema per prevenire abusi."
  },
  "security": {
    "title": "Protezione Tecnica dei Dati",
    "enc_t": "Crittografia dei dati",
    "enc_d": "Tutti i documenti sono crittografati durante il trasferimento (SSL) e a riposo sul server (AES-256). La tua password è 'hashed' e nessuno può vederla in forma originale.",
    "infra_t": "Infrastruttura database (AWS e Google Cloud)",
    "infra_d": "I dati sono conservati su server ad alta sicurezza conformi agli standard GDPR e SOC2. Utilizziamo la Row-Level Security (RLS) per garantire che il database rifiuti ogni richiesta non autorizzata."
  },
  "rights": {
    "title": "I Tuoi Diritti",
    "r1": "Diritto di accesso ai dati",
    "r2": "Diritto di rettifica delle informazioni errate",
    "r3": "Diritto alla cancellazione dell'account",
    "r4": "Diritto alla portabilità dei dati"
  },
  "contact_info": "Per ulteriori informazioni sui tuoi diritti, contatta:",
  "rights_reserved": "© 2026 Orizon AIX. Tutti i diritti riservati."
},


"contact": {
  "back": "Torna indietro",
  "title": "Contattaci",
  "subtitle": "Hai una domanda? Siamo qui per aiutarti.",
  "success_title": "Inviato con successo!",
  "success_desc": "Il tuo messaggio è stato inviato. Ti risponderemo il prima possibile.",
  "label_name": "Nome e Cognome",
  "label_email": "Indirizzo Email",
  "label_subject": "Oggetto",
  "label_message": "Il tuo Messaggio",
  "placeholder_name": "Il tuo nome e cognome",
  "placeholder_subject": "Domanda sul portale OrizonDesk...",
  "placeholder_message": "Scrivi qui la tua richiesta...",
  "btn_send": "Invia Messaggio",
  "info_email": "Email Diretta",
  "info_web": "Sito Web"
},


  "profile": {
    "loading": "Caricamento...",
    "no_data": "Nessun dato trovato.",
    "full_name": "Nome Completo",
    "email": "Email Aziendale",
    "phone": "Telefono",
    "not_specified": "Non specificato",
    "cf": "Codice Fiscale",
    "role": "Ruolo",
    "employee": "Dipendente",
    "reg_date": "Data di registrazione",
    "last_access": "Ultimo Accesso",
    "first_session": "Prima sessione",
    "unique_id": "Identificativo Unico (ID)",
    "change_password": "Cambia Password"
  },

"profile_page": {
  "title": "Mio Profilo",
  "back": "Indietro",
  "qr_badge": "Il Mio Badge QR",
  "my_holidays": "Le Mie Ferie"
},
  
  "change_password": {
    "title": "Cambia Password",
    "subtitle": "Aggiorna le tue credenziali di accesso",
    "security_section": "Sicurezza Account",
    "labels": {
      "old": "Password Attuale",
      "new": "Nuova Password",
      "confirm": "Conferma Password"
    },
    "errors": {
      "mismatch": "Le password non corrispondono",
      "wrong_old": "Password attuale errata"
    },
    "success": "Password aggiornata con successo!",
    "submit_btn": "Salva Modifiche"
  },

 "dipendenti_list": {
  "loading": "Caricamento dipendenti...",
  "title": "Gestione Organico",
  "subtitle": "Visualizza i dipendenti dell'azienda",
  "search_placeholder": "Cerca dipendente...",
  "no_results": "Nessun dipendente trovato per questa azienda.",
  "filter_active": "Attivi",
  "filter_inactive": "Non Attivi",
  "table": {
    "name": "Dipendente",
    "email": "Email",
    "role": "Ruolo",
    "actions": "Azioni"
  }
},


  "months": {
    "january": "Gennaio", "february": "Febbraio", "march": "Marzo", "april": "Aprile", "may": "Maggio", "june": "Giugno",
    "july": "Luglio", "august": "Agosto", "september": "Settembre", "october": "Ottobre", "november": "Novembre", "december": "Dicembre"
  },
  "timbrature": {
    "archive_title": "Archivio Mie Timbrature",
    "history_title": "Storico Presenze",
    "no_data": "Nessuna timbratura trovata per questo periodo.",
    "filters": {
      "month": "Mese",
      "year": "Anno",
      "view": "Visualizza",
      "loading": "Caricamento..."
    },
    "stats": {
      "ord": "Ore Ordinarie",
      "straord": "Ore Straordinarie",
      "monthly_total": "Totale Mensile",
      "total": "Totale"
    },
    "table": {
      "name": "Nome",
      "surname": "Cognome",
      "date": "Data",
      "entry": "Entrata",
      "exit": "Uscita",
      "ord_short": "Ord. (8h)",
      "straord_short": "Straord."
    }
  },

  "categ": {
  "title": "Nuova Categoria",
  "title2": "Nuova Categoria",
  "name": "Nome Categoria",
  "placeholder": "Inserisci nome...",
  "hint": "Disponibile per tutti i dipendenti di questa azienda.",
  "error_duplicate": "Errore: Questa categoria esiste già per questa azienda!",
  "error_generic": "Si è verificato un errore",
  "manager_title": "Gestisci Categorie",
  "add_new": "Aggiungi Nuova",
  "your_list": "Le tue categorie",
  "no_custom": "Nessuna categoria personalizzata",
  "error_delete": "Errore durante l'eliminazione"
},

  "settings": {
  "title": "Impostazioni",
  "theme_title": "Personalizza",
  "dark_mode": "Tema Scura",
  "light_mode": "Tema Chiara",
  "subtitle": "Personalizza la tua esperienza",
  "group_notifications": "Notifiche & Avvisi",
  "group_security": "Sicurezza & Accesso",
  "group_preferences": "Preferenze App",
  "push_label": "Notifiche Push",
  "push_desc": "Ricevi avvisi in tempo reale",
  "email_label": "Report Settimanali",
  "email_desc": "Resoconto ore via email",
  "bio_label": "Biometria",
  "bio_desc": "Sblocco rapido FaceID/Fingerprint",
  "logout_label": "Auto Log-out",
"delete_label": "Auto-Elimina",
  "delete_desc": "Elimina tutti i file dal cestino dopo 30 giorni",

  "logout_desc": "Esci dopo 30 min di inattività",

  "dark_label": "Modalità Scura",
  "dark_desc": "Interfaccia ad alto contrasto",
  "gps_label": "GPS Precisione",
  "gps_desc": "Migliora rilevamento posizione",
  "version": "Versione App",
  "reset": "Ripristina tutte le preferenze"
},


  "months": {
    "Gennaio": "Gennaio",
    "Febbraio": "Febbraio",
    "Marzo": "Marzo",
    "Aprile": "Aprile",
    "Maggio": "Maggio",
    "Giugno": "Giugno",
    "Luglio": "Luglio",
    "Agosto": "Agosto",
    "Settembre": "Settembre",
    "Ottobre": "Ottobre",
    "Novembre": "Novembre",
    "Dicembre": "Dicembre"
  },
  "myDocuments": {
    "title": "Archivio Documenti",
    "auditLogButton": "Monitoraggio Audit",
    "subtitle": "Visualizza e scarica i tuoi documenti, certificati e buste paga.",
    "backHome": "Torna alla Home",
    "searchPlaceholder": "Nome file, tipologia, corso...",
    "searchLabel": "Cerca nel tuo archivio",
    "filterAnno": "Anno",
    "filterTipo": "Tipo",
    "filterAll": "Tutti",
    "table": {
      "document": "Documento",
      "type": "Tipologia",
      "details": "Dettagli / Scadenza",
      "download": "Download",
      "uploadedOn": "Caricato il",
      "expires": "Scade",
      "noDocs": "Nessun documento trovato."
    },
    "types": {
      "bustaPaga": "Busta Paga",
      "cu": "CU",
      "contratto": "Contratto",
      "visitaMedica": "Visita Medica",
      "certificatoCorso": "Certificato Corso",
      "altro": "Altro"
    }
  },



  "qrBadge": {
  "title": "Il Mio Badge QR",
  "loading": "Recupero dati...",
  "instructions": "Mostra questo codice allo scanner <br /> per timbrare la presenza",
  "notGenerated": "Badge non ancora generato",
  "contactAdmin": "Contatta l'amministrazione per attivare il tuo codice QR.",
  "download": "Scarica Immagine",
  "close": "Chiudi"
},

"qrAdmin": {
  "title": "Badge Aziendale",
  "sync": "Sincronizzazione...",
  "notFound": "Badge non trovato",
  "download": "Scarica Badge",
  "regenerate": "Rigenera Badge",
  "generateNow": "Genera Ora",
  "confirmNew": "Vuoi generare un nuovo Badge QR?",
  "confirmOverwrite": "Vuoi sovrascrivere il badge esistente?",
  "success": "Badge aggiornato con successo!",
  "securityError": "Errore (Security Policy): Assicurati che il tuo account abbia i permessi di UPDATE nello storage."
},

"attendance": {
  "filterTitle": "Registro Presenze",
  "month": "Mese",
  "year": "Anno",
  "btnLoad": "Carica Presenze",
  "loading": "Caricamento...",
  "history": "STORICO PRESENZE",
  "noData": "Nessun dato trovato per il periodo selezionato.",
  "stats": {
    "ord": "Totale Ordinari",
    "stra": "Totale Straordinari",
    "total": "Somma Totale"
  },
  "table": {
    "date": "Data",
    "entry": "Entrata",
    "exit": "Uscita",
    "ord_short": "Ordinari (8h)",
    "stra_short": "Straordinari",
    "total": "Totale"
  }
},
"company_modal": {
    "header_subtitle": "DETTAGLI AZIENDALI",
    "address_label": "INDIRIZZO",
    "registered_label": "REGISTRATO IL"
  },
 

  "companies": {
    "title": "Lista Aziende",
    "total": "Totale",
    "search_placeholder": "Cerca aziende...",
    "col_name": "Azienda",
    "col_actions": "Dettagli",
    "no_data": "Nessuna azienda trovata."
  },
  "company_modal": {
    "header_subtitle": "DETTAGLI AZIENDALI",
    "address_label": "INDIRIZZO",
    "registered_label": "REGISTRATO IL"
  },
 
 

  "orizon_desk": {
    "back": "Torna al portale",
    "hero_title_1": "Cos'è il portale",
    "hero_title_2": "OrizonDesk?",
    "hero_title_3": "",
    "hero_subtitle": "Rivoluzione digitale nella gestione delle risorse umane",
    "main_desc_title": "Addio carta, benvenuto Cloud",
    "main_desc_text": "Il Portale OrizonDesk è una piattaforma digitale centralizzata progettata per trasformare il modo in cui le aziende comunicano con i propri dipendenti. Il nostro obiettivo è chiaro: eliminazione totale della documentazione cartacea e passaggio a un ambiente digitale sicuro, veloce e trasparente.",
    "for_companies": "Per le aziende",
    "for_companies_desc": "Automazione dei processi HR, sicurezza dei dati e risparmio di tempo.",
    "for_workers": "Per i lavoratori",
    "for_workers_desc": "Accesso immediato ai documenti personali e ai registri di lavoro tramite cellulare.",
    "feature_1_title": "Archivio Digitale",
    "feature_1_li1": "Buste paga",
    "feature_1_li2": "Certificati e formazione",
    "feature_1_li3": "Contratti di lavoro",
    "feature_1_li4": "Avvisi HR",
    "feature_2_title": "Rilevazione Presenze",
    "feature_2_desc": "Sistema di timbratura tramite codice QR. I lavoratori utilizzano il dispositivo mobile per l'entrata e l'uscita dal lavoro.",
    "feature_2_li1": "Calcolo automatico delle ore",
    "feature_2_li2": "Lavoro straordinario",
    "feature_2_li3": "Visualizzazione ore per i dipendenti",
    "cta_title": "Inizia la digitalizzazione oggi",
    "cta_subtitle": "La procedura è semplice e veloce",
    "step_1_title": "Contattaci",
    "step_1_desc": "Scegli il pacchetto in base al numero di dipendenti e alla memoria Cloud necessaria.",
    "step_2_title": "Attivazione azienda",
    "step_2_desc": "Ricevi le credenziali amministrative e crei i profili dei tuoi dipendenti.",
    "step_3_title": "I lavoratori sono pronti",
    "step_3_desc": "I dipendenti ricevono un'e-mail di conferma, accedono e vedono subito documenti e ore.",
    "footer_contact_text": "Contatta il nostro team per un preventivo",
    "footer_rights": "Tutti i diritti riservati."
  },

  "common": {
   
    "not_available": "Non disponibile",
    
    "nd": "N/D",
    "read": "LETTO",
  "unread": "NON LETTO",
   "close": "CHIUDI",
    "not_available": "Indirizzo non disponibile",
    "loading": "Caricamento...",
    "all": "Tutti",
    "actions": "Azioni",
    "annual": "Annuale",
    "edit": "Modifica",
    "save": "Salva",
    "saving": "Salvataggio...",
    "cancel": "Annulla",
    "close": "Chiudi",
    "delete": "Elimina",
    "preview": "Anteprima",
    "download": "Scarica",
    "downloading": "Scaricamento...",
    "load_more": "Carica altri",
    "nd": "N/D",
    "read": "LETTO",
    "unread": "NON LETTO",
    "yes": "Sì",
    "no": "No"
  },
  "employee": {
    "back_to_list": "Torna alla Lista Dipendenti",
    "generate_qr": "Genera Badge QR",
    "info_title": "Informazioni Dipendente",
    "not_active": "Non Attivo"
  },
  "docs": {
    "new_upload": "Nuovo Upload",
    "type": "Tipologia",
     "refid": "N. Riferimento / ID",
    "refid_placeholder": "Es. CON-2026-001 o N. Transazione",
    "course_name": "Nome del Corso",
    "course_placeholder": "Es: Sicurezza sul Lavoro",
    "valid_from": "Dal",
    "valid_to": "Al",
    "notes": "Note",
    "notes_placeholder": "Specifica di cosa si tratta...",
    "no_notes": "Nessuna nota aggiunta.",
    "year": "Anno",
    "month": "Mese",
    "select_pdf_img": "Seleziona PDF o Immagine",
    "upload_btn": "Carica Documento",
    "uploading": "Caricamento in corso...",
    "filter_archive": "Filtra Archivio",
    "search_placeholder": "Cerca per nome, tipo, N. riferimento...",
    "list_title": "Elenco Documenti Caricati",
    "col_name": "Nome Documento",
    "col_type": "Tipologia",
    "col_ref": "Riferimento ID",
    "col_period": "Periodo",
    "col_date": "Data Caricamento",
    "expires": "Scade",
    "no_docs_found": "Nessun documento trovato per i criteri selezionati.",
    "select_file_alert": "Seleziona un file!",
    "missing_company": "Dato aziendale mancante.",
    "upload_success": "Documento caricato con successo!",
    "upload_error": "Errore durante il caricamento",
    "confirm_delete_title": "Conferma Eliminazione",
    "confirm_delete": "Sei sicuro di voler eliminare permanentemente questo documento? L'azione rimuoverà il file anche dallo storage.",
    "confirm_delete_category": "Vuoi eliminare questa categoria?",
    "category_exists": "Questa categoria esiste già!",
    "category_error": "Errore",
    "delete_success": "Documento eliminato con successo!",
    "delete_error": "Errore durante l'eliminazione",
    "download_error": "Impossibile scaricare il file.",
    "preview_error": "Errore durante il caricamento dell'anteprima.",
    "update_success": "Documento aggiornato con successo!",
    "update_error": "Errore durante l'aggiornamento",
    "edit_modal_title": "Modifica Documento",
    "info_modal_title": "Dettagli Documento",
    "edit_subtitle": "Modifica parametri",
    "info_subtitle": "Panoramica dati",

    "types2": {
      "contract": "Contratto",
      "course": "Certificato",
      "other": "Altro"
    },

    "types": {
      "payslip": "Busta Paga",
      "cu": "Certificazione Unica (CU)",
      "contract": "Contratto",
      "medical": "Visita Medica",
      "course": "Certificato Corso",
      "other": "Altro"
       
  },
    "course_name": "Nome del Corso",
    "course_placeholder": "Es: Sicurezza sul Lavoro",
    "valid_from": "Valido Dal",
    "valid_to": "Valido Al",
    "notes": "Note / Descrizione",
    "notes_placeholder": "Specifica di cosa si tratta...",
    "year": "Anno",
    "month": "Mese",
    "select_pdf_img": "Seleziona PDF o Immagine",
    "upload_btn": "Carica Documento",
    "uploading": "Caricamento in corso...",
    "filter_archive": "Filtra Archivio",
    "search_placeholder": "Cerca per nome, tipo, data...",
    "list_title": "Elenco Documenti Caricati",
    "col_name": "Nome Documento",
    "col_type": "Tipologia",
    "col_period": "Periodo/Validità",
    "col_date": "Data Caricamento",
    "expires": "Scade",
    "no_docs_found": "Nessun documento trovato per i criteri selezionati.",
    "select_file_alert": "Seleziona un file!",
    "upload_success": "Documento caricato con successo!",
    "upload_error": "Errore durante il caricamento",
    "confirm_delete": "Sicuro di voler eliminare questo documento?",
    "delete_error": "Errore durante l'eliminazione",
    "download_error": "Impossibile scaricare il file."

  },

  "company_docs": {
    "title": "Documenti Aziendali",
    "subtitle": "Gestione e archiviazione digitale dei documenti aziendali"
  },

  "categ": {
    "title2": "Nuova Categoria",
    "input_placeholder": "Nome categoria...",
    "custom_list": "Categorie personalizzate:",
    "add": "Aggiungi"
  },
  
  "employee_modal": {
    "title_info": "Informazioni Dipendente",
    "title_edit": "Modifica Dipendente",
    "first_name": "Nome",
    "last_name": "Cognome",
    "tax_code": "Codice Fiscale",
    "email": "Email",
    "phone": "Telefono",
    "created_at": "Data Creazione",
    "last_login": "Ultimo Accesso",
    "never": "Mai effettuato",
    "alert_success": "Dati aggiornati con successo!",
    "alert_error": "Errore durante l'aggiornamento"
  },

  "notifikacije": {
    "title_not": "DOCUMENTI DA LEGGERE",
    "empty": "TUTTO LETTO!",
    "view_all": "VAI AI MIEI DOCUMENTI"
  },
  
  "sidebar": {
    "dashboard": "Dashboard",
    "profile": "Profilo",
    "settings": "Impostazioni",
    "back_to_menu": "Menu",
    "my_holidays": "Le Mie Ferie",
    "version": "V2.4.0 OrizonDesk"
  },

  "adminHome": {
    "categories": {
      "dipendenti": {
        "title": "DIPENDENTI",
        "subtitle": "Presenze, Documenti & Turni",
        "description": "Gestione del personale, contratti di lavoro, documenti personali, presenze, turni e report delle timbrature."
      },
      "azienda": {
        "title": "AZIENDA",
        "subtitle": "Profilo & Documenti",
        "description": "Archivia e gestisci i documenti ufficiali societari, i contratti di locazione e la burocrazia interna."
      },
      "partner": {
        "title": "PARTNER",
        "subtitle": "Clienti & Fornitori",
        "description": "Anagrafica completa dei partner commerciali, contratti di fornitura, fatture e storico ordini."
      }
    },

    "partnerModal": {
      "title": "Partner Commerciali",
      "subtitle": "Seleziona un'opzione per proseguire",
      "newPartner": {
        "title": "NUOVO PARTNER",
        "desc": "Aggiungi un nuovo cliente o fornitore nel database con tutti i dettagli."
      },
      "allPartners": {
        "title": "TUTTI I PARTNER",
        "desc": "Visualizza e gestisci l'elenco completo dei partner e dei relativi documenti."
         }
      },
    "common": {
      "accessSection": "Accedi alla sezione"
    }
  },

"create_partner": {
  "back": "Indietro",
  "title": "Nuovo Partner Commerciale",
  "subtitle": "Aggiungi nuovo partner per l'azienda:",
  "success_msg": "Partner salvato con successo!",
  "manage_categories_btn": "Gestisci categorie",
  "select_placeholder": "-- Seleziona tipo / categoria --",
  "default_types_group": "Tipi predefiniti",
  "db_categories_group": "Categorie dal database",
  "submit_btn": "Salva Partner",
  "my_partners_btn": "I miei partner",

  "sections": {
    "basic": "1. Dati di Base",
    "location": "2. Contatto e Sede",
    "banking": "3. Banca e Referente"
  },

  "labels": {
    "naziv": "Nome Partner *",
    "tip": "Tipo / Categoria Partner",
    "pib_jib": "Codice Fiscale",
    "pdv": "Partita IVA",
    "broj_registracije": "Numero Registro Imprese",
    "adresa": "Indirizzo",
    "postanski_broj": "Codice Postale",
    "grad": "Città",
    "drzava": "Paese",
    "email": "Email",
    "telefon": "Telefono",
    "web": "Sito Web",
    "naziv_banke": "Nome della Banca",
    "bankovni_racun": "Conto Bancario (IBAN)",
    "kontakt_osoba": "Persona di Contatto",
    "kontakt_telefon": "Telefono Persona di Contatto",
    "napomena": "Note"
  },

  "types": {
    "dobavljac": "Fornitore",
    "klijent": "Cliente",
    "obostrano": "Cliente / Fornitore"
  },

  "placeholders": {
  "naziv": "Es. ACME S.r.l.",
  "pib_jib": "Es. 12345678901",
  "pdv": "Es. IT12345678901",
  "napomena": "Inserisci note aggiuntive sul partner..."
},


  "errors": {
    "no_company": "Azienda non trovata",
    "name_req": "Il nome del partner è obbligatorio"
  },

  "category_modal": {
    "title": "Gestione Categorie",
    "existing_list": "Categorie esistenti",
    "no_categories": "Nessuna categoria creata.",
    "delete": "Elimina categoria",
    "add_new": "Aggiungi nuova categoria",
    "name_label": "Nome categoria *",
    "name_placeholder": "Es. Subappaltatore",
    "desc_label": "Descrizione categoria",
    "desc_placeholder": "Descrizione opzionale della categoria...",
    "save_btn": "Salva categoria",
    "close": "Chiudi",
    "duplicate_error": "Esiste già una categoria con questo nome.",
    "save_error": "Errore durante la creazione della categoria",
    "delete_error": "Errore durante l'eliminazione della categoria",
    "confirm_delete": "Sei sicuro di voler eliminare questa categoria?"
  }
},


 "listapartner": {
    "back": "Indietro",
    "title": "Partner Commerciali",
    "subtitle": "Gestisci i clienti e i fornitori della tua azienda",
    "new_partner": "Nuovo Partner",
    "filter_archive": "Cerca Partner",
    "search_placeholder": "Cerca per nome, P.IVA/CF, città, email...",
    "type": "Tipo Partner",
    "list_title": "Elenco Partner",
    "no_partners_found": "Nessun partner trovato per i criteri selezionati.",
    "col_name": "Nome Partner",
    "col_piva": "P.IVA / CF",
    "col_type": "Tipo",
    "col_location": "Città / Indirizzo",
    "col_contact": "Contatto",
    "col_date": "Data di Creazione",
    "view_documents": "Documenti Partner",
    "select_placeholder": "-- Seleziona --",
    "pdv": "Numero Partita IVA",
    "broj_registracije": "Numero di Registrazione",
    "adresa": "Indirizzo",
    "postanski_broj": "Codice Postale",
    "grad": "Città",
    "drzava": "Paese",
    "email": "Email",
    "telefon": "Telefono",
    "web": "Sito Web",
    "naziv_banke": "Nome della Banca",
    "bankovni_racun": "Conto Bancario (IBAN)",
    "kontakt_osoba": "Persona di Contatto",
    "kontakt_telefon": "Telefono Persona di Contatto",
    "napomena": "Nota",
    "no_notes": "Nessuna nota aggiunta.",
    "update_success": "Partner aggiornato con successo!",
    "update_error": "Errore durante l'aggiornamento del partner",
    "delete_error": "Errore durante l'eliminazione del partner",
    "edit_modal_title": "Modifica Partner",
    "info_modal_title": "Dettagli Partner",
    "edit_subtitle": "Modifica dei dati",
    "info_subtitle": "Panoramica dati",
    "confirm_delete_title": "Conferma Eliminazione",
    "confirm_delete": "Sei sicuro di voler eliminare permanentemente questo partner?",
    "confirm_delete_docs_warning": "ATTENZIONE: Questa azione eliminerà permanentemente anche tutti i {{count}} documenti di questo partner (dal database e dal server). Questa operazione NON PUÒ essere annullata.",
    "confirm_delete_no_docs_warning": "ATTENZIONE: Questa operazione NON PUÒ essere annullata.",
    "errors": {
      "name_req": "Il nome del partner è obbligatorio"
    },
    "types": {
      "dobavljac": "Fornitore",
      "klijent": "Cliente",
      "obostrano": "Cliente / Fornitore"
    }
  },


   "dettagli_partner": {
    "back": "Indietro",
    "gestione_documenti": "Gestione Documenti per",
    "subtitle": "Gestione e archiviazione digitale dei documenti del partner",
    "new_upload": "Nuovo Upload",
    "filter_archive": "Filtra Archivio",
    "search_placeholder": "Cerca per nome, tipo, N. riferimento...",
    "year": "Anno",
    "month": "Mese",
    "type": "Tipologia",
    "list_title": "Elenco Documenti Caricati",
    "no_docs_found": "Nessun documento trovato per i criteri selezionati.",
    "col_name": "Nome Documento",
    "col_ref": "Riferimento ID",
    "col_type": "Tipologia",
    "col_period": "Periodo / Validità",
    "col_date": "Data Caricamento",
    "valid_from": "Valido Dal",
    "valid_to": "Valido Al",
    "refid": "N. Riferimento / ID",
    "refid_placeholder": "Es. FATT-2026-001",
    "notes": "Note / Descrizione",
    "notes_placeholder": "Specifica di cosa si tratta...",
    "no_notes": "Nessuna nota aggiunta.",
    "select_pdf_img": "Seleziona PDF o Immagine",
    "select_file_alert": "Seleziona un file!",
    "uploading": "Caricamento in corso...",
    "upload_btn": "Carica Documento",
    "upload_success": "Documento caricato con successo!",
    "upload_error": "Errore durante il caricamento",
    "download_error": "Impossibile scaricare il file.",
    "preview_error": "Errore durante il caricamento dell'anteprima.",
    "update_success": "Documento aggiornato con successo!",
    "update_error": "Errore durante l'aggiornamento",
    "delete_error": "Errore durante l'eliminazione",
    "missing_company": "Dato aziendale mancante.",
    "missing_partner": "Partner non trovato.",
    "edit_modal_title": "Modifica Documento",
    "info_modal_title": "Dettagli Documento",
    "edit_subtitle": "Modifica parametri",
    "info_subtitle": "Panoramica dati",
    "confirm_delete_title": "Conferma Eliminazione",
    "confirm_delete": "Sei sicuro di voler eliminare permanentemente questo documento? L'azione rimuoverà il file anche dallo storage.",
    "categ_title2": "Nuova Categoria",
    "categ_input_placeholder": "Nome categoria...",
    "categ_custom_list": "Categorie personalizzate:",
    "categ_add": "Aggiungi",
    "category_exists": "Questa categoria esiste già!",
    "category_error": "Errore",
    "confirm_delete_category": "Vuoi eliminare questa categoria?",
    "types": {
      "contract": "Contratto",
      "invoice": "Fattura",
      "other": "Altro"
    }
  },

"deactivate_modal": {
  "title": "Disattivazione Dipendente",
  "subtitle": "Stai per disattivare l'accesso all'utente:",
  "reason_label": "Motivo della disattivazione (obbligatorio)",
  "placeholder": "Es. Fine rapporto di lavoro, provvedimento disciplinare...",
  "warning_login": "L'utente non potrà più accedere al sistema.",
  "warning_data": "Tutti i dati e i documenti rimarranno salvati nell'archivio.",
  "confirm_btn": "Conferma Disattivazione",
  "cancel_btn": "Annulla",
  "error": "Errore durante la disattivazione",
  "success_deactivate": "Dipendente disattivato con successo"
},

"activate_modal": {
  "title": "Attivazione Dipendente",
  "subtitle": "Stai riattivando l'accesso per:",
  "reason_label": "Nota di attivazione (opzionale)",
  "placeholder": "Es. Rientro da malattia, nuovo contratto...",
  "warning_login": "L'utente avrà accesso immediato al sistema.",
  "confirm_btn": "Attiva",
  "cancel_btn": "Annulla",
  "success_activate": "Il dipendente è di nuovo attivo!",
  "history_title": "Cronologia Disattivazione",
  "deactivated_on": "Disattivato il:",
  "previous_reason": "Motivo precedente:",
  "no_history": "Nessun dato di disattivazione precedente"
},

"not_active_page": {
  "title": "Account Sospeso",
  "message": "Il tuo accesso al sistema è stato temporaneamente disattivato dall'amministrazione.",
  "contact": "Se ritieni che si tratti di un errore, contatta il tuo responsabile.",
  "back_home": "Torna alla Home"
},

"pricing": {
  "monthly": "Mensile",
  "annual": "Annuale",
  "save_discount": "Risparmia il 20%",
  "month": "mese",
  "year": "anno",
  "popular": "Più Popolare",
  "choose_plan": "Scegli il piano",
  "what_you_get": "Cosa include il piano:",
  "confirm": "Conferma e continua",
  "close": "Chiudi",
  "basic_features": [
    "Fino a 10 dipendenti",
    "Archivio HR (Buste paga, contratti, corsi)",
    "Sistema di presenze con QR dinamico",
    "Modulo per Clienti e Fornitori",
    "Notifiche per scadenza documenti"
  ],
  "premium_features": [
    "Fino a 50 dipendenti",
    "Tutto ciò che include il piano Basic",
    "Sistema Audit Log (Tracciamento download)",
    "Gestione per più sedi o reparti",
    "Supporto prioritario"
  ],
  "enterprise_features": [
    "Dipendenti illimitati",
    "Tutto ciò che include il piano Premium",
    "Accesso API personalizzato e integrazioni",
    "Account manager dedicato",
    "Onboarding e configurazione in sede"
  ],
  "descriptions": {
    "Basic": "Ideale per piccole imprese e artigiani. Include l'archivio HR completo, un sistema avanzato di QR dinamico per la registrazione delle ore e il modulo per clienti e fornitori.",
    "Premium": "Perfetto per aziende in rapida crescita. Include un Audit Log avanzato per tracciare gli accessi ai documenti e il supporto per più sedi separate.",
    "Enterprise": "Soluzione completa su misura per grandi strutture con dipendenti illimitati, account manager dedicato e integrazioni API dirette."
  },
  "badge_text": "Prova gratuita",
  "free_trial_btn": "Inizia la prova gratuita di 30 giorni",
  "free_trial_subtitle": "Nessuna carta di credito richiesta. Configurazione in soli 2 minuti.",
  "start_test_btn": "Inizia il test"
},

"test_page": {
  "back": "Torna alle offerte",
  "title": "Test Gratuito",
  "subtitle": "Prova OrizonDesk per 30 giorni senza alcun costo",
  "success_title": "Richiesta inviata con successo!",
  "success_desc": "Grazie per il tuo interesse. Abbiamo inviato un’email con il link per l’attivazione dell’account. Ti preghiamo di controllare la posta in arrivo.",
  "basic_info": "Fino a 10 dipendenti • 5GB cloud • Tutti i moduli inclusi",
  "gratis": "30 Giorni Gratis",
  "label_name": "Nome",
  "label_surname": "Cognome",
  "label_company": "Nome dell’azienda",
  "label_email": "Email aziendale",
  "label_phone": "Numero di telefono",
  "label_note": "Nota aggiuntiva (Opzionale)",
  "placeholder_name": "Es. Marco",
  "placeholder_surname": "Es. Rossi",
  "placeholder_company": "Es. Orizon AIX S.r.l.",
  "placeholder_email": "nome@azienda.it",
  "placeholder_phone": "+39 320 000 0000",
  "placeholder_note": "Hai requisiti specifici?",
  "terms_part1": "Accetto i",
  "terms_link": "termini di utilizzo",
  "terms_part2": "e il trattamento dei dati.",
  "btn_send": "Attiva prova gratuita",
  "footer_note": "OrizonDesk si riserva il diritto di verificare i dati prima di approvare il periodo di prova.",
  "brand_subtitle": "OrizonDesk Sistemi Digitali",
  "error_email_exists": "Questo indirizzo email è già associato a un account esistente."
},

"common1": {
    "back": "Indietro"
  },
  "status": {
    "section_title": "Stato Risorse e Abbonamento",
    "section_subtitle": "Panoramica del consumo attuale e dei limiti del sistema.",
    "employees_label": "Dipendenti",
    "storage_label": "Memoria Cloud",
    "expires_in": "Tempo residuo licenza",
    "upgrade_btn": "AGGIORNA PIANO",
    "current_plan": "Piano Attuale",
    "days_suffix": "Giorni",
    "history_btn": "Cronologia Pagamenti",
    "trash_btn": "Pulisci spazio",
  

    
  },

  "upgrade": {
    "modal_title": "Gestione Piano",
    "current_status": "Piano attuale",
    "current_expires": "Scade il",
    "current_workers": "Dipendenti attivi",
    "current_storage": "Spazio utilizzato",
    "tab_upgrade": "Upgrade",
    "tab_renew": "Rinnovo",
    "tab_custom": "Offerta Custom",
    "recommended": "Consigliato",
    "recommended_renewal": "Rinnova stesso piano",
    "plan_basic_title": "Pacchetto Basic",
    "plan_basic_price": "75 € / anno",
    "plan_basic_workers": "10 dipendenti",
    "plan_basic_storage": "5GB Cloud",
    "plan_basic_feat1": "QR Code Badge",
    "plan_basic_feat2": "Supporto email",
    "plan_premium_title": "Pacchetto Premium",
    "plan_premium_price": "230 € / anno",
    "plan_premium_workers": "50 dipendenti",
    "plan_premium_storage": "15GB Cloud",
    "plan_premium_feat1": "Sistema Audit Log",
    "plan_premium_feat2": "Supporto prioritario",
    "plan_enterprise_title": "Pacchetto Enterprise",
    "plan_enterprise_price": "615 € / anno",
    "plan_enterprise_workers": "Illimitati",
    "plan_enterprise_storage": "100GB Cloud",
    "plan_enterprise_feat1": "Accesso API custom",
    "plan_enterprise_feat2": "Manager dedicato",
    "pay_now": "Paga ora",
    "select_plan": "Scegli questo piano",
    "current_plan_badge": "Piano attuale",
    "downgrade_badge": "Downgrade",
    "upgrade_badge": "Upgrade",
    "review_title": "Riepilogo cambio piano",
    "review_from": "Piano attuale",
    "review_to": "Nuovo piano",
    "review_workers": "Dipendenti",
    "review_storage": "Cloud storage",
    "review_price": "Prezzo",
    "review_period": "Durata",
    "review_period_val": "365 giorni",
    "review_proceed": "Procedi al pagamento",
    "review_back": "← Torna alla selezione",
    "downgrade_error_title": "Downgrade non possibile",
    "downgrade_error_workers": "Hai attualmente {current} dipendenti registrati. Il piano {plan} accetta max {max} dipendenti. Elimina i dipendenti dall'azienda prima di procedere.",
    "downgrade_error_storage": "Stai usando {current}GB di spazio. Il piano {plan} offre max {max}GB. Libera spazio eliminando documenti (incluso dal cestino) prima di procedere.",
    "downgrade_error_both": "Hai troppi dipendenti ({workers}) e troppo spazio occupato ({storage}GB) per il piano selezionato.",
    "divider_text": "oppure personalizza manualmente",
    "custom_title": "Configurazione Custom",
    "custom_subtitle": "Seleziona i parametri e il nostro team ti invierà un'offerta",
    "cloud_storage": "Spazio Cloud",
    "employee_count": "Numero dipendenti",
    "license_duration": "Durata Licenza",
    "unlimited": "ILLIMITATI",
    "year_one": "ANNO",
    "year_multi": "ANNI",
    "send_request": "INVIA RICHIESTA DI OFFERTA",
    "success_title": "Richiesta inviata!",
    "success_thanks": "Grazie per la fiducia.",
    "success_desc_1": "Il nostro team analizzerà la tua configurazione e ti contatterà nel",
    "success_desc_2": "più breve tempo possibile",
    "success_desc_3": "per finalizzare l'offerta.",
    "renewal_success_title": "Pagamento in elaborazione",
    "renewal_success_desc": "Il tuo piano verrà aggiornato non appena il pagamento sarà confermato. Una email di conferma arriverà al tuo indirizzo.",
    "feat_audit": "Sistema Audit Log",
    "feat_support": "Supporto prioritario",
    "feat_api": "Accesso API custom",
    "feat_manager": "Manager dedicato",
    "select_btn": "SELEZIONA",
    "premium_title": "Pacchetto Premium",
    "premium_price": "230 € / anno",
    "premium_subtitle": "Fino a 50 dipendenti e funzioni avanzate",
    "enterprise_title": "Pacchetto Enterprise",
    "enterprise_price": "615 € / anno",
    "enterprise_subtitle": "Dipendenti illimitati e accesso API",
    "loading_check": "Verifica dati in corso ...",
    "error_fetch": "Errore nel caricamento dati. Riprova.",
    "checkout_error": "Errore nell'apertura del pagamento. Riprova.",
    "plan_basic_price_eur":     "75 €",
"plan_premium_price_eur":   "230 €",
"plan_enterprise_price_eur":"615 € ",
"billing_annual": "Annuale",
  "billing_monthly": "Mensile",
  "review_period_annual": "365 giorni",
  "review_period_monthly": "30 giorni",
   "receipt_cycle": "Ciclo di fatturazione",
   "plan_basic_price_km_monthly":      "15.99 KM",
  "plan_premium_price_km_monthly":    "44.99 KM",
  "plan_enterprise_price_km_monthly": "119.99 KM",
  "plan_basic_price_eur_monthly":     "7.99 €",
  "plan_premium_price_eur_monthly":   "44.99 €",
  "plan_enterprise_price_eur_monthly":"119.99 €",



 
  },
  "renewal_success": {
    "loading": "Elaborazione pagamento ...",
    "title": "Piano Aggiornato!",
    "subtitle": "Il tuo piano è stato aggiornato con",
    "subtitle2": "successo. Conferma inviata via email.",
    "badge_renewed": "Piano rinnovato",
    "badge_upgraded": "Piano aggiornato",
    "badge_downgraded": "Piano ridotto",
     "receipt_cycle": "Ciclo di fatturazione",
    "receipt_title": "Conferma Modifica",
    "receipt_payment_id": "Payment ID",
    "receipt_plan": "Piano",
    "receipt_valid": "Valido fino al",
    "receipt_status": "Stato",
    "receipt_status_val": "Attivo",
    "btn_home": "Vai alla Dashboard",
    "error_title": "Errore aggiornamento",
    "error_subtitle": "Pagamento riuscito ma piano non aggiornato. Contatta il supporto.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Errore",
    "error_contact": "Contattaci a",
    "error_status_failed": "Pagamento non riuscito. Stato:"
  },

"invite_setup": {
  "title": "Sei stato invitato!",
  "desc": "Completa la configurazione del tuo account impostando una password",
  "new_password": "Crea Password",
  "confirm_password": "Conferma Password",
  "button": "Attiva il mio account",
  "success": "Account attivato con successo! Benvenuto nel team.",
  "error_match": "Le password non corrispondono",
  "error_too_short": "La password deve contenere almeno {{min}} caratteri",
  "passwords_match": "Le password coincidono",
  "error_session_title": "Link non valido o scaduto",
  "error_session_expired": "Questo link di invito non è più valido o è già stato utilizzato. Chiedi al tuo amministratore di inviarti un nuovo invito.",
  "back_to_login": "Torna al Login"
},

"company_inactive": {
  "title": "Azienda non attiva",
  "desc": "L'accesso a OrizonDesk per questa azienda è stato sospeso. Ciò accade solitamente quando il periodo di prova è terminato o l'abbonamento è scaduto.",
  "contact_support": "Contatta l'assistenza",
  "renew_btn": "Rinnova Abbonamento",
  "renew_hint": "Solo gli amministratori possono rinnovare l'abbonamento"
},

"userLog": {
  "noPermission": "Non hai il permesso di accedere ai log di controllo.",
  "back": "Indietro",
  "loadMore": "Carica altri",
  "title": "Registro Attività Audit",
  "subtitle": "Monitoraggio delle attività degli utenti, download di documenti e modifiche di sistema",
  "table": {
    "time": "Orario Azione",
    "user": "Utente (Esecutore)",
    "action": "Azione / Tipo",
    "document": "Documento / File",
    "device": "Dispositivo",
    "noActivity": "Nessuna attività registrata",
    "system": "Sistema"
  },
  "footer": {
    "gdprNote": "Questo log è immutabile e funge da prova ufficiale di accesso ai documenti sensibili in conformità con le normative GDPR.",
    "policy": "Policy Audit",
    "status": "Monitoraggio Attivo"
  }
},


  "payments": {
    "no_permission": "Non hai il permesso di accedere alla cronologia dei pagamenti.",
    "back": "Indietro",
    "title": "Cronologia Pagamenti e Licenze",
    "subtitle": "Panoramica delle transazioni, licenze attive e dati amministrativi",
    "table": {
      "period": "Periodo di Validità",
      "admin_email": "Admin / Email",
      "package_id": "Pacchetto e ID",
      "amount": "Importo",
      "status_pdf": "Stato / PDF",
      "from": "Pagato:",
      "to": "Scade:",
      "paid_by": "Pagato da",
      "online": "Online",
      "no_transactions": "Nessuna transazione registrata"
    },
    "footer": {
      "note": "Tutte le licenze vengono attivate automaticamente subito dopo la conferma del pagamento. Per fatture o domande aggiuntive, contatta l'assistenza con l'ID della transazione.",
      "system_status": "Stato del sistema",
      "verified": "Verified & Secured"
    }
  },

  
  "legal": {
    "back": "Indietro",
    "title_part1": "Legal &",
    "title_part2": "Compliance",
    "header_subtitle": "Orizon Desk Portal • Infrastruttura & Privacy • v1.2.5 • 2026",
    "stats": {
      "residency": "Data Residency",
      "storage": "Storage Infrastructure",
      "encryption": "Encryption Standard",
      "gdpr": "GDPR Compliance",
      "db": "Database Engine",
      "security": "Security Protocol",
      "monitoring": "Monitoring",
      "identity": "Identity"
    },
    "stats_vals": {
      "residency": "Zurigo (CH) West",
      "gdpr": "Full EU Standards"
    },

    "section01": {
      "title": "Termini e Condizioni",
      "subtitle": "Accordo SaaS e Garanzie di Integrità Militare",
      "p1_part1": "Orizon Desk è un ecosistema digitale chiuso, regolato da rigidi protocolli di sicurezza. L'accesso è limitato esclusivamente al personale autorizzato e ogni interazione è protetta da un'architettura",
      "p2_part1": "Al fine di garantire la massima protezione, il sistema monitora costantemente i punti di accesso:",
      "p2_bold": "ogni sessione viene associata all'indirizzo IP dell'utente",
      "p2_part2": "per prevenire intrusioni esterne, attacchi brute-force o l'utilizzo non autorizzato delle credenziali da postazioni non riconosciute.",
      "p3": "Orizon AIX si impegna a mantenere la disponibilità del servizio al 99.9%. I dati contenuti nel portale sono trattati con il massimo livello di riservatezza industriale.",
      "integrity_title": "Integrità del Sistema",
      "integrity_bold": "Utilizziamo protocolli di sicurezza militari",
      "integrity_desc": "per prevenire furti di identità o perdite di dati. L'integrità è garantita da algoritmi di checksum che verificano costantemente che nessun file caricato sia stato alterato, neppure accidentalmente.",
      "feature1_title": "Bcrypt Password Hashing",
      "feature1_desc": "Le password non vengono mai salvate in chiaro, rendendo impossibile la decriptazione anche in caso di accesso al database.",
      "feature2_title": "SSL/TLS 1.3",
      "feature2_desc": "Ogni bit di informazione che viaggia tra il tuo browser e i nostri server a Zurigo è protetto dal protocollo di crittografia più avanzato disponibile oggi.",
      "user_resp_title": "Responsabilità Utente",
      "user_resp_desc": "L'utente è custode delle proprie credenziali. Orizon Desk implementa il blocco automatico dell'account dopo 5 tentativi falliti di accesso e il tracciamento dell'indirizzo IP per rilevare attacchi brute-force.",
      "monitor_title": "Monitoraggio Real-Time",
      "monitor_desc": "Il nostro Threat Detection System analizza costantemente il traffico per identificare pattern sospetti. Ogni documento scaricato genera un timestamp crittografico univoco."
    },
    "section02": {
      "title": "Informativa Privacy",
      "subtitle": "Conformità al Regolamento UE 2016/679 e Standard Internazionali",
      "gdpr_text1": "Ai sensi dell'Art. 13 del GDPR, informiamo che il trattamento dei dati personali è finalizzato esclusivamente alla gestione del rapporto di lavoro e alla digitalizzazione della documentazione aziendale. Non vendiamo, né scambiamo i tuoi dati con terze parti per scopi commerciali.",
      "gdpr_text2": "I dati trattati includono: Identificativi personali, dati contrattuali, coordinate bancarie (se presenti in busta paga) e registri di accesso al sistema. Il trattamento è necessario per l'adempimento degli obblighi legali e contrattuali.",
      "cards": {
        "purpose_t": "Finalità",
        "purpose_d": "Digitalizzazione HR, archiviazione sostitutiva di buste paga e certificazioni uniche.",
        "retention_t": "Conservazione",
        "retention_d": "I dati sono conservati per 10 anni secondo la normativa fiscale europea.",
        "security_t": "Sicurezza",
        "security_d": "Accesso granulare basato su ruoli (RBAC). Un amministratore può visuallizzare esclusivamente le risorse a lui assegnate."
      },
      "audit": {
        "header": "Tracciabilità Totale: Cos'è il Log Audit?",
        "p1_part1": "Ogni singola azione compiuta all'interno del portale Orizon Desk viene registrata in un",
        "p1_part2": "immutabile. Questo significa che il sistema crea una \"scatola nera\" digitale che memorizza: chi ha effettuato l'accesso, da quale indirizzo IP, a che ora e quale documento ha visualizzato o scaricato.",
        "p2_part1": "Questa funzione è fondamentale per la vostra sicurezza: garantisce la",
        "p2_bold": "non-ripudiabilità",
        "p2_part2": "delle azioni e permette di verificare in qualsiasi momento che i documenti sensibili (come le buste paga) siano stati consultati esclusivamente dal legittimo proprietario o dal personale HR autorizzato, eliminando ogni rischio di accesso occulto.",
        "tag1": "Timestamp Immutabile",
        "tag2": "IP Tracking Protection",
        "tag3": "Data Access Transparency"
      },
      "cookies": {
        "title": "Informativa sui Cookie",
        "desc": "Orizon Desk Portal utilizza esclusivamente \"Cookie Tecnici\" necessari per il funzionamento della sessione e la sicurezza dell'autenticazione. Non utilizziamo cookie di profilazione o tracker pubblicitari di terze parti (come Facebook Pixel o Google Analytics) per garantirti la massima privacy."
      }
    },
    "section03": {
      "title": "Infrastruttura & Cloud",
      "subtitle": "Residenza Dati Zurigo (Svizzera) e Tecnologia AWS S3",
      "aws_title": "Archiviazione Cloud AWS S3",
      "aws_desc_part1": "Ogni file caricato viene ospitato su",
      "aws_desc_part2": "I dati non risiedono su un server fisico vulnerabile, ma in un'infrastruttura distribuita progettata per una durabilità dell'99,99%. Ogni file è criptato singolarmente a riposo (At-Rest Encryption).",
      "swiss_title": "Perchè la Svizzera (Zurigo)?",
      "swiss_bold": "Zurigo (Region: eu-central-2)",
      "swiss_desc_part1": "I nostri server sono situati nel polo tecnologico di",
      "swiss_desc_part2": ". La Svizzera offre una stabilità politica e legale unica, con leggi sulla protezione dei dati che estendono ulteriormente le tutele del GDPR, garantendo che i documenti aziendali siano protetti da interferenze esterne o sequestri arbitrari.",
      "backup_title": "Continuità Operativa & Backup",
      "backup_desc_part1": "Utilizziamo un sistema di",
      "backup_desc_part2": "che permette di ripristinare lo stato dei dati a qualsiasi istante passato, garantendo protezione contro errori umani o guasti tecnici. Tutti i documenti sono archiviati con ridondanza geografica e i backup vengono criptati con chiavi",
      "backup_desc_part3": "gestite tramite AWS KMS.",
      "rls_title": "Segregazione Dati RLS",
      "rls_desc_part1": "Il database PostgreSQL utilizza la tecnologia",
      "rls_desc_part2": "Questo assicura che a livello di codice sia fisicamente impossibile per un utente di un'azienda visualizzare record appartenenti a un'altra, anche in caso di bug applicativo.",
      "cert_header": "Cloud Certifications",
      "cert_iso": "Standard internazionali per la gestione della sicurezza delle informazioni in cloud.",
      "cert_soc": "Certificazione dei controlli interni su sicurezza, disponibilità e riservatezza.",
      "cert_gdpr": "Conformità UE per il trasferimento e il trattamento dei dati personali sensibili.",
      "cert_csa": "Livello massimo di sicurezza specifica per fornitori di servizi Cloud (SaaS).",
      "cert_dr": "Backup giornalieri geo-replicati per garantire la continuità operativa in ogni scenario.",
      "quote": "La nostra infrastruttura non è solo conforme, è leader globale nella protezione dei dati HR.",
      "click_hint": "Clicca sui badge in alto per verificare le certificazioni ufficiali dei provider."
    },
    "section04": {
  "title": "I Tuoi Diritti",
  "subtitle": "Esercizio dei poteri legislativi garantiti dal GDPR",
  "rights": {
    "access_t": "Diritto di Accesso",
    "access_d": "Puoi richiedere conferma del trattamento dei tuoi dati e ottenerne una copia digitale completa.",
    "forget_t": "Diritto all'Oblio",
    "forget_d": "Richiesta di cancellazione permanente dei propri dati personali al cessare delle finalità legali.",
    "port_t": "Portabilità",
    "port_d": "Ricevere i documenti in formato strutturato (PDF) per trasferirli ad altro titolare.",
    "limit_t": "Limitazione",
    "limit_d": "Richiedere di limitare il trattamento in caso di contestazione dell'esattezza dei dati."
  },
  "exercise_text": "Per esercitare uno dei suddetti diritti o per segnalare una violazione della privacy (Data Breach), l'interessato può rivolgersi direttamente al Titolare del Trattamento all'indirizzo email dedicato. Le richieste vengono elaborate entro un termine massimo di 30 giorni."
},
"footer": {
  "contact_label": "Contatti per quesiti legali",
  "locations": "Orizon AIX • Brescia, Italia • Zurigo, CH",
  "update_tag": "Aggiornato a MARZO 2026",
  "disclaimer": "Questa documentazione è soggetta a revisione annuale. L'utilizzo continuativo della piattaforma implica l'accettazione automatica di tutti i termini. Ogni modifica sostanziale verrà notificata tramite alert interno.",
  "secured_switzerland": "Orgogliosamente protetto in Svizzera."
},
"section05": {
  "title": "Sicurezza Pagamenti",
  "subtitle": "Protezione delle transazioni e politica di zero-storage",
  "points": {
    "stripe_t": "Zero-Storage Policy",
    "stripe_d": "Orizon DESK non memorizza né ha accesso ai dati della tua carta. Tutti i processi sono isolati.",
    "pci_t": "Standard PCI-DSS",
    "pci_d": "Le transazioni vengono eseguite tramite Dodo Payments, in conformità con i più alti standard bancari.",
    "crypto_t": "Criptografia SSL",
    "crypto_d": "Tutte le comunicazioni sono protette da crittografia a 256 bit e protocolli di sicurezza PKI.",
    "methods_t": "Metodi di Pagamento",
    "methods_d": "Supportiamo VISA, MasterCard, Klarna, Amazon Pay e pagamenti biometrici tramite Apple Pay e Google Pay."
  },
  "payment_text": "Tutte le transazioni finanziarie vengono elaborate tramite fornitori di gateway esterni altamente sicuri. Orizon Desk utilizza i tuoi dati esclusivamente per scopi di connessione all'interno della piattaforma, mentre i dati finanziari sono protetti da livelli di crittografia di terze parti."
},
  "section06": {
      "title": "Rimborsi e Recesso",
      "subtitle": "I tuoi diritti ai sensi della Direttiva UE 2011/83/UE — 14 giorni di garanzia rimborso",
      "intro": "OrizonDesk rispetta tutti i diritti dei consumatori previsti dalla normativa europea. Acquistando qualsiasi piano tramite la nostra piattaforma, hai diritto al rimborso secondo le condizioni indicate di seguito.",
      "points": {
        "period_t": "Periodo di recesso",
        "period_d": "Hai il diritto di recedere dal contratto entro 14 giorni di calendario dalla data di conferma del pagamento, senza dover fornire alcuna motivazione.",
        "how_t": "Come presentare la richiesta",
        "how_d": "Invia un'email a info@orizon-aix.com con oggetto 'RICHIESTA DI RIMBORSO' indicando il Payment ID della transazione. Risponderemo entro 48 ore.",
        "conditions_t": "Condizioni per il rimborso",
        "conditions_d": "Il rimborso è possibile se l'account non è stato attivamente utilizzato per aggiungere dipendenti, documenti o dati aziendali dopo l'attivazione.",
        "timeline_t": "Tempistiche di accredito",
        "timeline_d": "Dopo l'approvazione della richiesta, i fondi vengono restituiti al metodo di pagamento originale entro 5–10 giorni lavorativi."
      },
      "exceptions_title": "Eccezioni al diritto di recesso",
      "exceptions_desc": "Il diritto di recesso non si applica se il servizio digitale è stato completamente attivato e utilizzato con il tuo consenso esplicito, ai sensi dell'art. 16(m) della Direttiva 2011/83/UE. In caso di utilizzo attivo della piattaforma, valuteremo la richiesta individualmente e, se necessario, offriremo un rimborso parziale o un'estensione dell'abbonamento.",
      "contact_block": "Per qualsiasi domanda relativa ai rimborsi, contattaci a info@orizon-aix.com o tramite il modulo di supporto all'interno della piattaforma. Ogni richiesta viene gestita individualmente e con la massima trasparenza.",
      "eu_note": "Questa policy è conforme alla Direttiva UE 2011/83/UE sui diritti dei consumatori e alla normativa locale applicabile."
    }
  
},

 "trash": {
    "title": "Cestino Documenti",
    "subtitle": "Gestisci i file eliminati: ripristina o elimina definitivamente",
    "placeholder_search": "Cerca file o utente...",
    "filter_all": "Tutti",
    "filter_today": "Oggi",
    "filter_7days": "7 Giorni",
    "table_doc": "Documento",
    "table_size": "Dimensione",
    "table_owner": "Proprietario",
    "table_removed_by": "Rimosso Da",
    "table_date": "Data e Ora",
    "table_actions": "Azioni",
    "no_files": "Nessun file trovato",
    "total": "Totale",
    "info_auto_on": "L'auto-eliminazione è ATTIVA. I file più vecchi di 30 giorni verranno rimossi automaticamente.",
    "info_auto_off": "I file rimarranno nel cestino finché non verranno eliminati manualmente.",
    "modal_restore_title": "Ripristina File?",
    "modal_delete_title": "Elimina Definitivamente?",
    "modal_restore_desc": "Vuoi ripristinare il file {{name}} di {{owner}}?",
    "modal_delete_desc": "Sei sicuro di voler eliminare definitivamente il file {{name}} di {{owner}}? Questa azione è irreversibile.",
    "modal_cancel": "Annulla",
    "modal_confirm": "Conferma"
  },
  "settings_trash": {
    "delete_label": "Auto-Eliminazione",
    "days_30": "30 Giorni"
  },

  
  "inventory": {
    "back": "Indietro",
    "new_table": "Nuova Tabella",
    "title": "Inventario e Magazzino",
    "subtitle": "Gestisci le tue risorse e crea record personalizzati.",
    "stats": {
        "total": "Tabelle",
        "total_desc": "Tabelle attive",
        "records": "Record",
        "records_desc": "Totale righe in tutte le tabelle",
        "last_update": "Aggiornato",
        "last_update_desc": "Data dell'ultimo inserimento"
    },
    "active_tables": "Tabelle Attive",
    "open_record": "Apri registro",
    "no_tables": {
      "title": "Nessuna tabella creata",
      "desc": "Crea la tua prima tabella personalizzata per l'inventario per iniziare a inserire i dati.",
      "btn": "Inizia ora"
    }
  },

  
  "inventory_table": {
    "back": "Indietro",
    "search_placeholder": "Cerca...",
    "btn_new_entry": "Nuovo Inserimento",
    "export_excel": "Esporta tabella in Excel (.xlsx)",
    "settings_title": "Impostazioni colonne e tabella",
    "add_row_title": "Aggiungi nuova riga alla tabella",
    "actions": "Azioni",
    "loading": "Caricamento...",
    "confirm_delete_row": "Eliminare questa riga?",
    "confirm_delete_column": "Eliminare la colonna \"{{name}}\"?",
    "error_prefix": "Errore: ",
    "table_default_name": "Tabella",
    "status_true": "Vero",
    "status_false": "Falso"
  },

  
  "create_table_modal": {
    "title": "Nuova Tabella",
    "system_info": "Sistema: AWS (Supabase) (ISO 8601)",
    "label_table_name": "Nome Tabella",
    "placeholder_table_name": "es. MAGAZZINO_A",
    "label_columns": "Configurazione Colonne",
    "placeholder_col_name": "Nome campo",
    "label_dropdown": "Attiva Dropdown",
    "btn_cancel": "Annulla",
    "btn_create": "Crea Tabella",
    "btn_creating": "Creazione...",
    "alert_empty_name": "Inserisci il nome della tabella!",
    "alert_error": "Errore: ",
    "types": {
      "text": "Testo",
      "number": "Numero",
      "date": "Data (YYYY-MM-DD)",
      "boolean": "Boolean (Vero/Falso)"
    }
  },
  
  "insert_line": {
    "header": {
      "title": "Nuovo Record",
      "loading_structure": "Caricamento struttura database...",
      "table_label": "Tabella: "
    },
    "validation": {
      "invalid_date": "Deve essere AAAA-MM-DD",
      "invalid_number": "Deve essere un numero"
    },
    "inputs": {
      "dropdown_placeholder": "Scegli o scrivi...",
      "true": "VERO",
      "false": "FALSO"
    },
    "footer": {
      "cancel": "Annulla",
      "save": "Salva"
    }
  },
  
  "settings_columns": {
    "title": "Configurazione Campi",
    "subtitle": "Aggiunta diretta al database",
    "label_new_field": "Nuovo Campo",
    "placeholder_name": "Nome nuova colonna...",
    "label_dropdown": "Attiva Dropdown",
    "btn_add": "Aggiungi Campo",
    "btn_adding": "Aggiunta...",
    "label_existing_fields": "Campi Esistenti",
    "status_dropdown_on": "● Dropdown Attivo",
    "status_dropdown_off": "○ Attiva Dropdown",
    "btn_close": "Chiudi Impostazioni",
    "types": {
      "text": "Testo",
      "number": "Numero",
      "date": "Data (YYYY-MM-DD)",
      "boolean": "Boolean (Vero/Falso)"
    }
  },
  
  "update_info": {
    "header": {
      "edit_title": "Modifica Record",
      "view_title": "Informazioni Dettagliate",
      "edit_subtitle": "Modifica i valori e salva",
      "view_subtitle": "Visualizzazione record dalla tabella"
    },
    "types": {
      "boolean": "[ Boolean ]",
      "date": "[ Data ]",
      "number": "[ Numero ]",
      "text": "[ Testo ]"
    },
    "labels": {
      "negative_value": "Il valore è inferiore a zero",
      "last_update": "Ultima modifica",
      "active": "Attivo (True)",
      "inactive": "Inattivo (False)",
      "true": "VERO",
      "false": "FALSO"
    },
    "footer": {
      "cancel": "Annulla",
      "save_changes": "Salva Modifiche",
      "close_view": "Chiudi visualizzazione"
    }
  },
  

  "premium_payments": {
    "back": "Indietro",
    "badge": "OrizonDesk PREMIUM",
    "price": "230 €",
    "price_monthly": "24.99 €",
    "price_period": "/ ANNUALE",
     "price_period_monthly": "/ MENSILE",
    "feature_employees": "50 Dipendenti",
    "feature_cloud": "15GB Cloud",
    "feature_audit": "Audit Log",
    "feature_support": "Supporto prioritario",

    "step1": {
      "title": "Fattura e Dati",
      "subtitle": "Compila il modulo per attivare il Pacchetto Premium",
      "label_name": "Nome",
      "label_surname": "Cognome",
      "label_company": "Nome Azienda",
      "label_email": "Email",
      "label_phone": "Telefono",
      "placeholder_name": "Il tuo nome",
      "placeholder_surname": "Il tuo cognome",
      "placeholder_company": "Nome dell'azienda",
      "placeholder_email": "admin@azienda.it",
      "placeholder_phone": "+39",
      "terms_part1": "Accetto i",
      "terms_link": "Termini e Condizioni",
      "terms_part2": "e la Politica sulla Privacy",
      "btn_next": "Procedi al pagamento",
      "error_generic": "Si è verificato un errore.",
      "error_email_exists": "Questa email è già registrata nel sistema.",
      "error_server": "Errore del server. Riprova più tardi."
    },

    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "PACCHETTO PREMIUM per",
      "total_label": "TOTALE DA PAGARE:",
      "total_amount": "230.00 €",
       "total_amount_monthly": "24.99 €",
      "summary_title": "Riepilogo dati",
      "summary_name": "Nome e cognome",
      "summary_company": "Azienda",
      "summary_email": "Email",
      "summary_phone": "Telefono",
      "summary_package": "Pacchetto",
      "summary_package_value": "Premium — 365 giorni",
       "summary_package_value_monthly": "Premium — 30 giorni",
      "btn_pay": "Procedi al pagamento — 230 €",
       "btn_pay_monthly": "Procedi al pagamento —24.99 €",
      "ssl_label": "Pagamento sicuro tramite Dodo Payments · SSL Encrypted",
      "btn_back": "← Torna alla modifica dei dati",
      "loading": "Apertura del pagamento sicuro ...",
      "error_checkout": "Errore durante il pagamento. Riprova.",
      "error_expired": "La sessione di pagamento è scaduta. Riprova.",
      "error_open": "Errore nell'apertura del pagamento. Riprova."
    },

    "footer_ssl": "Transazione SSL Encrypted · Dodo Payments"
  },

  "payment_success": {
    "loading": "Attivazione Pacchetto Premium ...",
    "badge": "OrizonDesk PREMIUM",
    "title": "Premium Attivato!",
    "subtitle": "Controlla la tua email",
    "subtitle2": "per le credenziali di accesso e l'attivazione dell'account.",
    "receipt_title": "Conferma Transazione",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Pacchetto",
    "receipt_package_value": "Premium — 365 giorni",
     "receipt_package_value_monthly": "Premium — 30 giorni",
    "receipt_status": "Stato",
    "receipt_status_value": "Pagato & Verificato",
    "btn_home": "Vai alla Home",
    "error_title": "Errore di attivazione",
    "error_subtitle": "Il pagamento è andato a buon fine, ma l'attivazione non è stata completata.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Errore",
    "error_contact": "Conserva il Payment ID e contattaci a",
    "error_status_failed": "Pagamento non riuscito. Stato:"
  },

  
  "basic_payments": {
    "back": "Indietro",
    "badge": "OrizonDesk BASIC",
    "price": "75 €",
    "price_monthly": "7.99 €",
    "price_period": "/ ANNUALE",
     "price_period_monthly": "/ MENSILE",
    "feature_employees": "10 Dipendenti",
    "feature_cloud": "5GB Cloud",
    "feature_qr": "QR Code Badge",
    "feature_support": "Supporto email",

    "step1": {
      "title": "Fattura e Dati",
      "subtitle": "Compila il modulo per attivare il Pacchetto Basic",
      "label_name": "Nome",
      "label_surname": "Cognome",
      "label_company": "Nome Azienda",
      "label_email": "Email",
      "label_phone": "Telefono",
      "placeholder_name": "Il tuo nome",
      "placeholder_surname": "Il tuo cognome",
      "placeholder_company": "Nome dell'azienda",
      "placeholder_email": "admin@azienda.it",
      "placeholder_phone": "+39",
      "terms_part1": "Accetto i",
      "terms_link": "Termini e Condizioni",
      "terms_part2": "e la Politica sulla Privacy",
      "btn_next": "Procedi al pagamento",
      "error_generic": "Si è verificato un errore.",
      "error_email_exists": "Questa email è già registrata nel sistema.",
      "error_server": "Errore del server. Riprova più tardi."
    },

    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "PACCHETTO BASIC per",
      "total_label": "TOTALE DA PAGARE:",
      "total_amount": "75.00 €",
      "total_amount_monthly": "7.99 €",
      "summary_title": "Riepilogo dati",
      "summary_name": "Nome e cognome",
      "summary_company": "Azienda",
      "summary_email": "Email",
      "summary_phone": "Telefono",
      "summary_package": "Pacchetto",
      "summary_package_value": "Basic — 365 giorni",
      "summary_package_value_monthly": "Basic — 30 giorni",
      "btn_pay": "Procedi al pagamento — 75.00 €",
       "btn_pay_montlhy": "Procedi al pagamento — 7.99 €",
      "ssl_label": "Pagamento sicuro tramite Dodo Payments · SSL Encrypted",
      "btn_back": "← Torna alla modifica dei dati",
      "loading": "Apertura del pagamento sicuro ...",
      "error_checkout": "Errore durante il pagamento. Riprova.",
      "error_expired": "La sessione di pagamento è scaduta. Riprova.",
      "error_open": "Errore nell'apertura del pagamento. Riprova."
    },

    "footer_ssl": "Transazione SSL Encrypted · Dodo Payments"
  },

  "basic_payment_success": {
    "loading": "Attivazione Pacchetto Basic ...",
    "badge": "OrizonDesk BASIC",
    "title": "Basic Attivato!",
    "subtitle": "Controlla la tua email",
    "subtitle2": "per le credenziali di accesso e l'attivazione dell'account.",
    "receipt_title": "Conferma Transazione",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Pacchetto",
    "receipt_package_value": "Basic — 365 giorni",
    "receipt_package_value_monthly": "Basic — 30 giorni",
    "receipt_status": "Stato",
    "receipt_status_value": "Pagato & Verificato",
    "btn_home": "Vai alla Home",
    "error_title": "Errore di attivazione",
    "error_subtitle": "Il pagamento è andato a buon fine, ma l'attivazione non è stata completata.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Errore",
    "error_contact": "Conserva il Payment ID e contattaci a",
    "error_status_failed": "Pagamento non riuscito. Stato:"
  },
  
  "enterprise_payments": {
    "back": "Indietro",
    "badge": "OrizonDesk ENTERPRISE",
    "price": "615 €",
    "price_monthly": "59.99 €",
    "price_period": "/ ANNUALE",
    "price_period_monthly": "/ MENSILE",
    "feature_employees": "Illimitati",
    "feature_cloud": "100GB Cloud",
    "feature_audit": "Audit Avanzato",
    "feature_support": "Supporto Dedicato",

    "step1": {
      "title": "Fattura e Dati",
      "subtitle": "Compila il modulo per attivare il Pacchetto Enterprise",
      "label_name": "Nome",
      "label_surname": "Cognome",
      "label_company": "Nome Azienda",
      "label_email": "Email",
      "label_phone": "Telefono",
      "placeholder_name": "Il tuo nome",
      "placeholder_surname": "Il tuo cognome",
      "placeholder_company": "Nome dell'azienda",
      "placeholder_email": "admin@azienda.it",
      "placeholder_phone": "+39",
      "terms_part1": "Accetto i",
      "terms_link": "Termini e Condizioni",
      "terms_part2": "e la Politica sulla Privacy",
      "btn_next": "Procedi al pagamento",
      "error_generic": "Si è verificato un errore.",
      "error_email_exists": "Questa email è già registrata nel sistema.",
      "error_server": "Errore del server. Riprova più tardi."
    },

    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "PACCHETTO ENTERPRISE per",
      "total_label": "TOTALE DA PAGARE:",
      "total_amount": "615.00 €",
      "total_amount_monthly": "59.99 €",
      "summary_title": "Riepilogo dati",
      "summary_name": "Nome e cognome",
      "summary_company": "Azienda",
      "summary_email": "Email",
      "summary_phone": "Telefono",
      "summary_package": "Pacchetto",
      "summary_package_value": "Enterprise — 365 giorni",
       "summary_package_value_monthly": "Enterprise — 30 giorni",
      "btn_pay": "Procedi al pagamento — 615 €",
       "btn_pay_monthly": "Procedi al pagamento — 59.99 €",
      "ssl_label": "Pagamento sicuro tramite Dodo Payments · SSL Encrypted",
      "btn_back": "← Torna alla modifica dei dati",
      "loading": "Apertura del pagamento sicuro ...",
      "error_checkout": "Errore durante il pagamento. Riprova.",
      "error_expired": "La sessione di pagamento è scaduta. Riprova.",
      "error_open": "Errore nell'apertura del pagamento. Riprova."
    },

    "footer_ssl": "Transazione SSL Encrypted · Dodo Payments"
  },

  "enterprise_payment_success": {
    "loading": "Attivazione Pacchetto Enterprise ...",
    "badge": "OrizonDesk ENTERPRISE",
    "title": "Enterprise Attivato!",
    "subtitle": "Controlla la tua email",
    "subtitle2": "per le credenziali di accesso e l'attivazione dell'account.",
    "receipt_title": "Conferma Transazione",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Pacchetto",
    "receipt_package_value": "Enterprise — 365 giorni",
     "receipt_package_value_monthly": "Enterprise — 30 giorni",
    "receipt_status": "Stato",
    "receipt_status_value": "Pagato & Verificato",
    "btn_home": "Vai alla Home",
    "error_title": "Errore di attivazione",
    "error_subtitle": "Il pagamento è andato a buon fine, ma l'attivazione non è stata completata.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Errore",
    "error_contact": "Conserva il Payment ID e contattaci a",
    "error_status_failed": "Pagamento non riuscito. Stato:"
  },
"ferie": {
  "modal_title": "Richiesta Ferie",
  "type_single_day": "Un Giorno",
  "type_multi_day": "Più Giorni",
  "type_hours": "Ore",
  "date_label": "Data",
  "from_label": "Dal",
  "to_label": "Al",
  "from_time_label": "Dalle Ore",
  "to_time_label": "Alle Ore",
  "weekend_included": "Weekend Incluso",
  "type_label": "TIPO",
  "shift_label": "Turno",
  "shift_daily": "Giornaliero",
  "shift_first": "Primo Turno",
  "shift_second": "Secondo Turno",
  "shift_third": "Terzo Turno",
  "shift_other": "Altro",
  "note_label": "Note (opzionale)",
  "note_placeholder": "Aggiungi una nota...",
  "cancel_btn": "Annulla",
  "submit_btn": "Invia Richiesta",
  "new_request_btn": "Nuova Richiesta",
  "errors": {
    "select_date": "Seleziona una data.",
    "select_range": "Seleziona Dal e Al.",
    "select_date_time": "Seleziona data e orari.",
    "submit_error": "Errore durante l'invio della richiesta."
  },
  "admin": {
    "page_title": "Gestione Ferie",
    "requests_title": "Richieste Ferie Dipendenti",
    "search_placeholder": "Cerca dipendente...",
    "all_statuses": "Tutti gli Stati",
    "approve_btn": "Approva",
    "reject_btn": "Rifiuta",
    "edit_btn": "Modifica",
    "save_changes": "Salva Modifiche",
    "new_request_title": "Nuova Richiesta (FERIE)",
    "select_employee_label": "Dipendente",
    "select_employee_placeholder": "Seleziona un dipendente...",
    "auto_accept_notice": "Questa richiesta verrà salvata come già accettata.",
    "errors": {
      "select_employee": "Seleziona un dipendente."
    }
  },

  "my_requests_title": "Le Mie Richieste Ferie",
  "all_years": "Tutti gli Anni",
  "all_months": "Tutti i Mesi",
  "reset_btn": "Reset",
  "no_requests": "Nessuna richiesta inviata",
  "days_label": "giorni",
  "details_tooltip": "Dettagli",
  "load_more_btn": "Carica Altri",
  "details_title": "Dettagli Richiesta",
  "time_label": "Orario",
  "days_column_label": "Giorni",
  "yes": "Sì",
  "no": "No",
  "timeline_title": "Cronologia",
  "timeline_sent": "Richiesta inviata",
  "timeline_answered_by": "Risposto da",
  "timeline_answer_date": "Data risposta",
  "delete_btn": "Elimina Richiesta",
  "delete_confirm_text": "Sei sicuro? Questa azione non è reversibile.",
  "confirm_delete_btn": "Conferma Eliminazione",
  "status_accepted": "Accettato",
  "status_rejected": "Rifiutato",
  "status_pending": "In Attesa",
  "months": {
    "01": "Gennaio", "02": "Febbraio", "03": "Marzo", "04": "Aprile",
    "05": "Maggio", "06": "Giugno", "07": "Luglio", "08": "Agosto",
    "09": "Settembre", "10": "Ottobre", "11": "Novembre", "12": "Dicembre"
  }
}
        }

      },
      bs: {
        translation: {
          "header": {
            "notifications": "Obavještenja", "settings": "Postavke", "help": "Pomoć", "my_profile": "Moj profil", "logout": "Odjavi se", "change_lang": "Promijeni jezik", "loading": "Učitavanje..."
          },

          "auth": {
  "access_portal": "Pristup portalu",
  "login": "Prijava",
  "email": "Email",
  "password": "Lozinka",
  "forgot_password": "Zaboravili ste lozinku?",
  "errors": {
    "email_req": "Email je obavezan",
    "pass_req": "Lozinka je obavezna",
    "invalid_credentials": "Email ili lozinka nisu ispravni"
  
},
"company_inactive": {
  "title": "Firma nije aktivna",
  "desc": "Pristup OrizonDesk-u za vašu firmu je privremeno obustavljen. Razlog je obično istek probnog perioda ili pretplate.",
  "contact_support": "Kontaktiraj podršku"
},
  "reset_title": "Reset lozinke",
  "reset_desc": "Unesite vaš email da primite uputstva za reset.",
  "send_link": "Pošalji link za reset",
  "back_to_login": "Nazad na prijavu",
  "success_msg": "Email je uspješno poslan!",
  "update_password": {
    "title": "Nova Lozinka",
    "desc": "Unesite vašu novu lozinku ispod.",
    "new_password": "Nova lozinka",
    "confirm_password": "Potvrdi lozinku",
    "button": "Ažuriraj lozinku",
    "success": "Lozinka uspješno promijenjena!",
    "error_match": "Lozinke se ne podudaraju"
  }
},



          "hero": {
            "welcome": "Dobrodošli na", 
            "subtitle": "Digitalizujte upravljanje uposlenicima. Eliminišite papir i upravljajte platnim listama, ugovorima i dokumentima u jednom sigurnom portalu.",
            "cta_button": "Pristupi Portalu", "gdpr_note": "Sistem zaštićen i usklađen sa propisima o digitalnom arhiviranju"
          },
          "cta": {
            "title": "Uvedite firmu u digitalnu budućnost", 
            "description": "Pridružite se kompanijama koje su eliminisale papirnu dokumentaciju uz OrizonDesk Portal za pametno upravljanje fajlovima.",
            "button_contact": "Kontaktiraj Orizon Tim", "feature_card": "Bez skrivenih troškova", "feature_setup": "Setup za 5 minuta", "feature_support": "Tehnička podrška",
          "button_learn_more": "Šta je OrizonDesk?"
          },
          "features": {
            "main_title": "Zašto preći na digitalno uz OrizonDesk",
            "main_subtitle": "Kompletno SaaS rješenje za eliminaciju fascikli i automatizaciju podjele dokumenata radnicima",
            "security_title": "Sigurna Arhiva",
            "security_desc": "Platne liste i osjetljivi dokumenti zaštićeni enkripcijom i sigurnim pristupom za svakog radnika.",
            "speed_title": "Brza Distribucija",
            "speed_desc": "Trenutna dostava platnih lista i dokumenata radnicima jednim klikom, bez troškova štampe.",
            "privacy_title": "Potpuna Usklađenost",
            "privacy_desc": "Potpuna usklađenost sa GDPR-om i zakonima o digitalnom čuvanju i zaštiti podataka.",
            "support_title": "Posvećena Podrška",
            "support_desc": "Specijalizovana pomoć pri tranziciji vaše firme iz papirnog u digitalni oblik poslovanja."
          },
          "footer": {
            "rights": "Sva prava pridržana.",
            "gdpr_text": "Usklađeno sa GDPR-om i propisima o privatnosti",
            "privacy": "Privatnost",
            "terms": "Uslovi korištenja",
            "contact": "Kontakt"
          },
          "landing": {
            "seo_title": "OrizonDesk - Sigurna Autentifikacija | Digitalizacija Dokumenata",
            "seo_description": "Sigurna platforma za upravljanje platnim listama i poslovnom dokumentacijom. Eliminišite papir i upravljajte uposlenicima digitalno u skladu sa GDPR-om.",
            "seo_keywords": "digitalne platne liste, upravljanje dokumentima, GDPR, sigurnost podataka, portal za radnike",
            "footer_privacy": "Privatnost",
            "footer_terms": "Uslovi korištenja",
            "footer_contact": "Kontakt",
            "footer_rights": "Sva prava pridržana.",
            "footer_gdpr": "Usklađeno sa GDPR-om i propisima o privatnosti"
        },
        "testimonials": {
            "title": "Šta kažu naši klijenti",
            "subtitle": "Stvarna iskustva kompanija koje su odabrale OrizonDesk Portal za sigurno upravljanje dokumentacijom uposlenika"
            },

            "dashboard": {
         "welcome_card": {
          "loading": "Učitavanje...",
          "morning": "Dobro jutro",
           "afternoon": "Dobar dan",
           "evening": "Dobro veče",
           "subtitle": "Upravljajte dokumentima kompanije {{azienda}} u potpunoj sigurnosti."
  }
},

"dipendente": {
  "welcome_card_dipendente": {
    "loading_dipendente": "Učitavanje...",
    "morning_dipendente": "Dobro jutro",
    "afternoon_dipendente": "Dobar dan",
    "evening_dipendente": "Dobro veče",
    "subtitle_dipendente": "Pregledajte i preuzmite svoje dokumente iz firme {{azienda}} na siguran način."
  }
},

"owner_welcome": {
  "loading": "Učitavanje...",
  "morning": "Dobro jutro",
  "afternoon": "Dobar dan",
  "evening": "Dobro veče",
  "role_subtitle": "Prijavljeni ste kao CEO kompanije {{azienda}}."
},


 
  "create_company": {
    "back": "Nazad",
    "title": "Registruj novu kompaniju",
    "subtitle": "Unesite podatke za kreiranje novog portala kompanije",
    "admin_section": "Podaci o administratoru",
    "company_section": "Podaci o kompaniji",
    "plan_section": "Detalji paketa",
    "success": "Kompanija i administrator su uspješno registrovani!",
    "button": "Kreiraj kompaniju",
    "labels": {
      "name": "Ime",
      "surname": "Prezime",
      "cf": "JMBG / Lični broj",
      "phone": "Telefon",
      "email": "Email za pristup",
      "company_name": "Naziv kompanije",
      "address": "Adresa",
      "vat": "ID broj / PDV",
      "plan": "Izaberi paket",
      "start": "Ugovor od",
      "end": "Ugovor do",
      "max_emp": "Maks. radnika:",
      "cloud_space": "Cloud prostor:"
    },
    "plans": {
      "basic": "BASIC (10 radnika / 5GB)",
      "premium": "PREMIUM (50 radnika / 15GB)",
      "enterprise": "ENTERPRISE (∞ radnika / 100GB)"
    },
    "info": {
      "password_auto": "Lični broj (JMBG) će biti korišten kao početna lozinka za pristup."
    },
    "errors": {
      "email_req": "Email je obavezan",
      "cf_req": "Lični broj je obavezan",
      "name_req": "Ime je obavezno",
      "company_req": "Naziv kompanije je obavezan",
      "date_req": "Datum isteka je obavezan",
      
    }
  },

"hero_owner": {
  "title": "Proširite svoje poslovanje",
  "subtitle": "Kreirajte novu kompaniju u Orizon sistemu. Moći ćete upravljati novim zaposlenicima, dokumentima i dozvolama za svaku pojedinačnu firmu.",
  "button": "Registruj novu kompaniju"
},

 "home_superadmin": {
    "sections": {
      "quick_actions": "Brze Akcije"
    },
    "stats": {
      "active_sessions": "Moji Dokumenti",
      "total_employees": "Ukupno Radnika",
      "pending_notif": "Obavještenja",
      "total_aziende": "Ukupno firmi",
      "avg_time": "STATUS PAKETA",
    "check_usage": "provjeri potrošnju resursa",
      "vs_last_month": "u odnosu na prošli mjesec"
    },
    "actions": {
      "profile": { "title": "Upravljaj Profilom", "desc": "Ažurirajte svoje lične podatke" },
      "settings": { "title": "Postavke Sistema", "desc": "Konfigurišite postavke aplikacije" },
      "create_employee": { "title": "Registruj Radnika", "desc": "Kreirajte novi portal za radnika" },
      "support": { "title": "Podrška i Pomoć", "desc": "Pristupite dokumentaciji i podršci" },
      "trash": { "title": "Korpa za smeće", "desc": "Upravljaj obrisanim datotekama" },
      "holidays_management": { "title": "Upravljanje Godišnjim", "desc": "Odobri ili odbij zahtjeve zaposlenih" },
      "inventory": { "title": "Sistem Inventure", "desc": "Upravljajte Vašom tabelom" 
}
    }
  },
  "home_dipendente": {
    "stats": {
      "my_documents": "Moji Dokumenti",
      "monthly_hours": "Sati ovog mjeseca",
      "pending_notif": "Obavještenja",
      "avg_session": "Prosječna Sesija",
      "vs_last_month": "u odnosu na prošli mjesec"
    },
    "actions": {
      "notifications": { "title": "Centar za obavijesti", "desc": "Pregledajte vaša nedavna obavještenja" }
    },
    "activities_title": "Nedavne Aktivnosti",
    "activities_subtitle": "Vaše zadnje akcije u aplikaciji",
    "no_activities": "Nema nedavnih aktivnosti za prikaz",
    "activities": {
      "login_title": "Pristup izvršen",
      "login_desc": "Pristupili ste sistemu sa novog uređaja"
    }
  
  },

"create_employee": {
  "back": "Nazad",
  "title": "Registruj novog radnika",
  "subtitle": "Korisnik će automatski biti povezan sa:",
  "section_title": "Lični podaci",
  "labels": {
    "name": "Ime",
    "surname": "Prezime",
    "cf": "JMBG / Lični broj",
    "email": "Email",
    "phone": "Telefon",
    "role": "Uloga korisnika"
  },
    "roles": {
    "user": "Obični korisnik (User)",
    "admin": "Administrator firme (Admin)"
  },
  "placeholders": {
    "cf": "Unesite JMBG "
  },
  "submit_btn": "Kreiraj portal za radnika",
  "success_msg": "Uspješno poslat poziv za registraciju na portal.",
  "errors": {
    "email_req": "Email je obavezan",
    "cf_req": "JMBG je obavezan",
    "name_req": "Ime je obavezno",
    "no_company": "Greška: Nemoguće identifikovati matičnu kompaniju.",
    "limit_title": "Dostignut limit",
"limit_reached": "Firma je dostigla maksimalan limit od {{max}} uposlenika.",
"upgrade_now": "Vidi status i nadogradi"
  }
},



"legal": {
  "back": "Vrati se nazad",
  "title": "Pravne Informacije & Privatnost",
  "version": "Orizon Desk Portal • Verzija 1.2.1 • 2026",
  "terms": {
    "title": "Uslovi Korištenja",
    "p1": "Orizon Desk Portal je zatvorena poslovna platforma namijenjena isključivo zaposlenicima i menadžmentu kompanije. Pristupom portalu, korisnik se obavezuje na poštivanje internih pravila digitalne komunikacije.",
    "li1": "Zabranjeno je dijeljenje pristupnih podataka (email i lozinka) sa trećim licima.",
    "li2": "Svaki pokušaj neovlaštenog pristupa dijelovima sistema za koje korisnik nema dozvolu smatra se kršenjem radne discipline.",
    "li3": "Portal se smije koristiti isključivo za uvid u lične dokumente, evidenciju rada i komunikaciju unutar firme."
  },
  "privacy": {
    "title": "Transparentnost i Pristup",
    "sub": "Ko ima pristup vašim dokumentima?",
    "user_title": "Zaposlenik",
    "user_desc": "Ima puni uvid u svoje platne liste, CUD, medicinske certifikate... Može ih pregledati i preuzeti u bilo kojem trenutku.",
    "admin_title": "Administratori",
    "admin_desc": "Ovlašteni HR i računovodstveni radnici mogu postavljati, ažuriranja ili brisati dokumente. Ovaj pristup je neophodan radi digitalne distribucije dokumentacije.",
    "note": "Napomena o privatnosti: Administratori firme pristupaju dokumentima isključivo u okviru svojih radnih obaveza. Svaki pristup dokumentaciji je sistemski logovan radi sprečavanja zloupotrebe."
  },
  "security": {
    "title": "Tehnička Zaštita Podataka",
    "enc_t": "Enkripcija podataka",
    "enc_d": "Svi dokumenti su kriptovani tokom prenosa (SSL) i dok miruju na serveru (AES-256). Vaša lozinka je 'hashed' i niko je ne može vidjeti u izvornom obliku.",
    "infra_t": "Infrastruktura baze podataka (AWS i Google Cloud)",
    "infra_d": "Podaci se čuvaju na visokosigurnim serverima koji zadovoljavaju GDPR i SOC2 standarde. Koristimo Row-Level Security (RLS) kako bi osigurali da baza podataka odbije svaki neautorizovan zahtjev."
  },
  "rights": {
    "title": "Vaša Prava",
    "r1": "Pravo na uvid u podatke",
    "r2": "Pravo na ispravku netačnih informacija",
    "r3": "Pravo na brisanje naloga",
    "r4": "Pravo na prenosivost podataka"
  },
  "contact_info": "Za sve dodatne informacije o vašim pravima kontaktirajte:",
  "rights_reserved": "© 2026 Orizon AIX. Sva prava zadržana."
},

"contact": {
  "back": "Vrati se nazad",
  "title": "Kontaktirajte Nas",
  "subtitle": "Imate pitanje? Tu smo da pomognemo.",
  "success_title": "Uspješno Poslano!",
  "success_desc": "Vaša poruka je poslana. Odgovorićemo vam u najkraćem mogućem roku.",
  "label_name": "Ime i Prezime",
  "label_email": "Email Adresa",
  "label_subject": "Naslov (Subject)",
  "label_message": "Vaša Poruka",
  "placeholder_name": "Vaše ime i prezime",
  "placeholder_subject": "Pitanje u vezi OrizonDesk portala...",
  "placeholder_message": "Ovdje upišite vaš upit...",
  "btn_send": "Pošalji Poruku",
  "info_email": "Direktni Email",
  "info_web": "Web Stranica"
},



"profile": {
    "loading": "Učitavanje...",
    "no_data": "Podaci nisu pronađeni.",
    "full_name": "Ime i Prezime",
    "email": "Službeni Email",
    "phone": "Telefon",
    "not_specified": "Nije navedeno",
    "cf": "JMBG / Porezni broj",
    "role": "Uloga",
    "employee": "Uposlenik",
    "reg_date": "Datum registracije",
    "last_access": "Zadnji pristup",
    "first_session": "Prva sesija",
    "unique_id": "Jedinstveni ID korisnika",
    "change_password": "Promijeni lozinku"
  },

"profile_page": {
  "title": "Moj Profil",
  "back": "Nazad",
  "qr_badge": "Moj QR Badge",
  "my_holidays": "Moj Godišnji"
},
  "change_password": {
    "title": "Promjena Lozinke",
    "subtitle": "Ažurirajte vaše pristupne podatke",
    "security_section": "Sigurnost Računa",
    "labels": {
      "old": "Trenutna Lozinka",
      "new": "Nova Lozinka",
      "confirm": "Potvrdi Lozinku"
    },
    "errors": {
      "mismatch": "Lozinke se ne podudaraju",
      "wrong_old": "Trenutna lozinka nije ispravna"
    },
    "success": "Lozinka uspješno ažurirana!",
    "submit_btn": "Sačuvaj Izmjene"
  },

 "dipendenti_list": {
  "loading": "Učitavanje radnika...",
  "title": "Upravljanje Osobljem",
  "subtitle": "Pregled svih uposlenika firme",
  "search_placeholder": "Pretraži radnika...",
  "no_results": "Nema pronađenih radnika.",
  "filter_active": "Aktivni",
  "filter_inactive": "Neaktivni",
  "table": {
    "name": "Radnik",
    "email": "Email",
    "role": "Uloga",
    "actions": "Akcije"
  }
},

"months": {
    "january": "Januar", "february": "Februar", "march": "Mart", "april": "April", "may": "Maj", "june": "Juni",
    "july": "Juli", "august": "August", "september": "Septembar", "october": "Oktobar", "november": "Novembar", "december": "Decembar"
  },
  "timbrature": {
    "archive_title": "Arhiva mojih registracija",
    "history_title": "Historija prisustva",
    "no_data": "Nema pronađenih registracija za ovaj period.",
    "filters": {
      "month": "Mjesec",
      "year": "Godina",
      "view": "Prikaži sate",
      "loading": "Učitavanje..."
    },
    "stats": {
      "ord": "Regularni sati",
      "straord": "Prekovremeni sati",
      "monthly_total": "Mjesečni ukupno",
      "total": "Ukupno"
    },
    "table": {
      "name": "Ime",
      "surname": "Prezime",
      "date": "Datum",
      "entry": "Ulaz",
      "exit": "Izlaz",
      "ord_short": "Reg. (8h)",
      "straord_short": "Prekovr."
    }
  },

  "settings": {
  "title": "Postavke",
  "theme_title": "Personalizacija",
  "dark_mode": "Tamna tema",
  "light_mode": "Svijetla tema",
  "subtitle": "Prilagodi svoje iskustvo",
  "group_notifications": "Obavijesti i Upozorenja",
  "group_security": "Sigurnost i Pristup",
  "group_preferences": "Postavke Aplikacije",
  "push_label": "Push Obavijesti",
  "push_desc": "Primaj obavijesti u realnom vremenu",
  "email_label": "Sedmični Izvještaji",
  "email_desc": "Pregled sati putem emaila",
  "bio_label": "Biometrija",
  "delete_label": "Auto-brisanje",
  "delete_desc": "Trajno briše datoteke iz smeća nakon 30 dana",
  "bio_desc": "Brzi FaceID/Otisak prsta",
  "logout_label": "Auto Odjava",
  "logout_desc": "Odjavi nakon 30 min neaktivnosti",
  "dark_label": "Tamni Režim",
  "dark_desc": "Interfejs visokog kontrasta",
  "gps_label": "GPS Preciznost",
  "gps_desc": "Poboljšaj praćenje lokacije",
  "version": "Verzija aplikacije",
  "reset": "Resetuj sve postavke"
},


  "months": {
    "Gennaio": "Januar",
    "Febbraio": "Februar",
    "Marzo": "Mart",
    "Aprile": "April",
    "Maggio": "Maj",
    "Giugno": "Juni",
    "Luglio": "Juli",
    "Agosto": "Avgust",
    "Settembre": "Septembar",
    "Ottobre": "Oktobar",
    "Novembre": "Novembar",
    "Dicembre": "Decembar"
  },
  "myDocuments": {
    "title": "Arhiva dokumenata",
    "auditLogButton": "Log aktivnosti",
    "subtitle": "Pregledajte i preuzmite svoje dokumente, certifikate i platne liste.",
    "backHome": "Nazad na početnu",
    "searchPlaceholder": "Naziv datoteke, tip, kurs...",
    "searchLabel": "Traži u arhivi",
    "filterAnno": "Godina",
    "filterTipo": "Tip",
    "filterAll": "Sve",
    "table": {
      "document": "Dokument",
      "type": "Tipologija",
      "details": "Detalji / Istek",
      "download": "Preuzmi",
      "uploadedOn": "Učitano dana",
      "expires": "Ističe",
      "noDocs": "Nema pronađenih dokumenata."
    },
    "types": {
      "bustaPaga": "Platna lista",
      "cu": "Porezna potvrda (CU)",
      "contratto": "Ugovor",
      "visitaMedica": "Ljekarski pregled",
      "certificatoCorso": "Certifikat kursa",
      "altro": "Ostalo"
    }
  },
  "qrBadge": {
  "title": "Moj QR Kod",
  "loading": "Učitavanje podataka...",
  "instructions": "Pokažite ovaj kod skeneru <br /> da potvrdite prisustvo",
  "notGenerated": "Kod još nije generisan",
  "contactAdmin": "Kontaktirajte administraciju da aktivirate svoj QR kod.",
  "download": "Preuzmi sliku",
  "close": "Zatvori"
},

"qrAdmin": {
  "title": "Službeni Badge",
  "sync": "Sinhronizacija...",
  "notFound": "Badge nije pronađen",
  "download": "Preuzmi Badge",
  "regenerate": "Ponovo generiši",
  "generateNow": "Generiši sada",
  "confirmNew": "Želite li generisati novi QR Badge?",
  "confirmOverwrite": "Želite li zamijeniti postojeći badge?",
  "success": "Badge uspješno ažuriran!",
  "securityError": "Greška (Security Policy): Provjerite da li vaš nalog ima dozvole za UPDATE u storage-u."
},

"attendance": {
  "filterTitle": "Registar Prisustva",
  "month": "Mjesec",
  "year": "Godina",
  "btnLoad": "Učitaj Prisustva",
  "loading": "Učitavanje...",
  "history": "HISTORIJA PRISUSTVA",
  "noData": "Nema pronađenih podataka za odabrani period.",
  "stats": {
    "ord": "Ukupno Redovni",
    "stra": "Ukupno Prekovremeni",
    "total": "Ukupna Suma"
  },
  "table": {
    "date": "Datum",
    "entry": "Ulaz",
    "exit": "Izlaz",
    "ord_short": "Redovni (8h)",
    "stra_short": "Prekovremeni",
    "total": "Ukupno"
  }
},

"company_modal": {
    "header_subtitle": "PODACI O KOMPANIJI",
    "address_label": "ADRESA",
    "registered_label": "REGISTROVAN"
  },


  "companies": {
    "title": "Lista Kompanija",
    "total": "Ukupno",
    "search_placeholder": "Pretraži firme...",
    "col_name": "Kompanija",
    "col_actions": "Detalji",
    "no_data": "Nije pronađena nijedna firma."
  },
  "company_modal": {
    "header_subtitle": "PODACI O KOMPANIJI",
    "address_label": "ADRESA",
    "registered_label": "REGISTROVAN"
  },
  "common": {
      "loading": "Učitavanje...",
    "all": "Svi",
    "actions": "Akcije",
    "annual": "Godišnje",
    "edit": "Uredi",
    "save": "Spremi",
    "cancel": "Otkaži",
    "close": "Zatvori",
    "nd": "N/D",
    "unread": "NEPROČITANO",
    "read": "PROČITANO",
    "close": "ZATVORI",
    "not_available": "Nije dostupno",
    "confirm_delete": "Jesi li siguran da zelis obrisati?",
    "loading": "Učitavanje...",
    "all": "Sve",
    "actions": "Akcije",
    "annual": "Godišnje",
    "edit": "Uredi",
    "save": "Spremi",
    "saving": "Spremanje...",
    "cancel": "Otkaži",
    "close": "Zatvori",
    "delete": "Obriši",
    "preview": "Pregled",
    "download": "Preuzmi",
    "downloading": "Preuzimanje...",
    "load_more": "Prikaži više",
    "nd": "N/D",
    "read": "PROČITANO",
    "unread": "NEPROČITANO",
    "yes": "Da",
    "no": "Ne",
    "close": "ZATVORI",
    "not_available": "Nema adrese"
  },
  

"categ": {
  "title2": "Nova Kategorija",
  "input_placeholder": "Naziv kategorije...",
  "custom_list": "Prilagođene kategorije:",
  "add": "Dodaj",
  "title": "Nova Kategorija",
  "name": "Naziv Kategorije",
  "placeholder": "Unesite naziv...",
  "hint": "Dostupno za sve uposlenike ove firme.",
  "error_duplicate": "Greška: Ova kategorija već postoji u ovoj firmi!",
  "error_generic": "Došlo je do greške",
  "manager_title": "Upravljanje Kategorijama",
  "add_new": "Dodaj Novu",
  "your_list": "Vaše kategorije",
  "no_custom": "Nema prilagođenih kategorija",
  "error_delete": "Greška pri brisanju",
   "confirm_delete": "Jesi li siguran da zelis obrisati?"
},

  "orizon_desk": {
    "back": "Nazad na portal",
    "hero_title_1": "Šta je",
    "hero_title_2": "OrizonDesk",
    "hero_title_3": "portal?",
    "hero_subtitle": "Digitalna revolucija u upravljanju ljudskim resursima",
    "main_desc_title": "Zbogom papirima, dobrodošli u Cloud",
    "main_desc_text": "OrizonDesk Portal je centralizovana digitalna platforma dizajnirana da transformiše način na koji firme komuniciraju sa svojim uposlenicima. Naš cilj je jasan: potpuna eliminacija papirne dokumentacije i prelazak na sigurno, brzo i transparentno digitalno okruženje.",
    "for_companies": "Za firme",
    "for_companies_desc": "Automatizacija HR procesa, sigurnost podataka i ušteda vremena.",
    "for_workers": "Za uposlenike",
    "for_workers_desc": "Brzi pristup ličnim dokumentima i evidenciji rada putem mobitela.",
    "feature_1_title": "Digitalna Arhiva",
    "feature_1_li1": "Platne liste",
    "feature_1_li2": "Certifikati i obuke",
    "feature_1_li3": "Ugovori o radu",
    "feature_1_li4": "HR obavijesti",
    "feature_2_title": "Evidencija Prisustva",
    "feature_2_desc": "Sistem 'kucanja' putem QR koda. Radnici koriste mobilni uređaj za prijavu i odjavu sa posla.",
    "feature_2_li1": "Automatski obračun sati",
    "feature_2_li2": "Prekovremeni rad",
    "feature_2_li3": "Pregled sati za radnike",
    "cta_title": "Započnite digitalizaciju danas",
    "cta_subtitle": "Procedura je jednostavna i brza",
    "step_1_title": "Kontaktirajte nas",
    "step_1_desc": "Izaberite paket prema broju radnika i potrebnoj Cloud memoriji za arhivu.",
    "step_2_title": "Aktivacija firme",
    "step_2_desc": "Dobijate administratorske kredencijale i kreirate profile vaših radnika.",
    "step_3_title": "Radnici su tu",
    "step_3_desc": "Radnici dobijaju mail za potvrdu, loguju se i odmah vide svoje dokumente i sate.",
    "footer_contact_text": "Kontaktirajte naš tim za ponudu",
    "footer_rights": "Sva prava pridržana."
  },

 
  "employee": {
    "back_to_list": "Nazad na listu uposlenika",
    "generate_qr": "Generiši QR Badge",
    "info_title": "Informacije o uposleniku",
    "not_active": "Neaktivan"
  },
  "docs": {
    "new_upload": "Novi Upload",
    "title": "Dokumenti Firme",
    "subtitle": "Digitalno upravljanje i arhiviranje dokumenata firme",
     "refid": "Referentni Broj / ID",
    "refid_placeholder": "Npr. UGO-2026-001 ili broj transakcije",
    "course_name": "Naziv Kursa",
    "course_placeholder": "Npr: Sigurnost na Radu",
    "valid_from": "Važi Od",
    "valid_to": "Važi Do",
    "notes": "Napomene / Opis",
    "notes_placeholder": "Navedite o čemu se radi...",
    "no_notes": "Nema dodanih napomena.",
    "year": "Godina",
    "month": "Mjesec",
    "select_pdf_img": "Odaberite PDF ili Sliku",
    "upload_btn": "Sačuvaj Dokument",
    "uploading": "Prenos u toku...",
    "filter_archive": "Filtriraj Arhivu",
    "search_placeholder": "Traži po nazivu, tipu, ref. broju...",
    "list_title": "Lista Prenesenih Dokumenata",
    "col_name": "Naziv Dokumenta",
    "col_type": "Kategorija",
    "col_ref": "Referentni ID",
    "col_period": "Period",
    "col_date": "Datum Prenosa",
    "expires": "Do",
    "no_docs_found": "Nema pronađenih dokumenata za odabrane kriterije.",
    "select_file_alert": "Odaberite datoteku!",
    "missing_company": "Nedostaje podatak o firmi.",
    "upload_success": "Dokument uspješno prenesen!",
    "upload_error": "Greška prilikom prenosa",
    "confirm_delete_title": "Potvrda Brisanja",
    "confirm_delete": "Da li ste sigurni da želite trajno obrisati ovaj dokument? Ova akcija će ukloniti fajl i iz storage-a.",
    "confirm_delete_category": "Želite li obrisati ovu kategoriju?",
    "category_exists": "Ova kategorija već postoji!",
    "category_error": "Greška",
    "delete_success": "Dokument uspješno obrisan!",
    "delete_error": "Greška prilikom brisanja",
    "download_error": "Nije moguće preuzeti fajl.",
    "preview_error": "Greška prilikom učitavanja pregleda.",
    "update_success": "Dokument uspješno ažuriran!",
    "update_error": "Greška prilikom ažuriranja",
    "edit_modal_title": "Uredi Dokument",
    "info_modal_title": "Detalji Dokumenta",
    "edit_subtitle": "Izmjena parametara",
    "info_subtitle": "Pregled podataka",
    "type": "Tip",
    "types": {
      "payslip": "Platna lista",
      "cu": "Porezna potvrda (CU)",
      "contract": "Ugovor",
      "medical": "Ljekarski pregled",
      "course": "Certifikat kursa",
      "other": "Ostalo"
    },

      "types2": {
      "contract": "Ugovor",
      "course": "Certifikat",
      "other": "Ostalo"
    },
     
    "course_name": "Naziv kursa",
    "course_placeholder": "Npr: Zaštita na radu",
    "valid_from": "Važi od",
    "valid_to": "Važi do",
    "notes": "Napomena / Opis",
    "notes_placeholder": "Navedite detalje...",
    "year": "Godina",
    "month": "Mjesec",
    "select_pdf_img": "Odaberi PDF ili sliku",
    "upload_btn": "Učitaj dokument",
    "uploading": "Učitavanje u toku...",
    "filter_archive": "Filtriraj arhivu",
    "search_placeholder": "Pretraži po imenu, tipu, datumu...",
    "list_title": "Lista učitanih dokumenata",
    "col_name": "Naziv dokumenta",
    "col_type": "Tip",
    "col_period": "Period/Važenje",
    "col_date": "Datum uploada",
    "expires": "Ističe",
    "no_docs_found": "Nema dokumenata za odabrane kriterije.",
    "select_file_alert": "Molimo odaberite fajl!",
    "upload_success": "Dokument uspješno učitan!",
    "upload_error": "Greška pri učitavanju",
    "confirm_delete": "Jeste li sigurni da želite obrisati ovaj dokument?",
    "delete_error": "Greška pri brisanju",
    "download_error": "Preuzimanje fajla nije moguće."
  },
  
  "employee_modal": {
    "title_info": "Informacije o uposleniku",
    "title_edit": "Uredi uposlenika",
    "first_name": "Ime",
    "last_name": "Prezime",
    "tax_code": "JMBG",
    "email": "Email",
    "phone": "Telefon",
    "created_at": "Datum kreiranja",
    "last_login": "Zadnja prijava",
    "never": "Nikada",
    "alert_success": "Podaci uspješno ažurirani!",
    "alert_error": "Greška pri ažuriranju"
  },

  "notifikacije": {
    "title_not": "DOKUMENTI ZA ČITANJE",
    "empty": "SVE PROČITANO!",
    "view_all": "IDI NA MOJE DOKUMENTE"
  },

  "sidebar": {
    "dashboard": "Dashboard",
    "profile": "Moj Profil",
    "settings": "Postavke",
    "my_holidays": "Moj Godišnji",
    "version": "V2.4.0 OrizonDesk"
  },

  "adminHome": {
    "categories": {
      "dipendenti": {
        "title": "RADNICI",
        "subtitle": "Prisustvo, Dokumenti & Smjene",
        "description": "Upravljanje osobljem, ugovorima o radu, ličnim dokumentima, prisustvom, smjenama i izvještajima o evidenciji radnog vremena."
      },
      "azienda": {
        "title": "FIRMA",
        "subtitle": "Profil & Dokumenti",
        "description": "Arhivirajte i upravljajte zvaničnim dokumentima firme, ugovorima o zakupu i internom administracijom."
      },
      "partner": {
        "title": "PARTNERI",
        "subtitle": "Klijenti & Dobavljači",
        "description": "Kompletna evidencija poslovnih partnera, ugovora o nabavci, faktura i historije narudžbi."
      }
    },

  "partnerModal": {
    "title": "Poslovni partneri",
    "subtitle": "Izaberite opciju za nastavak",
    "newPartner": {
      "title": "NOVI PARTNER",
      "desc": "Dodajte novog klijenta ili dobavljača u bazu sa svim detaljima."
    },
    "allPartners": {
      "title": "SVI PARTNERI",
      "desc": "Pregledajte i upravljajte kompletnom listom partnera i njihovih dokumenata."
    }
  },
    "common": {
      "accessSection": "Pristupi sekciji"
    }
  },

  "create_partner": {
  "back": "Nazad",
  "title": "Novi Poslovni Partner",
  "subtitle": "Dodaj novog partnera za kompaniju:",
  "success_msg": "Partner uspješno spremljen!",
  "manage_categories_btn": "Upravljaj kategorijama",
  "select_placeholder": "-- Odaberi tip / kategoriju --",
  "default_types_group": "Zadane kategorije",
  "db_categories_group": "Kategorije iz baze",
  "submit_btn": "Spremi partnera",
  "my_partners_btn": "Moji Partneri",
  

  "sections": {
    "basic": "1. Osnovni podaci",
    "location": "2. Kontakt i adresa",
    "banking": "3. Banka i kontakt osoba"
  },

  "labels": {
    "naziv": "Naziv partnera *",
    "tip": "Tip / Kategorija partnera",
    "pib_jib": "JIB / PIB",
    "pdv": "PDV broj",
    "broj_registracije": "Broj registracije",
    "adresa": "Adresa",
    "postanski_broj": "Poštanski broj",
    "grad": "Grad",
    "drzava": "Država",
    "email": "Email",
    "telefon": "Telefon",
    "web": "Web stranica",
    "naziv_banke": "Naziv banke",
    "bankovni_racun": "Bankovni račun (IBAN)",
    "kontakt_osoba": "Kontakt osoba",
    "kontakt_telefon": "Telefon kontakt osobe",
    "napomena": "Napomena"
  },

  "types": {
    "dobavljac": "Dobavljač",
    "klijent": "Kupac / Klijent",
    "obostrano": "Kupac / Dobavljač"
  },


  "errors": {
    "no_company": "Kompanija nije pronađena",
    "name_req": "Naziv partnera je obavezan"
  },
"placeholders": {
  "naziv": "npr. ACME d.o.o.",
  "pib_jib": "npr. 4200000000000",
  "pdv": "npr. 200000000000",
  "napomena": "Unesite dodatne napomene o partneru..."
},

  "category_modal": {
    "title": "Upravljanje kategorijama",
    "existing_list": "Postojeće kategorije",
    "no_categories": "Nema kreiranih kategorija.",
    "delete": "Obriši kategoriju",
    "add_new": "Dodaj novu kategoriju",
    "name_label": "Naziv kategorije *",
    "name_placeholder": "Npr. Podizvođač",
    "desc_label": "Opis kategorije",
    "desc_placeholder": "Opcionalni opis kategorije...",
    "save_btn": "Spremi kategoriju",
    "close": "Zatvori",
    "duplicate_error": "Kategorija s ovim nazivom već postoji.",
    "save_error": "Greška prilikom kreiranja kategorije",
    "delete_error": "Greška prilikom brisanja kategorije",
    "confirm_delete": "Da li ste sigurni da želite obrisati ovu kategoriju?"
  }
},

  
"listapartner": {
  "back": "Nazad",
  "title": "Poslovni partneri",
  "subtitle": "Upravljajte klijentima i dobavljačima vaše kompanije",
  "new_partner": "Novi partner",
  "filter_archive": "Pretraga partnera",
  "search_placeholder": "Pretraži po nazivu, PIB/JIB, gradu, emailu...",
  "type": "Tip partnera",
  "list_title": "Lista partnera",
  "no_partners_found": "Nije pronađen nijedan partner za odabrane kriterije.",
  "col_name": "Naziv partnera",
  "col_piva": "PIB / JIB",
  "col_type": "Tip",
  "col_location": "Grad / Adresa",
  "col_contact": "Kontakt",
  "col_date": "Datum kreiranja",
  "view_documents": "Dokumenti partnera",
  "select_placeholder": "-- Odaberi --",
  "pdv": "PDV broj",
  "broj_registracije": "Broj registracije",
  "adresa": "Adresa",
  "postanski_broj": "Poštanski broj",
  "grad": "Grad",
  "drzava": "Država",
  "email": "Email",
  "telefon": "Telefon",
  "web": "Web stranica",
  "naziv_banke": "Naziv banke",
  "bankovni_racun": "Bankovni račun (IBAN)",
  "kontakt_osoba": "Kontakt osoba",
  "kontakt_telefon": "Telefon kontakt osobe",
  "napomena": "Napomena",
  "no_notes": "Nema dodanih napomena.",
  "update_success": "Partner je uspješno ažuriran!",
  "update_error": "Greška prilikom ažuriranja partnera",
  "delete_error": "Greška prilikom brisanja partnera",
  "edit_modal_title": "Uredi partnera",
  "info_modal_title": "Detalji partnera",
  "edit_subtitle": "Izmjena podataka",
  "info_subtitle": "Pregled podataka",
  "confirm_delete_title": "Potvrda brisanja",
  "confirm_delete": "Da li ste sigurni da želite trajno obrisati ovog partnera?",
  "confirm_delete_docs_warning": "UPOZORENJE: Ova akcija će trajno obrisati i svih {{count}} dokumenata ovog partnera (iz baze podataka i sa servera). Ova operacija se NE MOŽE poništiti.",
  "confirm_delete_no_docs_warning": "UPOZORENJE: Ova operacija se NE MOŽE poništiti.",
  "errors": {
    "name_req": "Naziv partnera je obavezan"
  },
  "types": {
    "dobavljac": "Dobavljač",
    "klijent": "Klijent",
    "obostrano": "Klijent / Dobavljač"
  }
},

"dettagli_partner": {
  "back": "Nazad",
  "gestione_documenti": "Upravljanje dokumentima za",
  "subtitle": "Upravljanje i digitalno arhiviranje dokumenata partnera",
  "new_upload": "Novi upload",
  "filter_archive": "Filtriraj arhivu",
  "search_placeholder": "Pretraži po nazivu, tipu, ref. broju...",
  "year": "Godina",
  "month": "Mjesec",
  "type": "Tipologija",
  "list_title": "Lista prenesenih dokumenata",
  "no_docs_found": "Nije pronađen nijedan dokument za odabrane kriterije.",
  "col_name": "Naziv dokumenta",
  "col_ref": "Referentni ID",
  "col_type": "Tipologija",
  "col_period": "Period / Važenje",
  "col_date": "Datum uploada",
  "valid_from": "Važi od",
  "valid_to": "Važi do",
  "refid": "Br. reference / ID",
  "refid_placeholder": "Npr. FAKT-2026-001",
  "notes": "Napomene / Opis",
  "notes_placeholder": "Navedite o čemu se radi...",
  "no_notes": "Nema dodanih napomena.",
  "select_pdf_img": "Odaberite PDF ili sliku",
  "select_file_alert": "Odaberite datoteku!",
  "uploading": "Upload u toku...",
  "upload_btn": "Prenesi dokument",
  "upload_success": "Dokument je uspješno prenesen!",
  "upload_error": "Greška prilikom uploada",
  "download_error": "Preuzimanje datoteke nije moguće.",
  "preview_error": "Greška prilikom učitavanja pregleda.",
  "update_success": "Dokument je uspješno ažuriran!",
  "update_error": "Greška prilikom ažuriranja",
  "delete_error": "Greška prilikom brisanja",
  "missing_company": "Nedostaje podatak o kompaniji.",
  "missing_partner": "Partner nije pronađen.",
  "edit_modal_title": "Uredi dokument",
  "info_modal_title": "Detalji dokumenta",
  "edit_subtitle": "Izmjena parametara",
  "info_subtitle": "Pregled podataka",
  "confirm_delete_title": "Potvrda brisanja",
  "confirm_delete": "Da li ste sigurni da želite trajno obrisati ovaj dokument? Ova akcija će ukloniti datoteku i sa storage servera.",
  "categ_title2": "Nova kategorija",
  "categ_input_placeholder": "Naziv kategorije...",
  "categ_custom_list": "Prilagođene kategorije:",
  "categ_add": "Dodaj",
  "category_exists": "Ova kategorija već postoji!",
  "category_error": "Greška",
  "confirm_delete_category": "Želite li obrisati ovu kategoriju?",
  "types": {
    "contract": "Ugovor",
    "invoice": "Faktura",
    "other": "Ostalo"
  }
},

"deactivate_modal": {
  "title": "Deaktivacija Radnika",
  "subtitle": "Spremate se da deaktivirate pristup korisniku:",
  "reason_label": "Razlog deaktivacije (obavezno)",
  "placeholder": "Npr. Prekid radnog odnosa, Disciplinski postupak...",
  "warning_login": "Korisnik se više neće moći prijaviti na sistem.",
  "warning_data": "Svi podaci i dokumenti će ostati sačuvani u arhivi.",
  "confirm_btn": "Potvrdi Deaktivaciju",
  "cancel_btn": "Odustani",
  "error": "Greška pri deaktivaciji",
  "success_deactivate": "Radnik uspješno deaktiviran"
},

"activate_modal": {
  "title": "Aktivacija Radnika",
  "subtitle": "Ponovo aktivirate pristup korisniku:",
  "reason_label": "Napomena o aktivaciji (opciono)",
  "placeholder": "Npr. Povratak sa bolovanja, novi ugovor...",
  "warning_login": "Korisnik će odmah dobiti pristup sistemu.",
  "confirm_btn": "Aktiviraj",
  "cancel_btn": "Odustani",
  "success_activate": "Radnik je ponovo aktivan!",
  "history_title": "Historija Deaktivacije",
  "deactivated_on": "Deaktiviran dana:",
  "previous_reason": "Prethodni razlog:",
  "no_history": "Nema prethodnih podataka o deaktivaciji"
},

"not_active_page": {
  "title": "Pristup Onemogućen",
  "message": "Vaš pristup sistemu je trenutno deaktiviran od strane administracije.",
  "contact": "Ako mislite da je ovo greška, kontaktirajte vašeg nadređenog.",
  "back_home": "Vrati se na početnu"
},

"pricing": {
    "monthly": "Mjesečno",
    "annual": "Godišnje",
    "save_discount": "Uštedite 20%",
    "month": "mjesec",
    "year": "godina",
    "popular": "Popularno",
    "choose_plan": "Odaberi paket",
    "what_you_get": "Šta dobijate u paketu:",
    "confirm": "Potvrdi i nastavi",
    "close": "Zatvori",
    "basic_features": [
      "Do 10 uposlenika",
      "HR Arhiva (Platne liste, ugovori, obuke)",
      "Rotirajući QR sistem evidencije rada",
      "Modul za Klijente i Dobavljače",
      "Notifikacije za isteke dokumenata"
    ],
    "premium_features": [
      "Do 50 uposlenika",
      "Sve iz Basic paketa",
      "Audit Log sistem (Praćenje preuzimanja)",
      "Upravljanje za više lokacija/odjela",
      "Prioritetna podrška"
    ],
    "enterprise_features": [
      "Neograničeno uposlenika",
      "Sve iz Premium paketa",
      "Custom API pristup i integracije",
      "Namjenski account menadžer",
      "Onboarding i postavljanje na licu mjesta"
    ],
    "descriptions": {
      "Basic": "Idealno za manje firme i obrte. Uključuje kompletnu HR arhivu, napredni rotirajući QR sistem za evidenciju radnih sati, te modul za klijente i dobavljače.",
      "Premium": "Savršeno za brzorastuće kompanije. Uključuje napredni Audit Log za praćenje pristupa dokumentima i podršku za više odvojenih lokacija.",
      "Enterprise": "Potpuna prilagođenost za velike sisteme sa neograničenim brojem radnika, posvećenim menadžerom i direktnim API integracijama."
    },
   "badge_text": "Besplatni probni period",
  "free_trial_btn": "Započni 30 dana besplatnog probnog perioda",
  "free_trial_subtitle": "Nije potrebna kreditna kartica. Podešavanje za samo 2 minute.",
  "start_test_btn": "Započni testiranje"
  },

"test_page": {
  "back": "Nazad na ponude",
  "title": "Besplatan Probni Period",
  "subtitle": "Isprobajte OrizonDesk 30 dana potpuno besplatno",
  "success_title": "Zahtjev uspješno poslan!",
  "success_desc": "Hvala na interesovanju. Poslali smo vam email sa linkom za aktivaciju računa. Molimo provjerite vaš inbox.",
  "basic_info": "Do 10 uposlenika • 5GB cloud memorije • Svi moduli uključeni",
  "gratis": "30 dana besplatno",
  "label_name": "Ime",
  "label_surname": "Prezime",
  "label_company": "Naziv kompanije",
  "label_email": "Poslovni email",
  "label_phone": "Broj telefona",
  "label_note": "Dodatna napomena (Opcionalno)",
  "placeholder_name": "Npr. Marko",
  "placeholder_surname": "Npr. Marković",
  "placeholder_company": "Npr. Orizon AIX d.o.o.",
  "placeholder_email": "ime@kompanija.ba",
  "placeholder_phone": "+387 61 000 000",
  "placeholder_note": "Imate li specifične zahtjeve?",
  "terms_part1": "Prihvatam",
  "terms_link": "uslove korištenja",
  "terms_part2": "i obradu podataka.",
  "btn_send": "Aktiviraj besplatni period",
  "footer_note": "OrizonDesk zadržava pravo provjere podataka prije odobravanja probnog perioda.",
  "brand_subtitle": "OrizonDesk Digitalni Sistemi",
  "error_email_exists": "Ovaj email je već registrovan. Molimo prijavite se ili koristite drugi email."
},


  "common1": {
    "back": "Nazad"
  },
  "status": {
    "section_title": "Status Resursa i Pretplata",
    "section_subtitle": "Pregled trenutne potrošnje i ograničenja vašeg sistema.",
    "employees_label": "Uposlenici",
    "storage_label": "Cloud Memorija",
    "expires_in": "Preostalo vrijeme licence",
    "upgrade_btn": "NADOGRADI PLAN",
    "current_plan": "Trenutni Plan",
    "days_suffix": "Dana",
    "history_btn": "Historija Plaćanja",
    "trash_btn":  "Oslobodi memoriju"
  },

  "upgrade": {
  "modal_title": "Nadogradnja Paketa",
  "current_status": "Trenutni status",
  "recommended": "Preporučeno",
  "premium_title": "Premium Paket",
  "premium_price": "450 KM / god.",
  "premium_subtitle": "Do 50 uposlenika i napredne opcije",
  "enterprise_title": "Enterprise Paket",
  "enterprise_price": "1200 KM / god.",
  "enterprise_subtitle": "Neograničeno uposlenika i API pristup",
  "feat_audit": "Audit Log sistem",
  "feat_support": "Prioritetna podrška",
  "feat_api": "Custom API pristup",
  "feat_manager": "Namjenski menadžer",
  "select_btn": "ODABERI",
  "divider_text": "ili prilagodi ručno",
  "cloud_storage": "Cloud Pohrana",
  "employee_count": "Broj uposlenika",
  "license_duration": "Trajanje Licence",
  "unlimited": "NEOGRANIČENO",
  "year_one": "GODINA",
  "year_multi": "GODINE",
  "send_request": "POŠALJI ZAHTJEV ZA PONUDU",
  "success_title": "Zahtjev poslan",
  "success_thanks": "Hvala Vam na povjerenju.",
  "success_desc_1": "Naš tim će analizirati Vašu konfiguraciju i kontaktirati Vas u",
  "success_desc_2": "najkraćem mogućem roku",
  "success_desc_3": "radi finalizacije ponude.",

    "modal_title": "Upravljanje Planom",
    "current_status": "Trenutni plan",
    "current_expires": "Ističe",
    "current_workers": "Aktivnih radnika",
    "current_storage": "Zauzeto prostora",
    "tab_upgrade": "Nadogradnja",
    "tab_renew": "Produženje",
    "tab_custom": "Custom Ponuda",
    "recommended": "Preporučeno",
    "recommended_renewal": "Obnovi isti plan",
    "plan_basic_title": "Basic Paket",
    "plan_basic_price": "150 KM / god.",
    "plan_basic_workers": "10 uposlenika",
    "plan_basic_storage": "5GB Cloud",
    "plan_basic_feat1": "QR Code Badge",
    "plan_basic_feat2": "Email podrška",
    "plan_premium_title": "Premium Paket",
    "plan_premium_price": "450 KM / god.",
    "plan_premium_workers": "50 uposlenika",
    "plan_premium_storage": "15GB Cloud",
    "plan_premium_feat1": "Audit Log sistem",
    "plan_premium_feat2": "Prioritetna podrška",
    "plan_enterprise_title": "Enterprise Paket",
    "plan_enterprise_price": "1200 KM / god.",
    "plan_enterprise_workers": "Neograničeno",
    "plan_enterprise_storage": "100GB Cloud",
    "plan_enterprise_feat1": "Custom API pristup",
    "plan_enterprise_feat2": "Namjenski menadžer",
    "pay_now": "Plati odmah",
    "select_plan": "Odaberi ovaj plan",
    "current_plan_badge": "Trenutni plan",
    "downgrade_badge": "Downgrade",
    "upgrade_badge": "Upgrade",
    "review_title": "Pregled promjene plana",
    "review_from": "Trenutni plan",
    "review_to": "Novi plan",
    "review_workers": "Uposlenici",
    "review_storage": "Cloud pohrana",
    "review_price": "Cijena",
    "review_period": "Period",
    "review_period_val": "365 dana",
    "review_proceed": "Nastavi na plaćanje",
    "review_back": "← Nazad na odabir",
    "downgrade_error_title": "Downgrade nije moguć",
    "downgrade_error_workers": "Trenutno imate {current} registrovanih radnika. {plan} paket prima max {max} radnika. Molimo obrišite radnike iz kompanije prije prelaska.",
    "downgrade_error_storage": "Trenutno koristite {current}GB pohrane. {plan} paket nudi max {max}GB. Molimo oslobodite prostor brisanjem dokumenata (uključujući iz smeća) prije prelaska.",
    "downgrade_error_both": "Imate previše radnika ({workers}) i zauzeto previše pohrane ({storage}GB) za odabrani plan.",
    "divider_text": "ili prilagodi ručno",
    "custom_title": "Custom Konfiguracija",
    "custom_subtitle": "Odaberite parametre i naš tim će vam poslati ponudu",
    "cloud_storage": "Cloud Pohrana",
    "employee_count": "Broj uposlenika",
    "license_duration": "Trajanje Licence",
    "unlimited": "NEOGRANIČENO",
    "year_one": "GODINA",
    "year_multi": "GODINE",
    "send_request": "POŠALJI ZAHTJEV ZA PONUDU",
    "success_title": "Zahtjev poslan!",
    "success_thanks": "Hvala Vam na povjerenju.",
    "success_desc_1": "Naš tim će analizirati Vašu konfiguraciju i kontaktirati Vas u",
    "success_desc_2": "najkraćem mogućem roku",
    "success_desc_3": "radi finalizacije ponude.",
    "renewal_success_title": "Uplata u obradi",
    "renewal_success_desc": "Vaš plan će biti ažuriran čim uplata bude potvrđena. Email potvrda stiže na vašu adresu.",
    "feat_audit": "Audit Log sistem",
    "feat_support": "Prioritetna podrška",
    "feat_api": "Custom API pristup",
    "feat_manager": "Namjenski menadžer",
    "select_btn": "ODABERI",
    "premium_title": "Premium Paket",
    "premium_price": "450 KM / god.",
    "premium_subtitle": "Do 50 uposlenika i napredne opcije",
    "enterprise_title": "Enterprise Paket",
    "enterprise_price": "1200 KM / god.",
    "enterprise_subtitle": "Neograničeno uposlenika i API pristup",
    "loading_check": "Provjera podataka ...",
    "error_fetch": "Greška pri učitavanju podataka. Pokušajte ponovo.",
    "checkout_error": "Greška pri otvaranju plaćanja. Pokušajte ponovo.",
    "plan_basic_price_km":      "150 KM ",
"plan_premium_price_km":    "450 KM",
"plan_enterprise_price_km": "1200 KM",
 "billing_annual": "Godišnje",
    "billing_monthly": "Mjesečno",
    "review_period_annual": "365 dana",
    "review_period_monthly": "30 dana",
    "receipt_cycle": "Obračunski ciklus",
    "plan_basic_price_km_monthly":      "15.99 KM",
  "plan_premium_price_km_monthly":    "44.99 KM",
  "plan_enterprise_price_km_monthly": "119.99 KM",
  "plan_basic_price_eur_monthly":     "7.99 €",
  "plan_premium_price_eur_monthly":   "44.99 €",
  "plan_enterprise_price_eur_monthly":"119.99 €"
    

  },
  "renewal_success": {
    "loading": "Obrada plaćanja ...",
    "title": "Plan Ažuriran!",
    "subtitle": "Vaš plan je uspješno",
    "subtitle2": "ažuriran. Potvrda je poslana na email.",
    "badge_renewed": "Plan obnovljen",
    "badge_upgraded": "Plan nadograđen",
    "badge_downgraded": "Plan smanjen",
    "receipt_title": "Potvrda Promjene",
    "receipt_payment_id": "Payment ID",
     "receipt_cycle": "Obračunski ciklus",
    "receipt_plan": "Plan",
    "receipt_valid": "Vrijedi do",
    "receipt_status": "Status",
    "receipt_status_val": "Aktivno",
    "btn_home": "Idi na Dashboard",
    "error_title": "Greška pri ažuriranju",
    "error_subtitle": "Uplata uspješna, ali plan nije ažuriran. Kontaktirajte podršku.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Greška",
    "error_contact": "Kontaktirajte nas na",
    "error_status_failed": "Uplata neuspješna. Status:"
  },

"invite_setup": {
  "title": "Pozvani ste!",
  "desc": "Završite podešavanje vašeg računa postavljanjem lozinke",
  "new_password": "Kreiraj lozinku",
  "confirm_password": "Potvrdi lozinku",
  "button": "Aktiviraj moj račun",
  "success": "Račun uspješno aktiviran! Dobrodošli u tim.",
  "error_match": "Lozinke se ne podudaraju",
  "error_too_short": "Lozinka mora imati najmanje {{min}} karaktera",
  "passwords_match": "Lozinke se podudaraju",
  "error_session_title": "Nevažeći ili istekao link",
  "error_session_expired": "Ovaj link za pozivnicu više nije važeći ili je već iskorišten. Zamolite svog administratora da vam pošalje novu pozivnicu.",
  "back_to_login": "Nazad na prijavu"
},

"company_inactive": {
  "title": "Kompanija nije aktivna",
  "desc": "Pristup OrizonDesk-u za vašu kompaniju je obustavljen. Razlog je obično istek probnog perioda ili pretplate.",
  "contact_support": "Kontaktiraj Podršku",
  "renew_btn": "Produži Pretplatu",
  "renew_hint": "Samo administratori mogu produžiti pretplatu"
},

"userLog": {
  "noPermission": "Nemate dozvolu za pristup audit logovima.",
  "back": "Nazad",
  "loadMore": "Prikaži više",
  "title": "Audit log aktivnosti",
  "subtitle": "Praćenje aktivnosti korisnika, preuzimanja dokumenata i sistemskih promjena",
  "table": {
    "time": "Vrijeme akcije",
    "user": "Korisnik (Izvršilac)",
    "action": "Akcija / Tip",
    "document": "Dokument / Fajl",
    "device": "Uređaj",
    "noActivity": "Nema zabilježenih aktivnosti",
    "system": "Sistem"
  },
  "footer": {
    "gdprNote": "Ovaj log je nepromjenjiv i služi kao zvanični dokaz o pristupu osjetljivim dokumentima u skladu sa GDPR regulativama.",
    "policy": "Audit politika",
    "status": "Aktivno praćenje"
  }
},


  "payments": {
    "no_permission": "Nemate dozvolu za pristup historiji plaćanja.",
    "back": "Nazad",
    "title": "Historija Uplata & Licenci",
    "subtitle": "Pregled transakcija, aktivnih licenci i administrativnih podataka",
    "table": {
      "period": "Period Važenja",
      "admin_email": "Admin / Email",
      "package_id": "Paket & ID",
      "amount": "Iznos",
      "status_pdf": "Status / PDF",
      "from": "Uplaćeno:",
      "to": "Ističe:",
      "paid_by": "Uplatio",
      "online": "Online",
      "no_transactions": "Nema zabilježenih transakcija"
    },
    "footer": {
      "note": "Sve licence se automatski aktiviraju odmah nakon potvrde uplate. Za R1 račune ili dodatna pitanja, kontaktirajte podršku sa ID-om transakcije.",
      "system_status": "Sistem Status",
      "verified": "Verified & Secured"
    }
  },

  
  "legal": {
    "back": "Nazad",
    "title_part1": "Pravno &",
    "title_part2": "Usklađenost",
    "header_subtitle": "Orizon Desk Portal • Infrastruktura i Privatnost • v1.2.5 • 2026",
    "stats": {
      "residency": "Lokacija Podataka",
      "storage": "Infrastruktura Baze Podataka",
      "encryption": "Standard Enkripcije",
      "gdpr": "GDPR Usklađenost",
      "db": "Baza Podataka",
      "security": "Sigurnosni Protokol",
      "monitoring": "Nadzor",
      "identity": "Identitet"
    },
    "stats_vals": {
      "residency": "Cirih (CH) Švajcarska",
      "gdpr": "Puni EU Standardi"
    },
 "section01": {
      "title": "Uslovi i Pravila",
      "subtitle": "SaaS Ugovor i Garancije Vojnog Nivoa Integriteta",
      "p1_part1": "Orizon Desk je zatvoreni digitalni ekosistem, regulisan strogim sigurnosnim protokolima. Pristup je ograničen isključivo na ovlašteno osoblje i svaka interakcija je zaštićena arhitekturom",
      "p2_part1": "U cilju osiguranja maksimalne zaštite, sistem konstantno nadzire pristupne tačke:",
      "p2_bold": "svaka sesija se povezuje sa IP adresom korisnika",
      "p2_part2": "kako bi se spriječili eksterni upadi, brute-force napadi ili neovlašteno korištenje akreditiva sa nepoznatih lokacija.",
      "p3": "Orizon AIX se obavezuje na dostupnost usluge od 99.9%. Podaci sadržani u portalu tretiraju se sa najvišim nivoom industrijske povjerljivosti.",
      "integrity_title": "Integritet Sistema",
      "integrity_bold": "Koristimo vojne sigurnosne protokole",
      "integrity_desc": "kako bismo spriječili krađu identiteta ili gubitak podataka. Integritet je garantovan checksum algoritmima koji stalno provjeravaju da nijedan fajl nije izmijenjen, čak ni slučajno.",
      "feature1_title": "Bcrypt Hashing Lozinki",
      "feature1_desc": "Lozinke se nikada ne spremaju u čistom tekstu, što čini dekripciju nemogućom čak i u slučaju direktnog pristupa bazi podataka.",
      "feature2_title": "SSL/TLS 1.3",
      "feature2_desc": "Svaki bit informacije koji putuje između Vašeg browsera i naših servera u Cirihu zaštićen je najnaprednijim protokolom enkripcije dostupnim danas.",
      "user_resp_title": "Odgovornost Korisnika",
      "user_resp_desc": "Korisnik je čuvar svojih kredencijala. Orizon Desk implementira automatsko zaključavanje računa nakon 5 neuspjelih pokušaja i praćenje IP adrese radi otkrivanja napada.",
      "monitor_title": "Monitoring u Realnom Vremenu",
      "monitor_desc": "Naš sistem za detekciju prijetnji stalno analizira saobraćaj radi identifikacije sumnjivih obrazaca. Svaki preuzeti dokument generiše jedinstveni kriptografski timestamp."
    },
   
    "section02": {
      "title": "Politika Privatnosti",
      "subtitle": "Usklađenost sa EU Regulativom 2016/679 i Međunarodnim Standardima",
      "gdpr_text1": "U skladu sa Čl. 13 GDPR-a, obavještavamo vas da je obrada ličnih podataka usmjerena isključivo na upravljanje radnim odnosom i digitalizaciju kompanijske dokumentacije. Vaše podatke ne prodajemo niti dijelimo sa trećim stranama u komercijalne svrhe.",
      "gdpr_text2": "Obrađeni podaci uključuju: lične identifikatore, ugovorne podatke, bankovne koordinate (ako se nalaze na platnoj listi) i zapise o pristupu sistemu. Obrada je neophodna za ispunjenje zakonskih i ugovornih obaveza.",
      "cards": {
        "purpose_t": "Svrha",
        "purpose_d": "HR digitalizacija, arhiviranje platnih lista i jedinstvenih certifikata.",
        "retention_t": "Čuvanje",
        "retention_d": "Podaci se čuvaju 10 godina u skladu sa europskim fiskalnim propisima.",
        "security_t": "Sigurnost",
        "security_d": "Granularni pristup zasnovan na ulogama (RBAC). Administrator može vidjeti isključivo resurse koji su mu dodijeljeni."
      },
      "audit": {
        "header": "Potpuna Sljedivost: Šta je Log Audit?",
        "p1_part1": "Svaka pojedinačna radnja unutar Orizon Desk portala bilježi se u nepromjenjivi",
        "p1_part2": ". To znači da sistem kreira digitalnu \"crnu kutiju\" koja memorisuje: ko je pristupio, sa koje IP adrese, u koje vrijeme i koji dokument je pregledao ili preuzeo.",
        "p2_part1": "Ova funkcija je ključna za vašu sigurnost: garantuje",
        "p2_bold": "nemogućnost poricanja",
        "p2_part2": "radnji i omogućava provjeru u svakom trenutku da su osjetljivi dokumenti (poput platnih lista) pregledani isključivo od strane legitimnog vlasnika ili ovlaštenog HR osoblja, eliminišući rizik od skrivenog pristupa.",
        "tag1": "Nepromjenjivi Timestamp",
        "tag2": "Zaštita IP Praćenja",
        "tag3": "Transparentnost Pristupa Podacima"
      },
      "cookies": {
        "title": "Obavještenje o Kolačićima",
        "desc": "Orizon Desk Portal koristi isključivo \"Tehničke kolačiće\" neophodne za funkcionisanje sesije i sigurnost autentifikacije. Ne koristimo kolačiće za profilisanje niti reklamne trackere trećih strana (poput Facebook Pixela ili Google Analyticsa) kako bismo vam garantovali maksimalnu privatnost."
      }
       },

       "section03": {
      "title": "Infrastruktura & Cloud",
      "subtitle": "Lokacija podataka Cirih (Švicarska) i AWS S3 Tehnologija",
      "aws_title": "AWS S3 Skladištenje u Oblaku",
      "aws_desc_part1": "Svaki učitani fajl se hostuje na",
      "aws_desc_part2": "Podaci se ne nalaze na ranjivom fizičkom serveru, već u distribuiranoj infrastrukturi dizajniranoj za trajnost od 99,99%. Svaki fajl je pojedinačno kriptovan u mirovanju (At-Rest Encryption).",
      "swiss_title": "Zašto Švicarska (Cirih)?",
      "swiss_bold": "Cirih (Region: eu-central-2)",
      "swiss_desc_part1": "Naši serveri su smješteni u tehnološkom centru",
      "swiss_desc_part2": ". Švicarska nudi jedinstvenu političku i pravnu stabilnost, sa zakonima o zaštiti podataka koji dodatno proširuju GDPR zaštitu, osiguravajući da su poslovni dokumenti zaštićeni od vanjskih uticaja ili proizvoljnih zapljena.",
      "backup_title": "Operativni Kontinuitet & Backup",
      "backup_desc_part1": "Koristimo sistem",
      "backup_desc_part2": "koji omogućava vraćanje stanja podataka u bilo koji trenutak u prošlosti, garantujući zaštitu od ljudskih grešaka ili tehničkih kvarova. Svi dokumenti su arhivirani sa geografskom redundansom, a backupi su kriptovani",
      "backup_desc_part3": "ključevima kojima se upravlja putem AWS KMS-a.",
      "rls_title": "Segregacija Podataka RLS",
      "rls_desc_part1": "PostgreSQL baza podataka koristi",
      "rls_desc_part2": "tehnologiju. Ovo osigurava da je na nivou koda fizički nemoguće da korisnik jedne kompanije vidi zapise druge, čak i u slučaju aplikativne greške.",
      "cert_header": "Cloud Sertifikacije",
      "cert_iso": "Međunarodni standardi za upravljanje sigurnošću informacija u cloudu.",
      "cert_soc": "Sertifikacija internih kontrola sigurnosti, dostupnosti i povjerljivosti.",
      "cert_gdpr": "EU usklađenost za prenos i obradu osjetljivih ličnih podataka.",
      "cert_csa": "Najviši nivo specifične sigurnosti za pružaoce Cloud usluga (SaaS).",
      "cert_dr": "Dnevni geo-replicirani backupi za osiguranje kontinuiteta u svakom scenariju.",
      "quote": "Naša infrastruktura nije samo usklađena, ona je globalni lider u zaštiti HR podataka.",
      "click_hint": "Kliknite na bedževe iznad za provjeru zvaničnih sertifikacija provajdera."
    },
    "section04": {
  "title": "Vaša Prava",
  "subtitle": "Vršenje zakonskih ovlaštenja zagarantovanih GDPR-om",
  "rights": {
    "access_t": "Pravo na Pristup",
    "access_d": "Možete zatražiti potvrdu o obradi Vaših podataka i dobiti potpunu digitalnu kopiju.",
    "forget_t": "Pravo na Zaborav",
    "forget_d": "Zahtjev za trajno brisanje ličnih podataka po prestanku zakonske svrhe obrade.",
    "port_t": "Prenosivost",
    "port_d": "Preuzimanje dokumenata u strukturiranom formatu (PDF) radi prenosa drugom voditelju.",
    "limit_t": "Ograničenje",
    "limit_d": "Zahtjev za ograničenje obrade u slučaju osporavanja tačnosti podataka."
  },
  "exercise_text": "Za ostvarivanje bilo kojeg od navedenih prava ili za prijavu povrede privatnosti (Data Breach), ispitanik se može direktno obratiti Voditelju obrade putem namjenske e-mail adrese. Zahtjevi se obrađuju u roku od maksimalno 30 dana."
},
"footer": {
  "contact_label": "Kontakt za pravne upite",
  "locations": "Orizon AIX • Brescia, Italija • Cirih, CH",
  "update_tag": "Ažurirano Mart 2026",
  "disclaimer": "Ova dokumentacija podliježe godišnjoj reviziji. Nastavak korištenja platforme podrazumijeva automatsko prihvatanje svih uslova. Svaka bitna izmjena bit će komunicirana putem internog obavještenja.",
  "secured_switzerland": "Ponosno osigurano u Švicarskoj."
},
"section05": {
  "title": "Sigurnost Plaćanja",
  "subtitle": "Zaštita transakcija i zero-storage politika privatnosti",
  "points": {
    "stripe_t": "Zero-Storage Policy",
    "stripe_d": "Orizon DESK ne pohranjuje niti ima pristup podacima vaše kartice. Svi procesi su izolovani.",
    "pci_t": "PCI-DSS Standard",
    "pci_d": "Transakcije se vrše putem Dodo Payments, usklađenih sa najvišim bankarskim standardima.",
    "crypto_t": "SSL Enkripcija",
    "crypto_d": "Kompletna komunikacija je zaštićena 256-bitnom enkripcijom i PKI sigurnosnim protokolima.",
    "methods_t": "Metode Plaćanja",
    "methods_d": "Podržavamo VISA, MasterCard, Klarna, Amazon Pay, te biometrijsko plaćanje putem Google i Apple Pay-a."
  },
  "payment_text": "Sve novčane transakcije se obavljaju putem eksternih, visoko sigurnih gateway provajdera. Orizon Desk koristi vaše podatke isključivo za potrebe povezivanja unutar platforme, dok su finansijski podaci zaštićeni neprobojnim slojevima enkripcije trećih strana."
},
  "section06": {
      "title": "Povrat i Odustajanje",
      "subtitle": "Vaša prava prema EU direktivi 2011/83/EU — 14 dana garancija povrata",
      "intro": "OrizonDesk poštuje sva prava potrošača propisana europskim zakonodavstvom. Kupovinom bilo kojeg plana putem naše platforme, imate pravo na povrat sredstava u skladu s dolje navedenim uvjetima.",
      "points": {
        "period_t": "Period za odustajanje",
        "period_d": "Imate pravo odustati od ugovora u roku od 14 kalendarskih dana od datuma potvrde plaćanja, bez navođenja razloga.",
        "how_t": "Kako podnijeti zahtjev",
        "how_d": "Pošaljite email na info@orizon-aix.com s predmetom 'ZAHTJEV ZA POVRAT' i navedite Payment ID transakcije. Odgovorit ćemo u roku od 48 sati.",
        "conditions_t": "Uvjeti za povrat",
        "conditions_d": "Povrat je moguć ako nalog nije aktivno korišten za dodavanje uposlenika, dokumenata ili podataka kompanije nakon aktivacije.",
        "timeline_t": "Rok isplate povrata",
        "timeline_d": "Nakon odobrenja zahtjeva, sredstva se vraćaju na originalnu metodu plaćanja u roku od 5–10 radnih dana."
      },
      "exceptions_title": "Izuzeci od prava na povrat",
      "exceptions_desc": "Pravo na odustajanje ne primjenjuje se ako je digitalna usluga u potpunosti aktivirana i korištena uz vašu izričitu suglasnost, u skladu s članom 16(m) Direktive 2011/83/EU. U slučaju aktivne upotrebe platforme, procijenit ćemo zahtjev individualno i po potrebi ponuditi djelomični povrat ili produženje pretplate.",
      "contact_block": "Za sva pitanja vezana uz povrat sredstava, kontaktirajte nas na info@orizon-aix.com ili putem obrasca za podršku unutar platforme. Svaki zahtjev se obrađuje individualno i s punom transparentnošću.",
      "eu_note": "Ova politika je u skladu s EU Direktivom 2011/83/EU o pravima potrošača i Zakonom o zaštiti korisnika EU."
    }
      
  },

  "trash": {
    "title": "Kanta za Dokumente",
    "subtitle": "Upravljajte obrisanim fajlovima: vratite ih ili trajno obrišite",
    "placeholder_search": "Pretraži fajl ili korisnika...",
    "filter_all": "Sve",
    "filter_today": "Danas",
    "filter_7days": "7 dana",
    "table_doc": "Dokument",
    "table_size": "Veličina",
    "table_owner": "Vlasnik",
    "table_removed_by": "Uklonio",
    "table_date": "Datum i Vrijeme",
    "table_actions": "Akcije",
    "no_files": "Nema pronađenih fajlova",
    "total": "Ukupno",
    "info_auto_on": "Automatsko brisanje je AKTIVNO. Fajlovi stariji od 30 dana će biti automatski uklonjeni.",
    "info_auto_off": "Fajlovi će ostati u kanti dok se ručno ne obrišu.",
    "modal_restore_title": "Vratiti fajl?",
    "modal_delete_title": "Trajno obrisati?",
    "modal_restore_desc": "Želite li vratiti fajl {{name}} korisnika {{owner}}?",
    "modal_delete_desc": "Jeste li sigurni da želite trajno obrisati fajl {{name}} korisnika {{owner}}? Ova akcija je nepovratna.",
    "modal_cancel": "Odustani",
    "modal_confirm": "Potvrdi"
  },
  "settings_trash": {
    "delete_label": "Auto-brisanje",
    "days_30": "30 Dana"
  },

  
  "premium_payments": {
    "back": "Nazad",
    "badge": "OrizonDesk PREMIUM",
    "price": "450 KM",
     "price_monthly": "44.99 KM",
    "price_period": "/ GODIŠNJE",
    "price_period_monthly": "/ MJESEČNO",
    "feature_employees": "50 Uposlenika",
    "feature_cloud": "15GB Cloud",
    "feature_audit": "Audit Logs",
    "feature_support": "Prioritetna podrška",

    "step1": {
      "title": "Faktura i Podaci",
      "subtitle": "Popunite formu za aktivaciju Premium Paketa",
      "label_name": "Ime",
      "label_surname": "Prezime",
      "label_company": "Naziv Kompanije",
      "label_email": "Email",
      "label_phone": "Telefon",
      "placeholder_name": "Vaše ime",
      "placeholder_surname": "Vaše prezime",
      "placeholder_company": "Naziv firme",
      "placeholder_email": "admin@kompanija.ba",
      "placeholder_phone": "+387",
      "terms_part1": "Prihvatam",
      "terms_link": "Uslove korištenja",
      "terms_part2": "i Politiku privatnosti",
      "btn_next": "Nastavi na plaćanje",
      "error_generic": "Došlo je do greške.",
      "error_email_exists": "Ovaj email je već registrovan u bazi.",
      "error_server": "Serverska greška. Pokušajte kasnije."
    },

    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "PREMIUM PAKET za",
      "total_label": "UKUPNO ZA UPLATU:",
      "total_amount": "450.00 KM",
       "total_amount_monthly": "44.99 KM",
      "summary_title": "Pregled podataka",
      "summary_name": "Ime i prezime",
      "summary_company": "Firma",
      "summary_email": "Email",
      "summary_phone": "Telefon",
      "summary_package": "Paket",
      "summary_package_value": "Premium — 365 dana",
       "summary_package_value_monthly": "Premium — 30 dana",
      "btn_pay": "Nastavi plaćanje — 450 KM",
       "btn_pay_monthly": "Nastavi plaćanje — 44.99 KM",
      "ssl_label": "Sigurno plaćanje putem Dodo Payments · SSL Encrypted",
      "btn_back": "← Nazad na izmjenu podataka",
      "loading": "Otvaranje sigurnog plaćanja ...",
      "error_checkout": "Greška pri plaćanju. Pokušajte ponovo.",
      "error_expired": "Sesija plaćanja je istekla. Pokušajte ponovo.",
      "error_open": "Greška pri otvaranju plaćanja. Pokušajte ponovo."
    },

    "footer_ssl": "Secure SSL Encrypted · Dodo Payments"
  },

  "payment_success": {
    "loading": "Aktivacija Premium Paketa ...",
    "badge": "OrizonDesk PREMIUM",
    "title": "Premium Aktiviran!",
    "subtitle": "Provjerite email",
    "subtitle2": "za pristupne podatke i aktivaciju naloga.",
    "receipt_title": "Potvrda Transakcije",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Paket",
    "receipt_package_value": "Premium — 365 dana",
     "receipt_package_value_monthly": "Premium — 30 dana",
    "receipt_status": "Status",
    "receipt_status_value": "Paid & Verified",
    "btn_home": "Idi na Početnu",
    "error_title": "Greška pri aktivaciji",
    "error_subtitle": "Uplata je uspješna, ali aktivacija nije završena.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Greška",
    "error_contact": "Sačuvajte Payment ID i kontaktirajte nas na",
    "error_status_failed": "Plaćanje nije uspjelo. Status:"
  },

  
  "basic_payments": {
    "back": "Nazad",
    "badge": "OrizonDesk BASIC",
    "price": "150 KM",
     "price_monthly": "15.99 KM",
    "price_period": "/ GODIŠNJE",
    "price_period_monthly": "/ MJESEČNO",
    "feature_employees": "10 Uposlenika",
    "feature_cloud": "5GB Cloud",
    "feature_qr": "QR Code Badge",
    "feature_support": "Email podrška",

    "step1": {
      "title": "Faktura i Podaci",
      "subtitle": "Popunite formu za aktivaciju Basic Paketa",
      "label_name": "Ime",
      "label_surname": "Prezime",
      "label_company": "Naziv Kompanije",
      "label_email": "Email",
      "label_phone": "Telefon",
      "placeholder_name": "Vaše ime",
      "placeholder_surname": "Vaše prezime",
      "placeholder_company": "Naziv firme",
      "placeholder_email": "admin@kompanija.ba",
      "placeholder_phone": "+387",
      "terms_part1": "Prihvatam",
      "terms_link": "Uslove korištenja",
      "terms_part2": "i Politiku privatnosti",
      "btn_next": "Nastavi na plaćanje",
      "error_generic": "Došlo je do greške.",
      "error_email_exists": "Ovaj email je već registrovan u bazi.",
      "error_server": "Serverska greška. Pokušajte kasnije."
    },

    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "BASIC PAKET za",
      "total_label": "UKUPNO ZA UPLATU:",
      "total_amount": "150.00 KM",
      "total_amount_monthly": "15.99 KM",
      "summary_title": "Pregled podataka",
      "summary_name": "Ime i prezime",
      "summary_company": "Firma",
      "summary_email": "Email",
      "summary_phone": "Telefon",
      "summary_package": "Paket",
      "summary_package_value": "Basic — 365 dana",
      "summary_package_value_monthly": "Basic — 30 dana",
      "btn_pay": "Nastavi plaćanje — 150 KM",
       "btn_pay_montlhy": "Nastavi plaćanje — 15.99 KM",
      "ssl_label": "Sigurno plaćanje putem Dodo Payments · SSL Encrypted",
      "btn_back": "← Nazad na izmjenu podataka",
      "loading": "Otvaranje sigurnog plaćanja ...",
      "error_checkout": "Greška pri plaćanju. Pokušajte ponovo.",
      "error_expired": "Sesija plaćanja je istekla. Pokušajte ponovo.",
      "error_open": "Greška pri otvaranju plaćanja. Pokušajte ponovo."
    },

    "footer_ssl": "Secure SSL Encrypted · Dodo Payments"
  },

  "basic_payment_success": {
    "loading": "Aktivacija Basic Paketa ...",
    "badge": "OrizonDesk BASIC",
    "title": "Basic Paket Aktiviran!",
    "subtitle": "Provjerite email",
    "subtitle2": "za pristupne podatke i aktivaciju naloga.",
    "receipt_title": "Potvrda Transakcije",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Paket",
    "receipt_package_value": "Basic — 365 dana",
    "receipt_package_value_monthly": "Basic — 30 dana",
    "receipt_status": "Status",
    "receipt_status_value": "Paid & Verified",
    "btn_home": "Idi na Početnu",
    "error_title": "Greška pri aktivaciji",
    "error_subtitle": "Uplata je uspješna, ali aktivacija nije završena.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Greška",
    "error_contact": "Sačuvajte Payment ID i kontaktirajte nas na",
    "error_status_failed": "Plaćanje nije uspjelo. Status:"
  },



  "enterprise_payments": {
    "back": "Nazad",
    "badge": "OrizonDesk ENTERPRISE",
    "price": "1200 KM",
    "price_monthly": "119.99 KM",
    "price_period": "/ GODIŠNJE",
   "price_period_monthly": "/ MJESEČNO",
    "feature_employees": "Neograničeno",
    "feature_cloud": "100GB Cloud",
    "feature_audit": "Napredni Audit",
    "feature_support": "Dedicated podrška",

    "step1": {
      "title": "Faktura i Podaci",
      "subtitle": "Popunite formu za aktivaciju Enterprise Paketa",
      "label_name": "Ime",
      "label_surname": "Prezime",
      "label_company": "Naziv Kompanije",
      "label_email": "Email",
      "label_phone": "Telefon",
      "placeholder_name": "Vaše ime",
      "placeholder_surname": "Vaše prezime",
      "placeholder_company": "Naziv firme",
      "placeholder_email": "admin@kompanija.ba",
      "placeholder_phone": "+387",
      "terms_part1": "Prihvatam",
      "terms_link": "Uslove korištenja",
      "terms_part2": "i Politiku privatnosti",
      "btn_next": "Nastavi na plaćanje",
      "error_generic": "Došlo je do greške.",
      "error_email_exists": "Ovaj email je već registrovan u bazi.",
      "error_server": "Serverska greška. Pokušajte kasnije."
    },

    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "ENTERPRISE PAKET za",
      "total_label": "UKUPNO ZA UPLATU:",
      "total_amount": "1200.00 KM",
       "total_amount_monthly": "119.99 KM",
      "summary_title": "Pregled podataka",
      "summary_name": "Ime i prezime",
      "summary_company": "Firma",
      "summary_email": "Email",
      "summary_phone": "Telefon",
      "summary_package": "Paket",
      "summary_package_value": "Enterprise — 365 dana",
      "summary_package_value_monthly": "Enterprise — 30 dana",
      "btn_pay": "Nastavi plaćanje — 1200 KM",
        "btn_pay_monthly": "Nastavi plaćanje — 119.99 KM",
      "ssl_label": "Sigurno plaćanje putem Dodo Payments · SSL Encrypted",
      "btn_back": "← Nazad na izmjenu podataka",
      "loading": "Otvaranje sigurnog plaćanja ...",
      "error_checkout": "Greška pri plaćanju. Pokušajte ponovo.",
      "error_expired": "Sesija plaćanja je istekla. Pokušajte ponovo.",
      "error_open": "Greška pri otvaranju plaćanja. Pokušajte ponovo."
    },

    "footer_ssl": "Secure SSL Encrypted · Dodo Payments"
  },

  "enterprise_payment_success": {
    "loading": "Aktivacija Enterprise Paketa ...",
    "badge": "OrizonDesk ENTERPRISE",
    "title": "Enterprise Aktiviran!",
    "subtitle": "Provjerite email",
    "subtitle2": "za pristupne podatke i aktivaciju naloga.",
    "receipt_title": "Potvrda Transakcije",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Paket",
    "receipt_package_value": "Enterprise — 365 dana",
     "receipt_package_value_monthly": "Enterprise — 30 dana",
    "receipt_status": "Status",
    "receipt_status_value": "Paid & Verified",
    "btn_home": "Idi na Početnu",
    "error_title": "Greška pri aktivaciji",
    "error_subtitle": "Uplata je uspješna, ali aktivacija nije završena.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Greška",
    "error_contact": "Sačuvajte Payment ID i kontaktirajte nas na",
    "error_status_failed": "Plaćanje nije uspjelo. Status:"
  },

"ferie": {
  "modal_title": "Zahtjev za Godišnji",
  "type_single_day": "Jedan Dan",
  "type_multi_day": "Više Dana",
  "type_hours": "Sati",
  "date_label": "Datum",
  "from_label": "Od",
  "to_label": "Do",
  "from_time_label": "Od Sata",
  "to_time_label": "Do Sata",
  "weekend_included": "Uključen Vikend",
  "type_label": "TIP",
  "shift_label": "Smjena",
  "shift_daily": "Cjelodnevno",
  "shift_first": "Prva Smjena",
  "shift_second": "Druga Smjena",
  "shift_third": "Treća Smjena",
  "shift_other": "Ostalo",
  "note_label": "Napomena (opcionalno)",
  "note_placeholder": "Dodaj napomenu...",
  "cancel_btn": "Otkaži",
  "submit_btn": "Pošalji Zahtjev",
  "new_request_btn": "Novi Zahtjev",
  "errors": {
    "select_date": "Odaberite datum.",
    "select_range": "Odaberite Od i Do.",
    "select_date_time": "Odaberite datum i vrijeme.",
    "submit_error": "Greška prilikom slanja zahtjeva."
  },
  "admin": {
    "page_title": "Upravljanje Godišnjim",
    "requests_title": "Zahtjevi za Godišnji Zaposlenih",
    "search_placeholder": "Pretraži zaposlenog...",
    "all_statuses": "Svi Statusi",
    "approve_btn": "Odobri",
    "reject_btn": "Odbij",
    "edit_btn": "Izmijeni",
    "save_changes": "Sačuvaj Izmjene",
    "new_request_title": "Novi Zahtjev (Godišnji)",
    "select_employee_label": "Zaposleni",
    "select_employee_placeholder": "Odaberite zaposlenog...",
    "auto_accept_notice": "Ovaj zahtjev će biti sačuvan kao već prihvaćen.",
    "errors": {
      "select_employee": "Odaberite zaposlenog."
    }
  },


  "my_requests_title": "Moji Zahtjevi za Godišnji",
  "all_years": "Sve Godine",
  "all_months": "Svi Mjeseci",
  "reset_btn": "Reset",
  "no_requests": "Nema poslanih zahtjeva",
  "days_label": "dana",
  "details_tooltip": "Detalji",
  "load_more_btn": "Učitaj Više",
  "details_title": "Detalji Zahtjeva",
  "time_label": "Vrijeme",
  "days_column_label": "Ukupno dana",
  "yes": "Da",
  "no": "Ne",
  "timeline_title": "Historija",
  "timeline_sent": "Zahtjev poslan",
  "timeline_answered_by": "Odgovorio",
  "timeline_answer_date": "Datum odgovora",
  "delete_btn": "Obriši Zahtjev",
  "delete_confirm_text": "Jeste li sigurni? Ova akcija je nepovratna.",
  "confirm_delete_btn": "Potvrdi Brisanje",
  "status_accepted": "Prihvaćeno",
  "status_rejected": "Odbijeno",
  "status_pending": "Na Čekanju",
  "months": {
    "01": "Januar", "02": "Februar", "03": "Mart", "04": "April",
    "05": "Maj", "06": "Juni", "07": "Juli", "08": "August",
    "09": "Septembar", "10": "Oktobar", "11": "Novembar", "12": "Decembar"
  }
},


  "inventory": {
    "back": "Nazad",
    "new_table": "Nova Tabela",
    "title": "Inventar i Magacin",
    "subtitle": "Upravljajte svojim resursima i kreirajte prilagođene zapise.",
  "stats": {
        "total": "Tabele",
        "total_desc": "Aktivnih tabela",
        "records": "Zapisi",
        "records_desc": "Ukupno redova u svim tabelama",
        "last_update": "Ažurirano",
        "last_update_desc": "Datum posljednjeg unosa"
    },
    "active_tables": "Aktivne Tabele",
    "open_record": "Otvori evidenciju",
    "no_tables": {
      "title": "Nema kreiranih tabela",
      "desc": "Kreirajte svoju prvu prilagođenu tabelu inventara kako biste počeli unositi podatke.",
      "btn": "Počni sada"
    }
  },

  "inventory_table": {
    "back": "Nazad",
    "search_placeholder": "Pretraži...",
    "btn_new_entry": "Novi Unos",
    "export_excel": "Izvezi tabelu u Excel (.xlsx)",
    "settings_title": "Postavke kolona i tabele",
    "add_row_title": "Dodaj novi red u tabelu",
    "actions": "Akcije",
    "loading": "Učitavanje...",
    "confirm_delete_row": "Obrisati ovaj red?",
    "confirm_delete_column": "Obrisati kolonu \"{{name}}\"?",
    "error_prefix": "Greška: ",
    "table_default_name": "Tabela",
    "status_true": "Tačno",
    "status_false": "Netačno"
  },

  
  "create_table_modal": {
    "title": "Nova Tabela",
    "system_info": "Sistem: AWS (Supabase) (ISO 8601)",
    "label_table_name": "Naziv Tabele",
    "placeholder_table_name": "npr. MAGACIN_A",
    "label_columns": "Konfiguracija Kolona",
    "placeholder_col_name": "Naziv polja",
    "label_dropdown": "Aktiviraj Dropdown",
    "btn_cancel": "Odustani",
    "btn_create": "Kreiraj Tabelu",
    "btn_creating": "Kreiranje...",
    "alert_empty_name": "Unesite naziv tabele!",
    "alert_error": "Greška: ",
    "types": {
      "text": "Tekst",
      "number": "Broj",
      "date": "Datum (GGGG-MM-DD)",
      "boolean": "Boolean (Tačno/Netačno)"
    }
  },

  "insert_line": {
    "header": {
      "title": "Novi Zapis",
      "loading_structure": "Učitavanje strukture baze podataka...",
      "table_label": "Tabela: "
    },
    "validation": {
      "invalid_date": "Mora biti GGGG-MM-DD",
      "invalid_number": "Mora biti broj"
    },
    "inputs": {
      "dropdown_placeholder": "Odaberite ili upišite...",
      "true": "TAČNO",
      "false": "NETAČNO"
    },
    "footer": {
      "cancel": "Odustani",
      "save": "Spremi"
    }
  },

  "settings_columns": {
    "title": "Konfiguracija Polja",
    "subtitle": "Direktno dodavanje u bazu podataka",
    "label_new_field": "Novo Polje",
    "placeholder_name": "Naziv nove kolone...",
    "label_dropdown": "Aktiviraj Dropdown",
    "btn_add": "Dodaj Polje",
    "btn_adding": "Dodavanje...",
    "label_existing_fields": "Postojeća Polja",
    "status_dropdown_on": "● Dropdown Aktivan",
    "status_dropdown_off": "○ Aktiviraj Dropdown",
    "btn_close": "Zatvori Postavke",
    "types": {
      "text": "Tekst",
      "number": "Broj",
      "date": "Datum (GGGG-MM-DD)",
      "boolean": "Boolean (Tačno/Netačno)"
    }
  },

  

  "update_info": {
    "header": {
      "edit_title": "Uredi Zapis",
      "view_title": "Detaljne Informacije",
      "edit_subtitle": "Izmjenite vrijednosti i sačuvajte",
      "view_subtitle": "Pregled zapisa iz tabele"
    },
    "types": {
      "boolean": "[ Boolean ]",
      "date": "[ Datum ]",
      "number": "[ Broj ]",
      "text": "[ Tekst ]"
    },

    
    
    "labels": {
      "negative_value": "Vrijednost je manja od nule",
      "last_update": "Posljednja izmjena",
      "active": "Aktivno (Tačno)",
      "inactive": "Neaktivno (Netačno)",
      "true": "TAČNO",
      "false": "NETAČNO"
    },
    "footer": {
      "cancel": "Odustani",
      "save_changes": "Sačuvaj Izmjene",
      "close_view": "Zatvori pregled"
    
    },
    

    
        }

        }
      },
      de: {
        translation: {
          "header": {
            "notifications": "Benachrichtigungen", "settings": "Einstellungen", "help": "Hilfe", "my_profile": "Mein Profil", "logout": "Abmelden", "change_lang": "Sprache ändern", "loading": "Laden..."
          },

          "auth": {
  "access_portal": "Portal-Zugang",
  "login": "Anmelden",
  "email": "E-Mail",
  "password": "Passwort",
  "forgot_password": "Passwort vergessen?",
  "errors": {
    "email_req": "E-Mail erforderlich",
    "pass_req": "Passwort erforderlich",
    "invalid_credentials": "E-Mail oder Passwort ist falsch"
  
},
"company_inactive": {
  "title": "Unternehmen nicht aktiv",
  "desc": "Der Zugang zu OrizonDesk für dieses Unternehmen wurde gesperrt. Dies geschieht in der Regel, wenn die Testphase beendet oder das Abonnement abgelaufen ist.",
  "contact_support": "Support kontaktieren"
},


  "reset_title": "Passwort zurücksetzen",
  "reset_desc": "Geben Sie Ihre E-Mail ein, um Anweisungen zu erhalten.",
  "send_link": "Reset-Link senden",
  "back_to_login": "Zurück zum Login",
  "success_msg": "E-Mail erfolgreich gesendet!",
  "update_password": {
    "title": "Neues Passwort",
    "desc": "Geben Sie unten Ihr neues Passwort ein.",
    "new_password": "Neues Passwort",
    "confirm_password": "Passwort bestätigen",
    "button": "Passwort aktualisieren",
    "success": "Passwort erfolgreich aktualisiert!",
    "error_match": "Passwörter stimmen nicht überein"
  }
},


          "hero": {
            "welcome": "Willkommen bei", 
            "subtitle": "Digitalisieren Sie Ihr Personalmanagement. Eliminieren Sie Papier und verwalten Sie Gehaltsabrechnungen und Dokumente in einem sicheren Portal.",
            "cta_button": "Zum Portal anmelden", "gdpr_note": "Gesichertes System, GDPR-konform für die digitale Aufbewahrung"
          },
          "cta": {
            "title": "Bringen Sie Ihr Unternehmen in die digitale Zukunft", 
            "description": "Schließen Sie sich Unternehmen an, die mit dem OrizonDesk Portal auf Papier verzichten.",
            "button_contact": "Orizon Team kontaktieren", "feature_card": "Sofortige Aktivierung", "feature_setup": "Setup in 5 Min.", "feature_support": "Technischer Support",
            "button_learn_more": "Was ist OrizonDesk?"
          },
          "features": {
            "main_title": "Warum mit OrizonDesk digital werden",
            "main_subtitle": "Die komplette SaaS-Lösung zur Eliminierung von Papierakten und Automatisierung der Dokumentenverteilung",
            "security_title": "Sicheres Archiv",
            "security_desc": "Gehaltsabrechnungen und sensible Dokumente sind durch Ende-zu-Ende-Verschlüsselung geschützt.",
            "speed_title": "Schnelle Verteilung",
            "speed_desc": "Sofortige Zustellung von Dokumenten an Mitarbeiter mit einem Klick, ohne Papierverschwendung.",
            "privacy_title": "Vollständige Compliance",
            "privacy_desc": "Vollständige Einhaltung der DSGVO und der geltenden Datenschutzbestimmungen.",
            "support_title": "Engagierter Support",
            "support_desc": "Spezialisierte Unterstützung beim Übergang Ihres Unternehmens von Papier zu Digital."
          },
            "footer": {
                "rights": "Alle Rechte vorbehalten.",
                "gdpr_text": "Konform mit der DSGVO und den Datenschutzbestimmungen",
                "privacy": "Datenschutz",
                "terms": "Nutzungsbedingungen",
                "contact": "Kontakt"
            },
            "landing": {
                "seo_title": "OrizonDesk - Sichere Authentifizierung | Dokumenten-Digitalisierung",
                "seo_description": "Sichere Plattform für die Verwaltung von Gehaltsabrechnungen und Geschäftsdokumenten. Papierloses Personalmanagement DSGVO-konform.",
                "footer_privacy": "Datenschutz",
                "footer_terms": "Nutzungsbedingungen",
                "footer_contact": "Kontakt",
                "footer_rights": "Alle Rechte vorbehalten.",
                "footer_gdpr": "Konform mit der DSGVO und den Datenschutzbestimmungen"
            },
            "testimonials": {
               "title": "Was unsere Kunden sagen",
               "subtitle": "Echte Erfahrungsberichte Unternehmen, die das OrizonDesk Portal für ihre sichere Mitarbeiterdokumentenverwaltung gewählt haben"
        },

        "dashboard": {
  "welcome_card": {
    "loading": "Laden...",
    "morning": "Guten Morgen",
    "afternoon": "Guten Tag",
    "evening": "Guten Abend",
    "subtitle": "Verwalten Sie die Dokumente von {{azienda}} in absoluter Sicherheit."
  }
},

"dipendente": {
  "welcome_card_dipendente": {
    "loading_dipendente": "Laden...",
    "morning_dipendente": "Guten Morgen",
    "afternoon_dipendente": "Guten Tag",
    "evening_dipendente": "Guten Abend",
    "subtitle_dipendente": "Greifen Sie sicher auf Ihre Dokumente von {{azienda}} zu und laden Sie diese herunter."
  }
},

"owner_welcome": {
  "loading": "Laden...",
  "morning": "Guten Morgen",
  "afternoon": "Guten Tag",
  "evening": "Guten Abend",
  "role_subtitle": "Sie sind als CEO von {{azienda}} angemeldet."
},


"create_company": {
    "back": "Zurück",
    "title": "Neues Unternehmen registrieren",
    "subtitle": "Geben Sie die Daten ein, um das neue Unternehmensportal zu erstellen",
    "admin_section": "Administrator-Daten",
    "company_section": "Unternehmensdaten",
    "plan_section": "Paket-Details",
    "success": "Unternehmen und Administrator erfolgreich registriert!",
    "button": "Unternehmen erstellen",
    "labels": {
      "name": "Vorname",
      "surname": "Nachname",
      "cf": "Steuernummer / ID",
      "phone": "Telefon",
      "email": "E-Mail für Login",
      "company_name": "Unternehmensname",
      "address": "Adresse",
      "vat": "USt-IdNr.",
      "plan": "Paket wählen",
      "start": "Vertrag von",
      "end": "Vertrag bis",
      "max_emp": "Max. Mitarbeiter:",
      "cloud_space": "Cloud-Speicher:"
    },
    "plans": {
      "basic": "BASIC (10 Mitarbeiter / 5GB)",
      "premium": "PREMIUM (50 Mitarbeiter / 15GB)",
      "enterprise": "ENTERPRISE (∞ Mitarbeiter / 100GB)"
    },
    "info": {
      "password_auto": "Die Steuernummer (ID) wird als initiales Passwort für den Zugang verwendet."
    },
    "errors": {
      "email_req": "E-Mail ist erforderlich",
      "cf_req": "Steuernummer ist erforderlich",
      "name_req": "Vorname ist erforderlich",
      "company_req": "Unternehmensname ist erforderlich",
      "date_req": "Ablaufdatum ist erforderlich"
    }
  },

"hero_owner": {
  "title": "Erweitern Sie Ihr Geschäft",
  "subtitle": "Erstellen Sie ein neues Unternehmen im Orizon-System. Sie können neue Mitarbeiter, Dokumente und Berechtigungen für jede einzelne Einheit verwalten.",
  "button": "Neues Unternehmen registrieren"
},


"home_superadmin": {
    "sections": {
      "quick_actions": "Schnellzugriffe"
    },
    "stats": {
      "active_sessions": "Meine Dokumente",
      "total_employees": "Mitarbeiter Gesamt",
      "pending_notif": "Ausstehende Benachrichtigungen",
      "total_aziende": "Unternehmen Gesamt",
      "avg_time": "TARIFSTATUS",
    "check_usage": "Ressourcenverbrauch prüfen",
      "vs_last_month": "im Vergleich zum Vormonat",
      
    },
    "actions": {
      "profile": { "title": "Profil verwalten", "desc": "Aktualisieren Sie Ihre persönlichen Daten" },
      "settings": { "title": "Systemeinstellungen", "desc": "Konfigurieren Sie die App-Einstellungen" },
      "create_employee": { "title": "Mitarbeiter registrieren", "desc": "Neues Mitarbeiterportal erstellen" },
      "support": { "title": "Hilfe & Support", "desc": "Dokumentation und Support kontaktieren" },
      "trash": { "title": "Papierkorb", "desc": "Gelöschte Dateien verwalten" },
      "holidays_management": { "title": "Urlaubsverwaltung", "desc": "Anträge der Mitarbeiter genehmigen oder ablehnen" },
      "inventory": { "title": "Inventarsystem", "desc": "Verwalten Sie Ihre Tabelle" 
}
    }
  },
  "home_dipendente": {
    "stats": {
      "my_documents": "Meine Dokumente",
      "monthly_hours": "Monatsstunden",
      "pending_notif": "Benachrichtigungen",
      "avg_session": "Durchschnittl. Sitzung",
      "vs_last_month": "im Vergleich zum Vormonat"
    },
    "actions": {
      "notifications": { "title": "Benachrichtigungszentrum", "desc": "Überprüfen Sie Ihre letzten Benachrichtigungen" }
    },
    "activities_title": "Kürzliche Aktivitäten",
    "activities_subtitle": "Ihre letzten Aktionen in der Anwendung",
    "no_activities": "Keine kürzlichen Aktivitäten zum Anzeigen",
    "activities": {
      "login_title": "Anmeldung erfolgt",
      "login_desc": "Sie haben sich von einem neuen Gerät aus angemeldet"
    }
  },
  


"create_employee": {
  "back": "Zurück",
  "title": "Neuen Mitarbeiter registrieren",
  "subtitle": "Der Benutzer wird automatisch verknüpft mit:",
  "section_title": "Persönliche Informationen",
  "labels": {
    "name": "Vorname",
    "surname": "Nachname",
    "cf": "Steuernummer / ID ",
    "email": "E-Mail",
    "phone": "Telefon",
    "role": "Benutzerrolle",
  },

  "roles": {
    "user": "Standard-Mitarbeiter (User)",
    "admin": "Unternehmensadministrator (Admin)"
  },

  "placeholders": {
    "cf": "ID eingeben"
  },
  "submit_btn": "Mitarbeiter-Portal erstellen",
  "success_msg": "Die Einladung zum Registrierungsportal wurde erfolgreich versendet.",
  "errors": {
    "email_req": "E-Mail ist erforderlich",
    "cf_req": "Steuernummer ist erforderlich",
    "name_req": "Vorname ist erforderlich",
    "no_company": "Fehler: Herkunftsunternehmen konnte nicht identifiziert werden.",
    "limit_title": "Limit erreicht",
"limit_reached": "Das Unternehmen hat das maximale Limit von {{max}} Mitarbeitern erreicht.",
"upgrade_now": "Status anzeigen und upgraden"
  }
},

"legal": {
  "back": "Zurückgehen",
  "title": "Rechtliche Informationen & Datenschutz",
  "version": "Orizon Desk Portal • Version 1.2.1 • 2026",
  "terms": {
    "title": "Nutzungsbedingungen",
    "p1": "Das Orizon Desk Portal ist eine geschlossene Geschäftsplattform, die ausschließlich für Mitarbeiter und das Management des Unternehmens bestimmt ist. Mit dem Zugriff auf das Portal verpflichtet sich der Nutzer zur Einhaltung der internen Regeln für die digitale Kommunikation.",
    "li1": "Die Weitergabe von Zugangsdaten (E-Mail und Passwort) an Dritte ist untersagt.",
    "li2": "Jeder Versuch eines unbefugten Zugriffs auf Systemteile, für die der Nutzer keine Berechtigung hat, wird als Verstoß gegen die Arbeitsdisziplin gewertet.",
    "li3": "Das Portal darf ausschließlich zur Einsichtnahme in persönliche Dokumente, Arbeitszeitnachweise und zur internen Firmenkommunikation genutzt werden."
  },
  "privacy": {
    "title": "Transparenz und Zugriff",
    "sub": "Wer hat Zugriff auf Ihre Dokumente?",
    "user_title": "Mitarbeiter",
    "user_desc": "Hat volle Einsicht in seine Lohnabrechnungen, CUD, ärztliche Bescheinigungen... Kann diese jederzeit einsehen und herunterladen.",
    "admin_title": "Administratoren",
    "admin_desc": "Autorisierte HR- und Buchhaltungsmitarbeiter können Dokumente hochladen, aktualisieren oder löschen. Dieser Zugriff ist für die digitale Verteilung der Dokumentation erforderlich.",
    "note": "Datenschutzhinweis: Die Administratoren des Unternehmens greifen ausschließlich im Rahmen ihrer beruflichen Pflichten auf Dokumente zu. Jeder Zugriff auf die Dokumentation wird systemseitig protokolliert, um Missbrauch zu verhindern."
  },
  "security": {
    "title": "Technischer Datenschutz",
    "enc_t": "Datenverschlüsselung",
    "enc_d": "Alle Dokumente werden während der Übertragung (SSL) und im Ruhezustand auf dem Server (AES-256) verschlüsselt. Ihr Passwort ist 'gehasht' und niemand kann es in seiner ursprünglichen Form sehen.",
    "infra_t": "Datenbank-Infrastruktur (AWS & Google Cloud)",
    "infra_d": "Die Daten werden auf Hochsicherheitsservern gespeichert, die den GDPR- und SOC2-Standards entsprechen. Wir verwenden Row-Level Security (RLS), um sicherzustellen, dass die Datenbank jede unbefugte Anfrage ablehnt."
  },
  "rights": {
    "title": "Ihre Rechte",
    "r1": "Recht auf Dateneinsicht",
    "r2": "Recht auf Berichtigung unrichtiger Informationen",
    "r3": "Recht auf Kontolöschung",
    "r4": "Recht auf Datenübertragbarkeit"
  },
  "contact_info": "Für weitere Informationen zu Ihren Rechten kontaktieren Sie bitte:",
  "rights_reserved": "© 2026 Orizon AIX. Alle Rechte vorbehalten."
},

"contact": {
  "back": "Zurückgehen",
  "title": "Kontaktieren Sie uns",
  "subtitle": "Haben Sie eine Frage? Wir sind hier, um zu helfen.",
  "success_title": "Erfolgreich gesendet!",
  "success_desc": "Ihre Nachricht wurde gesendet. Wir werden nam schnellstmöglich antworten.",
  "label_name": "Vor- und Nachname",
  "label_email": "E-Mail-Adresse",
  "label_subject": "Betreff",
  "label_message": "Ihre Nachricht",
  "placeholder_name": "Ihr Vor- und Nachname",
  "placeholder_subject": "Frage zum OrizonDesk-Portal...",
  "placeholder_message": "Geben Sie hier Ihre Anfrage ein...",
  "btn_send": "Nachricht senden",
  "info_email": "Direkte E-Mail",
  "info_web": "Webseite"
},

"categ": {
  "title": "Neue Kategorie",
  "title2": "Neue Kategorie",
  "name": "Kategoriename",
  "placeholder": "Namen eingeben...",
  "hint": "Verfügbar für alle Mitarbeiter dieses Unternehmens.",
  "error_duplicate": "Fehler: Diese Kategorie existiert bereits für dieses Unternehmen!",
  "error_generic": "Ein Fehler ist aufgetreten",
  "confirm_delete": "Sind Sie sicher, dass Sie diese Kategorie löschen möchten?",
  "manager_title": "Kategorien Verwalten",
  "add_new": "Neu Hinzufügen",
  "your_list": "Ihre Kategorien",
  "no_custom": "Keine benutzerdefinierten Kategorien",
  "error_delete": "Fehler beim Löschen",
  "input_placeholder": "Kategoriename...",
  "custom_list": "Benutzerdefinierte Kategorien:",
  "add": "Hinzufügen"
},


"profile": {
    "loading": "Laden...",
    "no_data": "Keine Daten gefunden.",
    "full_name": "Vollständiger Name",
    "email": "Geschäftliche E-Mail",
    "phone": "Telefonnummer",
    "not_specified": "Nicht angegeben",
    "cf": "Steuernummer",
    "role": "Rolle",
    "employee": "Mitarbeiter",
    "reg_date": "Registrierungsdatum",
    "last_access": "Letzter Zugriff",
    "first_session": "Erste Sitzung",
    "unique_id": "Eindeutige ID",
    "change_password": "Passwort ändern"
  },

  
  "profile_page": {
  "title": "Mein Profil",
  "back": "Zurück",
  "qr_badge": "Mein QR-Badge",
  "my_holidays": "Mein Urlaub"
},

 "change_password": {
    "title": "Passwort ändern",
    "subtitle": "Aktualisieren Sie Ihre Zugangsdaten",
    "security_section": "Kontosicherheit",
    "labels": {
      "old": "Aktuelles Passwort",
      "new": "Neues Passwort",
      "confirm": "Passwort bestätigen"
    },
    "errors": {
      "mismatch": "Passwörter stimmen nicht überein",
      "wrong_old": "Aktuelles Passwort ist falsch"
    },
    "success": "Passwort erfolgreich aktualisiert!",
    "submit_btn": "Änderungen speichern"
  },

 "dipendenti_list": {
  "loading": "Mitarbeiter werden geladen...",
  "title": "Personalverwaltung",
  "subtitle": "Unternehmensmitarbeiter anzeigen",
  "search_placeholder": "Mitarbeiter suchen...",
  "no_results": "Keine Mitarbeiter gefunden.",
  "filter_active": "Aktiv",
  "filter_inactive": "Inaktiv",
  "table": {
    "name": "Mitarbeiter",
    "email": "Email",
    "role": "Rolle",
    "actions": "Aktionen"
  }
},

"months": {
    "january": "Januar", "february": "Februar", "march": "März", "april": "April", "may": "Mai", "june": "Juni",
    "july": "Juli", "august": "August", "september": "September", "october": "Oktober", "november": "November", "december": "Dezember"
  },
  "timbrature": {
    "archive_title": "Archiv meiner Zeiterfassungen",
    "history_title": "Anwesenheitshistorie",
    "no_data": "Keine Zeiterfassungen für diesen Zeitraum gefunden.",
    "filters": {
      "month": "Monat",
      "year": "Jahr",
      "view": "Anzeigen",
      "loading": "Laden..."
    },
    "stats": {
      "ord": "Reguläre Stunden",
      "straord": "Überstunden",
      "monthly_total": "Monatssumme",
      "total": "Gesamt"
    },
    "table": {
      "name": "Vorname",
      "surname": "Nachname",
      "date": "Datum",
      "entry": "Eintritt",
      "exit": "Austritt",
      "ord_short": "Reg. (8h)",
      "straord_short": "Überst."
    }
  },

  "settings": {
  "title": "Einstellungen",
  "theme_title": "Personalisieren",
  "dark_mode": "Dunkelmodus",
  "light_mode": "Hellmodus",
  "subtitle": "Passen Sie Ihr Erlebnis an",
  "group_notifications": "Benachrichtigungen",
  "group_security": "Sicherheit & Zugang",
  "group_preferences": "App-Einstellungen",
  "push_label": "Push-Benachrichtigungen",
  "push_desc": "Echtzeit-Warnungen erhalten",
  "email_label": "Wöchentliche Berichte",
  "email_desc": "Stundenübersicht per E-Mail",
  "bio_label": "Biometrie",
  "delete_label": "Auto-Löschen",
  "delete_desc": "Dateien nach 30 Tagen automatisch aus dem Papierkorb löschen",
  "bio_desc": "FaceID/Fingerabdruck-Entsperrung",
  "logout_label": "Auto-Abmeldung",
  "logout_desc": "Nach 30 Min. Inaktivität beenden",
  "dark_label": "Dunkelmodus",
  "dark_desc": "Kontrastreiche Benutzeroberfläche",
  "gps_label": "GPS-Genauigkeit",
  "gps_desc": "Standortverfolgung verbessern",
  "version": "App-Version",
  "reset": "Alle Einstellungen zurücksetzen"
},


  "months": {
    "Gennaio": "Januar",
    "Febbraio": "Februar",
    "Marzo": "März",
    "Aprile": "April",
    "Maggio": "Mai",
    "Giugno": "Juni",
    "Luglio": "Juli",
    "Agosto": "August",
    "Settembre": "September",
    "Ottobre": "Oktober",
    "Novembre": "November",
    "Dicembre": "Dezember"
  },
  "myDocuments": {
    "title": "Dokumentenarchiv",
    "auditLogButton": "Aktivitätsprotokoll",
    "subtitle": "Ansehen und Herunterladen Ihrer Dokumente, Zertifikate und Gehaltsabrechnungen.",
    "backHome": "Zurück zur Startseite",
    "searchPlaceholder": "Dateiname, Typ, Kurs...",
    "searchLabel": "In Ihrem Archiv suchen",
    "filterAnno": "Jahr",
    "filterTipo": "Typ",
    "filterAll": "Alle",
    "table": {
      "document": "Dokument",
      "type": "Typologie",
      "details": "Details / Ablaufdatum",
      "download": "Download",
      "uploadedOn": "Hochgeladen am",
      "expires": "Läuft ab am",
      "noDocs": "Keine Dokumente gefunden."
    },
    "types": {
      "bustaPaga": "Gehaltsabrechnung",
      "cu": "Steuerbescheinigung (CU)",
      "contratto": "Vertrag",
      "visitaMedica": "Ärztliche Untersuchung",
      "certificatoCorso": "Kurszertifikat",
      "altro": "Anderes"
    }
  },

  "qrBadge": {
  "title": "Mein QR-Ausweis",
  "loading": "Daten werden geladen...",
  "instructions": "Zeigen Sie diesen Code dem Scanner <br /> um Ihre Anwesenheit zu registrieren",
  "notGenerated": "Ausweis noch nicht generiert",
  "contactAdmin": "Kontaktieren Sie die Verwaltung, um Ihren QR-Code zu aktivieren.",
  "download": "Bild herunterladen",
  "close": "Schließen"
},

"qrAdmin": {
  "title": "Firmenausweis",
  "sync": "Synchronisierung...",
  "notFound": "Ausweis nicht gefunden",
  "download": "Ausweis herunterladen",
  "regenerate": "Neu generieren",
  "generateNow": "Jetzt generieren",
  "confirmNew": "Möchten Sie einen neuen QR-Ausweis erstellen?",
  "confirmOverwrite": "Möchten Sie den vorhandenen Ausweis überschreiben?",
  "success": "Ausweis erfolgreich aktualisiert!",
  "securityError": "Fehler (Security Policy): Stellen Sie sicher, dass Ihr Konto über UPDATE-Berechtigungen im Storage verfügt."
},

"attendance": {
  "filterTitle": "Anwesenheitsregister",
  "month": "Monat",
  "year": "Jahr",
  "btnLoad": "Anwesenheit Laden",
  "loading": "Laden...",
  "history": "ANWESENHEITSHISTORIE",
  "noData": "Für den gewählten Zeitraum wurden keine Daten gefunden.",
  "stats": {
    "ord": "Gesamt Normal",
    "stra": "Gesamt Überstunden",
    "total": "Gesamtsumme"
  },
  "table": {
    "date": "Datum",
    "entry": "Eintritt",
    "exit": "Austritt",
    "ord_short": "Normal (8h)",
    "stra_short": "Überstunden",
    "total": "Gesamt"
  }
},

"company_modal": {
    "header_subtitle": "UNTERNEHMENSDATEN",
    "address_label": "ADRESSE",
    "registered_label": "REGISTRIERT AM"
  },


  "companies": {
    "title": "Unternehmensliste",
    "total": "Gesamt",
    "search_placeholder": "Firmen suchen...",
    "col_name": "Unternehmen",
    "col_actions": "Details",
    "no_data": "Keine Unternehmen gefunden."
  },
  "company_modal": {
    "header_subtitle": "UNTERNEHMENSDATEN",
    "address_label": "ADRESSE",
    "registered_label": "REGISTRIERT AM"
  },


  "orizon_desk": {
    "back": "Zurück zum Portal",
    "hero_title_1": "Was ist das",
    "hero_title_2": "OrizonDesk",
    "hero_title_3": "Portal?",
    "hero_subtitle": "Digitale Revolution im Personalmanagement",
    "main_desc_title": "Abschied vom Papier, willkommen in der Cloud",
    "main_desc_text": "OrizonDesk Portal ist eine zentrale digitale Plattform, die entwickelt wurde, um die Kommunikation zwischen Unternehmen und Mitarbeitern zu transformieren. Unser Ziel ist klar: vollständige Eliminierung von Papierdokumenten und Übergang zu einer sicheren, schnellen und transparenten digitalen Umgebung.",
    "for_companies": "Für Unternehmen",
    "for_companies_desc": "Automatisierung von HR-Prozessen, Datensicherheit und Zeitersparnis.",
    "for_workers": "Für Mitarbeiter",
    "for_workers_desc": "Sofortiger Zugriff auf persönliche Dokumente und Arbeitsnachweise über das Mobiltelefon.",
    "feature_1_title": "Digitales Archiv",
    "feature_1_li1": "Gehaltsabrechnungen",
    "feature_1_li2": "Zertifikate und Schulungen",
    "feature_1_li3": "Arbeitsverträge",
    "feature_1_li4": "HR-Mitteilungen",
    "feature_2_title": "Zeiterfassung",
    "feature_2_desc": "Stempelsystem per QR-Code. Mitarbeiter nutzen das Mobilgerät zum An- und Abmelden von der Arbeit.",
    "feature_2_li1": "Automatische Stundenberechnung",
    "feature_2_li2": "Überstundenerfassung",
    "feature_2_li3": "Stundenübersicht für Mitarbeiter",
    "cta_title": "Starten Sie heute mit der Digitalisierung",
    "cta_subtitle": "Das Verfahren ist einfach und schnell",
    "step_1_title": "Kontaktieren Sie uns",
    "step_1_desc": "Wählen Sie ein Paket basierend auf der Mitarbeiteranzahl und dem Cloud-Speicherbedarf.",
    "step_2_title": "Aktivierung der Firma",
    "step_2_desc": "Erhalten Sie Administrator-Zugangsdaten und erstellen Sie Mitarbeiterprofile.",
    "step_3_title": "Mitarbeiter sind bereit",
    "step_3_desc": "Mitarbeiter erhalten eine Bestätigungsmail, loggen sich ein und sehen sofort Dokumente und Stunden.",
    "footer_contact_text": "Kontaktieren Sie unser Team für ein Angebot",
    "footer_rights": "Alle Rechte vorbehalten."
  },


  "common": {
    "loading": "Laden...",
    "nd": "N/V",
    "read": "GELESEN",
  "unread": "UNGELSEN",
    "close": "SCHLIESSEN",
    "not_available": "Nicht verfügbar",
    "all": "Alle",
    "actions": "Aktionen",
    "annual": "Jährlich",
    "edit": "Bearbeiten",
    "save": "Speichern",
    "saving": "Wird gespeichert...",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "delete": "Löschen",
    "preview": "Vorschau",
    "download": "Herunterladen",
    "downloading": "Wird heruntergeladen...",
    "load_more": "Mehr laden",
    "nd": "N/A",
    "read": "GELESEN",
    "unread": "UNGELESEN",
    "yes": "Ja",
    "no": "Nein"
  },
  "employee": {
    "back_to_list": "Zurück zur Mitarbeiterliste",
    "generate_qr": "QR-Badge generieren",
    "info_title": "Mitarbeiterinformationen",
    "not_active": "Nicht Aktiv"
  },
  "docs": {
    "title": "Firmendokumente",
    "subtitle": "Digitale Verwaltung und Archivierung von Firmendokumenten",
    "new_upload": "Neuer Upload",
    "type": "Dokumententyp",
 "refid": "Referenznummer / ID",
    "refid_placeholder": "Z.B. CON-2026-001 oder Transaktionsnr.",
    "course_name": "Kursname",
    "course_placeholder": "Z.B: Arbeitssicherheit",
    "valid_from": "Gültig Von",
    "valid_to": "Gültig Bis",
    "notes": "Notizen / Beschreibung",
    "notes_placeholder": "Geben Sie an, worum es sich handelt...",
    "no_notes": "Keine Notizen hinzugefügt.",
    "year": "Jahr",
    "month": "Monat",
    "select_pdf_img": "PDF oder Bild auswählen",
    "upload_btn": "Dokument hochladen",
    "uploading": "Wird hochgeladen...",
    "filter_archive": "Archiv filtern",
    "search_placeholder": "Suche nach Name, Typ, Referenznr...",
    "list_title": "Liste der hochgeladenen Dokumente",
    "col_name": "Dokumentname",
    "col_type": "Typ",
    "col_ref": "Referenz-ID",
    "col_period": "Zeitraum / Gültigkeit",
    "col_date": "Hochladedatum",
    "expires": "Läuft ab",
    "no_docs_found": "Keine Dokumente für die ausgewählten Kriterien gefunden.",
    "select_file_alert": "Bitte wählen Sie eine Datei aus!",
    "missing_company": "Firmendaten fehlen.",
    "upload_success": "Dokument erfolgreich hochgeladen!",
    "upload_error": "Fehler beim Hochladen",
    "confirm_delete_title": "Löschung bestätigen",
    "confirm_delete": "Sind Sie sicher, dass Sie dieses Dokument dauerhaft löschen möchten? Dadurch wird die Datei auch aus dem Speicher entfernt.",
    "confirm_delete_category": "Möchten Sie diese Kategorie löschen?",
    "category_exists": "Diese Kategorie existiert bereits!",
    "category_error": "Fehler",
    "delete_success": "Dokument erfolgreich gelöscht!",
    "delete_error": "Fehler beim Löschen",
    "download_error": "Datei kann nicht herunterladen werden.",
    "preview_error": "Fehler beim Laden der Vorschau.",
    "update_success": "Dokument erfolgreich aktualisiert!",
    "update_error": "Fehler bei der Aktualisierung",
    "edit_modal_title": "Dokument bearbeiten",
    "info_modal_title": "Dokumentdetails",
    "edit_subtitle": "Parameter bearbeiten",
    "info_subtitle": "Datenübersicht",
    "types2": {
      "contract": "Vertrag",
      "course": "Zertifikat",
      "other": "Sonstiges"
    },
    "types": {
      "payslip": "Gehaltsabrechnung",
      "cu": "Steuerbescheinigung (CU)",
      "contract": "Vertrag",
      "medical": "Ärztliche Untersuchung",
      "course": "Kurszertifikat",
      "other": "Sonstiges"
    },
    "course_name": "Kursname",
    "course_placeholder": "Z.B.: Arbeitssicherheit",
    "valid_from": "Gültig ab",
    "valid_to": "Gültig bis",
    "notes": "Notizen / Beschreibung",
    "notes_placeholder": "Details angeben...",
    "year": "Jahr",
    "month": "Monat",
    "select_pdf_img": "PDF oder Bild auswählen",
    "upload_btn": "Dokument hochladen",
    "uploading": "Wird hochgeladen...",
    "filter_archive": "Archiv filtern",
    "search_placeholder": "Suche nach Name, Typ, Datum...",
    "list_title": "Liste der hochgeladenen Dokumente",
    "col_name": "Dokumentname",
    "col_type": "Typ",
    "col_period": "Zeitraum/Gültigkeit",
    "col_date": "Hochladedatum",
    "expires": "Läuft ab",
    "no_docs_found": "Keine Dokumente für die ausgewählten Kriterien gefunden.",
    "select_file_alert": "Bitte wählen Sie eine Datei aus!",
    "upload_success": "Dokument erfolgreich hochgeladen!",
    "upload_error": "Fehler beim Hochladen",
    "confirm_delete": "Sind Sie sicher, dass Sie dieses Dokument löschen möchten?",
    "delete_error": "Fehler beim Löschen",
    "download_error": "Datei kann nicht heruntergeladen werden."
  },

  "employee_modal": {
    "title_info": "Mitarbeiterinfo",
    "title_edit": "Mitarbeiter bearbeiten",
    "first_name": "Vorname",
    "last_name": "Nachname",
    "tax_code": "Steuernummer",
    "email": "Email",
    "phone": "Telefon",
    "created_at": "Erstellt am",
    "last_login": "Letzter Login",
    "never": "Nie",
    "alert_success": "Daten erfolgreich aktualisiert!",
    "alert_error": "Fehler beim Update"
  },

  "notifikacije": {
    "title_not": "ZU LESENDE DOKUMENTE",
    "empty": "ALLES GELESEN!",
    "view_all": "ZU MEINEN DOKUMENTEN GEHEN"
  },


  "sidebar": {
    "dashboard": "Übersicht",
    "profile": "Profil",
    "settings": "Einstellungen",
     "my_holidays": "Mein Urlaub",
    "version": "V2.4.0 OrizonDesk"
  },

  "adminHome": {
    "categories": {
      "dipendenti": {
        "title": "MITARBEITER",
        "subtitle": "Anwesenheit, Dokumente & Schichten",
        "description": "Personalverwaltung, Arbeitsverträge, persönliche Dokumente, Anwesenheit, Schichten und Berichte zur Zeiterfassung."
      },
      "azienda": {
        "title": "UNTERNEHMEN",
        "subtitle": "Profil & Dokumente",
        "description": "Archivieren und verwalten Sie offizielle Firmendokumente, Mietverträge und interne Verwaltungsangelegenheiten."
      },
      "partner": {
        "title": "PARTNER",
        "subtitle": "Kunden & Lieferanten",
        "description": "Vollständige Übersicht der Geschäftspartner, Lieferverträge, Rechnungen und Bestellhistorie."
      }
    },

    "partnerModal": {
    "title": "Geschäftspartner",
    "subtitle": "Wählen Sie eine Option, um fortzufahren",
    "newPartner": {
      "title": "NEUER PARTNER",
      "desc": "Fügen Sie einen neuen Kunden oder Lieferanten mit allen Details zur Datenbank hinzu."
    },
    "allPartners": {
      "title": "ALLE PARTNER",
      "desc": "Verwalten und durchsuchen Sie die vollständige Liste der Partner und deren Dokumente."
    }
  },

    "common": {
      "accessSection": "Zum Bereich"
    }
  },


  "create_partner": {
  "back": "Zurück",
  "title": "Neuer Geschäftspartner",
  "subtitle": "Neuen Partner hinzufügen für das Unternehmen:",
  "success_msg": "Partner erfolgreich gespeichert!",
  "manage_categories_btn": "Kategorien verwalten",
  "select_placeholder": "-- Typ / Kategorie auswählen --",
  "default_types_group": "Standardtypen",
  "db_categories_group": "Datenbank-Kategorien",
  "submit_btn": "Partner speichern",
   "my_partners_btn": "Meine Partners",

  "sections": {
    "basic": "1. Grunddaten",
    "location": "2. Kontakt & Standort",
    "banking": "3. Bankverbindung & Ansprechpartner"
  },

  "labels": {
    "naziv": "Partnername *",
    "tip": "Partnertyp / -kategorie",
    "pib_jib": "Steuernummer",
    "pdv": "USt-IdNr.",
    "broj_registracije": "Handelsregisternummer",
    "adresa": "Adresse",
    "postanski_broj": "Postleitzahl",
    "grad": "Stadt",
    "drzava": "Land",
    "email": "E-Mail",
    "telefon": "Telefon",
    "web": "Webseite",
    "naziv_banke": "Bankname",
    "bankovni_racun": "Bankverbindung (IBAN)",
    "kontakt_osoba": "Ansprechpartner",
    "kontakt_telefon": "Telefon Ansprechpartner",
    "napomena": "Anmerkungen"
  },

  "types": {
    "dobavljac": "Lieferant",
    "klijent": "Kunde",
    "obostrano": "Kunde / Lieferant"
  },

  "placeholders": {
    "naziv": "z. B. ACME GmbH",
    "pib_jib": "z. B. 12345678901",
    "pdv": "z. B. DE123456789",
    "napomena": "Zusätzliche Anmerkungen zum Partner eingeben..."
  },

  "errors": {
    "no_company": "Unternehmen nicht gefunden",
    "name_req": "Partnername ist erforderlich"
  },

  "category_modal": {
    "title": "Kategorien verwalten",
    "existing_list": "Bestehende Kategorien",
    "no_categories": "Noch keine Kategorien erstellt.",
    "delete": "Kategorie löschen",
    "add_new": "Neue Kategorie hinzufügen",
    "name_label": "Kategoriename *",
    "name_placeholder": "z. B. Subunternehmer",
    "desc_label": "Kategoriebeschreibung",
    "desc_placeholder": "Optionale Beschreibung der Kategorie...",
    "save_btn": "Kategorie speichern",
    "close": "Schließen",
    "duplicate_error": "Eine Kategorie mit diesem Namen existiert bereits.",
    "save_error": "Fehler beim Erstellen der Kategorie",
    "delete_error": "Fehler beim Löschen der Kategorie",
    "confirm_delete": "Sind Sie sicher, dass Sie diese Kategorie löschen möchten?"
  }
},

"listapartner": {
  "back": "Zurück",
  "title": "Geschäftspartner",
  "subtitle": "Verwalten Sie Kunden und Lieferanten Ihres Unternehmens",
  "new_partner": "Neuer Partner",
  "filter_archive": "Partner suchen",
  "search_placeholder": "Suche nach Name, St.Nr./USt-IdNr., Stadt, E-Mail...",
  "type": "Partnertyp",
  "list_title": "Partnerliste",
  "no_partners_found": "Keine Partner für die ausgewählten Kriterien gefunden.",
  "col_name": "Partnername",
  "col_piva": "St.Nr. / USt-IdNr.",
  "col_type": "Typ",
  "col_location": "Stadt / Adresse",
  "col_contact": "Kontakt",
  "col_date": "Erstellungsdatum",
  "view_documents": "Partnerdokumente",
  "select_placeholder": "-- Auswählen --",
  "pdv": "USt-IdNr.",
  "broj_registracije": "Handelsregisternummer",
  "adresa": "Adresse",
  "postanski_broj": "Postleitzahl",
  "grad": "Stadt",
  "drzava": "Land",
  "email": "E-Mail",
  "telefon": "Telefon",
  "web": "Website",
  "naziv_banke": "Bankname",
  "bankovni_racun": "Bankverbindung (IBAN)",
  "kontakt_osoba": "Ansprechpartner",
  "kontakt_telefon": "Telefon des Ansprechpartners",
  "napomena": "Anmerkung",
  "no_notes": "Keine Anmerkungen hinzugefügt.",
  "update_success": "Partner erfolgreich aktualisiert!",
  "update_error": "Fehler beim Aktualisieren des Partners",
  "delete_error": "Fehler beim Löschen des Partners",
  "edit_modal_title": "Partner bearbeiten",
  "info_modal_title": "Partnerdetails",
  "edit_subtitle": "Daten bearbeiten",
  "info_subtitle": "Datenübersicht",
  "confirm_delete_title": "Löschen bestätigen",
  "confirm_delete": "Sind Sie sicher, dass Sie diesen Partner dauerhaft löschen möchten?",
  "confirm_delete_docs_warning": "WARNUNG: Diese Aktion löscht dauerhaft auch alle {{count}} Dokumente dieses Partners (aus der Datenbank und vom Server). Dieser Vorgang kann NICHT rückgängig gemacht werden.",
  "confirm_delete_no_docs_warning": "WARNUNG: Dieser Vorgang kann NICHT rückgängig gemacht werden.",
  "errors": {
    "name_req": "Der Partnername ist erforderlich"
  },
  "types": {
    "dobavljac": "Lieferant",
    "klijent": "Kunde",
    "obostrano": "Kunde / Lieferant"
  }
},

"dettagli_partner": {
  "back": "Zurück",
  "gestione_documenti": "Dokumentenverwaltung für",
  "subtitle": "Digitale Verwaltung und Archivierung der Partnerdokumente",
  "new_upload": "Neuer Upload",
  "filter_archive": "Archiv filtern",
  "search_placeholder": "Suche nach Name, Typ, Ref.-Nr....",
  "year": "Jahr",
  "month": "Monat",
  "type": "Typologie",
  "list_title": "Liste der hochgeladenen Dokumente",
  "no_docs_found": "Keine Dokumente für die ausgewählten Kriterien gefunden.",
  "col_name": "Dokumentenname",
  "col_ref": "Referenz-ID",
  "col_type": "Typologie",
  "col_period": "Zeitraum / Gültigkeit",
  "col_date": "Upload-Datum",
  "valid_from": "Gültig ab",
  "valid_to": "Gültig bis",
  "refid": "Ref.-Nr. / ID",
  "refid_placeholder": "Z.B. RECH-2026-001",
  "notes": "Anmerkungen / Beschreibung",
  "notes_placeholder": "Geben Sie an, worum es sich handelt...",
  "no_notes": "Keine Anmerkungen hinzugefügt.",
  "select_pdf_img": "PDF oder Bild auswählen",
  "select_file_alert": "Bitte wählen Sie eine Datei aus!",
  "uploading": "Upload läuft...",
  "upload_btn": "Dokument hochladen",
  "upload_success": "Dokument erfolgreich hochgeladen!",
  "upload_error": "Fehler beim Upload",
  "download_error": "Datei konnte nicht heruntergeladen werden.",
  "preview_error": "Fehler beim Laden der Vorschau.",
  "update_success": "Dokument erfolgreich aktualisiert!",
  "update_error": "Fehler beim Aktualisieren",
  "delete_error": "Fehler beim Löschen",
  "missing_company": "Unternehmensdaten fehlen.",
  "missing_partner": "Partner nicht gefunden.",
  "edit_modal_title": "Dokument bearbeiten",
  "info_modal_title": "Dokumentdetails",
  "edit_subtitle": "Parameter bearbeiten",
  "info_subtitle": "Datenübersicht",
  "confirm_delete_title": "Löschen bestätigen",
  "confirm_delete": "Sind Sie sicher, dass Sie dieses Dokument dauerhaft löschen möchten? Diese Aktion entfernt die Datei auch vom Storage-Server.",
  "categ_title2": "Neue Kategorie",
  "categ_input_placeholder": "Kategoriename...",
  "categ_custom_list": "Benutzerdefinierte Kategorien:",
  "categ_add": "Hinzufügen",
  "category_exists": "Diese Kategorie existiert bereits!",
  "category_error": "Fehler",
  "confirm_delete_category": "Möchten Sie diese Kategorie löschen?",
  "types": {
    "contract": "Vertrag",
    "invoice": "Rechnung",
    "other": "Sonstiges"
  }
},

  "deactivate_modal": {
  "title": "Mitarbeiter deaktivieren",
  "subtitle": "Sie sind dabei, den Zugriff für folgenden Benutzer zu deaktivieren:",
  "reason_label": "Grund für die Deaktivierung (erforderlich)",
  "placeholder": "z.B. Beendigung des Arbeitsverhältnisses, Disziplinarmaßnahmen...",
  "warning_login": "Der Benutzer kann sich nicht mehr am System anmelden.",
  "warning_data": "Alle Daten und Dokumente bleiben im Archiv gespeichert.",
  "confirm_btn": "Deaktivierung bestätigen",
  "cancel_btn": "Abbrechen",
  "error": "Fehler bei der Deaktivierung",
  "success_deactivate": "Mitarbeiter erfolgreich deaktiviert"
},

"activate_modal": {
  "title": "Mitarbeiteraktivierung",
  "subtitle": "Zugang reaktivieren für:",
  "reason_label": "Aktivierungsnotiz (optional)",
  "placeholder": "Z.B. Rückkehr aus dem Urlaub, neuer Vertrag...",
  "warning_login": "Der Benutzer erhält sofortigen Systemzugriff.",
  "confirm_btn": "Aktivieren",
  "cancel_btn": "Abbrechen",
  "success_activate": "Mitarbeiter je ponovo aktivan!",
  "history_title": "Deaktivierungshistorie",
  "deactivated_on": "Deaktiviert am:",
  "previous_reason": "Vorheriger Grund:",
  "no_history": "Keine vorherigen Deaktivierungsdaten gefunden"
},

"not_active_page": {
  "title": "Account deaktiviert",
  "message": "Ihr Systemzugriff wurde von der Administration vorübergehend deaktiviert.",
  "contact": "Wenn Sie glauben, dass es sich um einen Fehler handelt, wenden Sie sich an Ihren Vorgesetzten.",
  "back_home": "Zurück zur Startseite"
},

"pricing": {
  "monthly": "Monatlich",
  "annual": "Jährlich",
  "save_discount": "20% Sparen",
  "month": "Monat",
  "year": "Jahr",
  "popular": "Beliebtet",
  "choose_plan": "Paket wählen",
  "what_you_get": "Was im Paket enthalten ist:",
  "confirm": "Bestätigen & Weiter",
  "close": "Schließen",
  "basic_features": [
    "Bis zu 10 Mitarbeiter",
    "HR-Archiv (Lohnabrechnungen, Verträge, Schulungen)",
    "Zeiterfassungssystem mit dynamischem QR-Code",
    "Kunden- & Lieferantenmodul",
    "Benachrichtigungen bei Dokumentenablauf"
  ],
  "premium_features": [
    "Bis zu 50 Mitarbeiter",
    "Alles aus dem Basic-Paket",
    "Audit-Log-System (Download-Verfolgung)",
    "Verwaltung mehrerer Standorte/Abteilungen",
    "Prioritäts-Support"
  ],
  "enterprise_features": [
    "Unbegrenzte Mitarbeiteranzahl",
    "Alles aus dem Premium-Paket",
    "Individueller API-Zugriff & Integrationen",
    "Dedizierter Account Manager",
    "Onboarding und Einrichtung vor Ort"
  ],
  "descriptions": {
    "Basic": "Ideal für kleine Unternehmen und Handwerksbetriebe. Enthält ein vollständiges HR-Archiv, ein fortschrittliches dynamisches QR-System zur Zeiterfassung sowie das Kunden- und Lieferantenmodul.",
    "Premium": "Perfekt für schnell wachsende Unternehmen. Enthält ein erweitertes Audit-Log zur Nachverfolgung von Dokumentenzugriffen und Unterstützung für mehrere getrennte Standorte.",
    "Enterprise": "Maßgeschneiderte Lösung für große Systeme mit unbegrenzter Mitarbeiteranzahl, eigenem Account Manager und direkten API-Integrationen."
  },
  "badge_text": "Kostenlose Testversion",
  "free_trial_btn": "30 Tage kostenlos testen",
  "free_trial_subtitle": "Keine Kreditkarte erforderlich. Einrichtung in nur 2 Minuten.",
  "start_test_btn": "Test starten"
},

"test_page": {
  "back": "Zurück zu den Angeboten",
  "title": "Kostenloser Test",
  "subtitle": "Testen Sie OrizonDesk 30 Tage lang völlig kostenlos",
  "success_title": "Anfrage erfolgreich gesendet!",
  "success_desc": "Vielen Dank für Ihr Interesse. Wir haben Ihnen eine E-Mail mit dem Link zur Kontoaktivierung gesendet. Bitte überprüfen Sie Ihren Posteingang.",
  "basic_info": "Bis zu 10 Mitarbeiter • 5GB Cloud-Speicher • Alle Module enthalten",
  "gratis": "30 Tage kostenlos",
  "label_name": "Vorname",
  "label_surname": "Nachname",
  "label_company": "Firmenname",
  "label_email": "Geschäftliche E-Mail",
  "label_phone": "Telefonnummer",
  "label_note": "Zusätzliche Anmerkung (Optional)",
  "placeholder_name": "z.B. Markus",
  "placeholder_surname": "z.B. Müller",
  "placeholder_company": "z.B. Orizon AIX GmbH",
  "placeholder_email": "name@firma.de",
  "placeholder_phone": "+49 151 0000000",
  "placeholder_note": "Haben Sie spezielle Anforderungen?",
  "terms_part1": "Ich akzeptiere die",
  "terms_link": "Nutzungsbedingungen",
  "terms_part2": "und die Datenverarbeitung.",
  "btn_send": "Kostenlose Testphase starten",
  "footer_note": "OrizonDesk behält sich das Recht vor, die Daten vor der Genehmigung der Testphase zu prüfen.",
  "brand_subtitle": "OrizonDesk Digitale Systeme",
  "error_email_exists": "Diese E-Mail-Adresse ist bereits registriert. Bitte loggen Sie sich ein."
},


"common1": {
    "back": "Zurück"
  },
  "status": {
    "section_title": "Ressourcen- & Abonnementstatus",
    "section_subtitle": "Übersicht über den aktuellen Verbrauch und Systembeschränkungen.",
    "employees_label": "Mitarbeiter",
    "storage_label": "Cloud-Speicher",
    "expires_in": "Verbleibende Lizenzzeit",
    "upgrade_btn": "TARIF UPGRADEN",
    "current_plan": "Aktueller Tarif",
    "days_suffix": "Tage",
    "history_btn": "Zahlungshistorie",
    "trash_btn": "Speicher freigeben"
  },

  "upgrade": {
  "modal_title": "Paketverwaltung",
  "current_status": "Aktuelles Paket",
  "current_expires": "Läuft ab am",
  "current_workers": "Aktive Mitarbeiter",
  "current_storage": "Genutzter Speicher",
  "tab_upgrade": "Upgrade",
  "tab_renew": "Verlängerung",
  "tab_custom": "Individuelles Angebot",
  "recommended": "Empfohlen",
  "recommended_renewal": "Gleiches Paket verlängern",
  "plan_basic_title": "Basic-Paket",
  "plan_basic_price": "75 € / Jahr",
  "plan_basic_workers": "10 Mitarbeiter",
  "plan_basic_storage": "5GB Cloud",
  "plan_basic_feat1": "QR-Code-Badge",
  "plan_basic_feat2": "E-Mail-Support",
  "plan_premium_title": "Premium-Paket",
  "plan_premium_price": "230 € / Jahr",
  "plan_premium_workers": "50 Mitarbeiter",
  "plan_premium_storage": "15GB Cloud",
  "plan_premium_feat1": "Audit-Log-System",
  "plan_premium_feat2": "Prioritäts-Support",
  "plan_enterprise_title": "Enterprise-Paket",
  "plan_enterprise_price": "615 € / Jahr",
  "plan_enterprise_workers": "Unbegrenzt",
  "plan_enterprise_storage": "100GB Cloud",
  "plan_enterprise_feat1": "Custom-API-Zugang",
  "plan_enterprise_feat2": "Persönlicher Manager",
  "pay_now": "Jetzt bezahlen",
  "select_plan": "Dieses Paket wählen",
  "current_plan_badge": "Aktuelles Paket",
  "downgrade_badge": "Downgrade",
  "upgrade_badge": "Upgrade",
  "review_title": "Zusammenfassung der Paketänderung",
  "review_from": "Aktuelles Paket",
  "review_to": "Neues Paket",
  "review_workers": "Mitarbeiter",
  "review_storage": "Cloud-Speicher",
  "review_price": "Preis",
  "review_period": "Laufzeit",
  "review_period_val": "365 Tage",
  "review_proceed": "Weiter zur Zahlung",
  "review_back": "← Zurück zur Auswahl",
  "downgrade_error_title": "Downgrade nicht möglich",
  "downgrade_error_workers": "Sie haben derzeit {current} registrierte Mitarbeiter. Das Paket {plan} akzeptiert max. {max} Mitarbeiter. Entfernen Sie Mitarbeiter aus dem Unternehmen, bevor Sie fortfahren.",
  "downgrade_error_storage": "Sie nutzen {current}GB Speicher. Das Paket {plan} bietet max. {max}GB. Geben Sie Speicher frei, indem Sie Dokumente löschen (auch aus dem Papierkorb), bevor Sie fortfahren.",
  "downgrade_error_both": "Sie haben zu viele Mitarbeiter ({workers}) und zu viel genutzten Speicher ({storage}GB) für das ausgewählte Paket.",
  "divider_text": "oder manuell konfigurieren",
  "custom_title": "Individuelle Konfiguration",
  "custom_subtitle": "Wählen Sie die Parameter und unser Team sendet Ihnen ein Angebot",
  "cloud_storage": "Cloud-Speicher",
  "employee_count": "Anzahl Mitarbeiter",
  "license_duration": "Lizenzdauer",
  "unlimited": "UNBEGRENZT",
  "year_one": "JAHR",
  "year_multi": "JAHRE",
  "send_request": "ANGEBOTSANFRAGE SENDEN",
  "success_title": "Anfrage gesendet!",
  "success_thanks": "Vielen Dank für Ihr Vertrauen.",
  "success_desc_1": "Unser Team wird Ihre Konfiguration analysieren und Sie",
  "success_desc_2": "so schnell wie möglich",
  "success_desc_3": "kontaktieren, um das Angebot abzuschließen.",
  "renewal_success_title": "Zahlung wird verarbeitet",
  "renewal_success_desc": "Ihr Paket wird aktualisiert, sobald die Zahlung bestätigt wurde. Eine Bestätigungs-E-Mail wird an Ihre Adresse gesendet.",
  "feat_audit": "Audit-Log-System",
  "feat_support": "Prioritäts-Support",
  "feat_api": "Custom-API-Zugang",
  "feat_manager": "Persönlicher Manager",
  "select_btn": "AUSWÄHLEN",
  "premium_title": "Premium-Paket",
  "premium_price": "230 € / Jahr",
  "premium_subtitle": "Bis zu 50 Mitarbeiter und erweiterte Funktionen",
  "enterprise_title": "Enterprise-Paket",
  "enterprise_price": "615 € / Jahr",
  "enterprise_subtitle": "Unbegrenzte Mitarbeiter und API-Zugang",
  "loading_check": "Daten werden geladen ...",
  "error_fetch": "Fehler beim Laden der Daten. Bitte erneut versuchen.",
  "checkout_error": "Fehler beim Öffnen der Zahlung. Bitte erneut versuchen.",
  "plan_basic_price_eur":      "75 €",
"plan_premium_price_eur":    "230 €",
"plan_enterprise_price_eur": "615 €",

"billing_annual": "Jährlich",
  "billing_monthly": "Monatlich",
  "review_period_annual": "365 Tage",
  "review_period_monthly": "1 Monat",
  "receipt_cycle": "Abrechnungszeitraum",

  "plan_basic_price_km_monthly":      "15.99 KM",
  "plan_premium_price_km_monthly":    "44.99 KM",
  "plan_enterprise_price_km_monthly": "119.99 KM",
  "plan_basic_price_eur_monthly":     "7.99 €",
  "plan_premium_price_eur_monthly":   "44.99 €",
  "plan_enterprise_price_eur_monthly":"119.99 €",

},
"renewal_success": {
  "loading": "Zahlung wird verarbeitet ...",
  "title": "Paket aktualisiert!",
  "subtitle": "Ihr Paket wurde erfolgreich",
   "receipt_cycle": "Abrechnungszeitraum",
  "subtitle2": "aktualisiert. Bestätigung per E-Mail gesendet.",
  "badge_renewed": "Paket verlängert",
  "badge_upgraded": "Paket aktualisiert",
  "badge_downgraded": "Paket herabgestuft",
  "receipt_title": "Änderungsbestätigung",
  "receipt_payment_id": "Payment ID",
  "receipt_plan": "Paket",
  "receipt_valid": "Gültig bis",
  "receipt_status": "Status",
  "receipt_status_val": "Aktiv",
  "btn_home": "Zur Dashboard",
  "error_title": "Aktualisierungsfehler",
  "error_subtitle": "Zahlung erfolgreich, aber Paket nicht aktualisiert. Bitte kontaktieren Sie den Support.",
  "error_label_id": "Payment ID",
  "error_label_msg": "Fehler",
  "error_contact": "Kontaktieren Sie uns unter",
  "error_status_failed": "Zahlung fehlgeschlagen. Status:"
},

"invite_setup": {
  "title": "Du wurdest eingeladen!",
  "desc": "Schließe die Einrichtung deines Kontos ab, indem du ein Passwort festlegst",
  "new_password": "Passwort erstellen",
  "confirm_password": "Passwort bestätigen",
  "button": "Mein Konto aktivieren",
  "success": "Konto erfolgreich aktiviert! Willkommen im Team.",
  "error_match": "Passwörter stimmen nicht überein",
  "error_too_short": "Das Passwort muss mindestens {{min}} Zeichen lang sein",
  "passwords_match": "Passwörter stimmen überein",
  "error_session_title": "Ungültiger oder abgelaufener Link",
  "error_session_expired": "Dieser Einladungslink ist nicht mehr gültig oder wurde bereits verwendet. Bitte bitten Sie Ihren Administrator, Ihnen eine neue Einladung zu senden.",
  "back_to_login": "Zurück zum Login"
},
"company_inactive": {
  "title": "Unternehmen nicht aktiv",
  "desc": "Der Zugang zu OrizonDesk für Ihr Unternehmen wurde vorübergehend deaktiviert. Dies geschieht in der Regel nach Ablauf des Testzeitraums oder des Abonnements.",
  "contact_support": "OrizonDesk-Team kontaktieren",
  "renew_btn": "Abonnement verlängern",
"renew_hint": "Nur Administratoren können das Abonnement verlängern",

},

"userLog": {
  "noPermission": "Keine Berechtigung für den Zugriff auf Audit-Logs.",
  "back": "Zurück",
  "loadMore": "Mehr laden",
  "title": "Aktivitäts-Audit-Log",
  "subtitle": "Verfolgung von Benutzeraktivitäten, Dokumenten-Downloads und Systemänderungen",
  "table": {
    "time": "Zeitpunkt",
    "user": "Benutzer (Ausführender)",
    "action": "Aktion / Typ",
    "document": "Dokument / Datei",
    "device": "Gerät",
    "noActivity": "Keine Aktivitäten aufgezeichnet",
    "system": "System"
  },
  "footer": {
    "gdprNote": "Dieses Protokoll ist unveränderlich und dient als offizieller Nachweis des Zugriffs auf sensible Dokumente gemäß DSGVO.",
    "policy": "Audit-Richtlinie",
    "status": "Aktive Überwachung"
  }
},


  "legal": {
    "back": "Zurück",
    "title_part1": "Rechtliches &",
    "title_part2": "Compliance",
    "header_subtitle": "Orizon Desk Portal • Infrastruktur & Datenschutz • v1.2.5 • 2026",
    "stats": {
      "residency": "Datenstandort",
      "storage": "Datenbank-Infrastruktur",
      "encryption": "Verschlüsselungsstandard",
      "gdpr": "DSGVO-Konformität",
      "db": "Datenbank",
      "security": "Sicherheitsprotokoll",
      "monitoring": "Überwachung",
      "identity": "Identität"
    },
    "stats_vals": {
      "residency": "Zürich (CH) Schweiz",
      "gdpr": "Volle EU-Standards"
    },
    "section01": {
      "title": "Allgemeine Geschäftsbedingungen",
      "subtitle": "SaaS-Vereinbarung und Integritätsgarantien auf militärischem Niveau",
      "p1_part1": "Orizon Desk ist ein geschlossenes digitales Ökosystem, das durch strenge Sicherheitsprotokolle reguliert wird. Der Zugriff ist strikt auf autorisiertes Personal beschränkt, und jede Interaktion ist durch eine Architektur geschützt",
      "p2_part1": "Um maximalen Schutz zu gewährleisten, überwacht das System ständig die Zugriffspunkte:",
      "p2_bold": "Jede Sitzung ist mit der IP-Adresse des Benutzers verknüpft",
      "p2_part2": "um externe Eindringlinge, Brute-Force-Angriffe oder die unbefugte Verwendung von Anmeldedaten von unbekannten Standorten zu verhindern.",
      "p3": "Orizon AIX garantiert eine Serviceverfügbarkeit von 99,9 %. Die im Portal enthaltenen Daten werden mit höchster industrieller Vertraulichkeit behandelt.",
      "integrity_title": "Systemintegrität",
      "integrity_bold": "Wir verwenden Sicherheitsprotokolle auf militärischem Niveau",
      "integrity_desc": "um Identitetsdiebstahl ili Datenverlust zu verhindern. Die Integrität wird durch Prüfsummenalgorithmen garantiert, die ständig verifizieren, dass keine Datei geändert wurde, auch ne versehentlich.",
      "feature1_title": "Bcrypt-Passwort-Hashing",
      "feature1_desc": "Passwörter werden niemals im Klartext gespeichert, was eine Entschlüsselung selbst bei direktem Datenbankzugriff unmöglich macht.",
      "feature2_title": "SSL/TLS 1.3",
      "feature2_desc": "Jedes Bit an Informationen, das zwischen Ihrem Browser und unseren Servern in Zürich übertragen wird, ist durch das fortschrittlichste heute verfügbare Verschlüsselungsprotokoll geschützt.",
      "user_resp_title": "Verantwortung des Benutzers",
      "user_resp_desc": "Der Benutzer ist der Hüter seiner Anmeldedaten. Orizon Desk implementiert eine automatische Kontosperrung nach 5 fehlgeschlagenen Versuchen und eine IP-Adressverfolgung zur Erkennung von Angriffen.",
      "monitor_title": "Echtzeit-Überwachung",
      "monitor_desc": "Unser Bedrohungserkennungssystem analysira ständig den Datenverkehr, um verdächtige Muster zu identifizieren. Jedes heruntergeladene Dokument generiert einen eindeutigen kryptografischen Zeitstempel."
    },
    "section02": {
      "title": "Datenschutzerklärung",
      "subtitle": "Konformität mit der EU-Verordnung 2016/679 und internationalen Standards",
      "gdpr_text1": "Gemäß Art. 13 der DSGVO informieren wir Sie darüber, dass die Verarbeitung personenbezogener Daten ausschließlich auf die Verwaltung des Arbeitsverhältnisses und die Digitalisierung der Unternehmensdokumentation gerichtet ist. Wir verkaufen oder teilen Ihre Daten nicht mit Dritten zu kommerziellen Zwecken.",
      "gdpr_text2": "Die verarbeiteten Daten umfassen: persönliche Identifikatoren, vertragliche Daten, Bankverbindungen (falls auf der Gehaltsliste) und Systemzugriffsprotokolle. Die Verarbeitung ist zur Erfüllung rechtlicher und vertraglicher Verpflichtungen erforderlich.",
      "cards": {
        "purpose_t": "Zweck",
        "purpose_d": "HR-Digitalisierung, Archivierung von Gehaltsabrechnungen und eindeutigen Zertifikaten.",
        "retention_t": "Aufbewahrung",
        "retention_d": "Die Daten werden gemäß den europäischen Steuerzahlerrichtlinien 10 Jahre lang gespeichert.",
        "security_t": "Sicherheit",
        "security_d": "Granulare rollenbasierte Zugriffskontrolle (RBAC). Ein Administrator kann nur Ressourcen einsehen, die ihm ausdrücklich zugewiesen wurden."
      },
      "audit": {
        "header": "Vollständige Rückverfolgbarkeit: Was ist ein Log-Audit?",
        "p1_part1": "Jede einzelne Aktion innerhalb des Orizon Desk Portals wird in einem unveränderlichen",
        "p1_part2": "aufgezeichnet. Das bedeutet, das System erstellt eine digitale 'Black Box', die speichert: wer zugegriffen hat, von welcher IP-Adresse, zu welcher Zeit und welches Dokument angesehen oder heruntergeladen wurde.",
        "p2_part1": "Diese Funktion ist entscheidend für Ihre Sicherheit: Sie garantiert die",
        "p2_bold": "Nichtabstreitbarkeit",
        "p2_part2": "von Handlungen und ermöglicht jederzeit die Überprüfung, ob sensible Dokumente (wie Gehaltsabrechnungen) ausschließlich vom rechtmäßigen Eigentümer oder autorisiertem HR-Personal eingesehen wurden, wodurch das Risiko eines verborgenen Zugriffs eliminiert wird.",
        "tag1": "Unveränderlicher Zeitstempel",
        "tag2": "IP-Tracking-Schutz",
        "tag3": "Transparenz des Datenzugriffs"
      },
      "cookies": {
        "title": "Cookie-Hinweis",
        "desc": "Das Orizon Desk Portal verwendet ausschließlich 'Technische Cookies', die für das Funktionieren der Sitzung und die Authentifizierungssicherheit erforderlich sind. Wir verwenden keine Profiling-Cookies oder Werbe-Tracker von Drittanbietern (wie Facebook Pixel oder Google Analytics), um Ihnen maximalen Datenschutz zu garantieren."
      }
    },
    "section03": {
      "title": "Infrastruktur & Cloud",
      "subtitle": "Datenstandort Zürich (Schweiz) und AWS S3 Technologie",
      "aws_title": "AWS S3 Cloud-Speicher",
      "aws_desc_part1": "Jede hochgeladene Datei wird gehostet auf",
      "aws_desc_part2": "Daten werden nicht auf einem anfälligen physischen Server gespeichert, sondern in einer verteilten Infrastruktur, die für eine Beständigkeit von 99,99 % ausgelegt ist. Jede Datei wird einzeln im Ruhezustand verschlüsselt (At-Rest-Encryption).",
      "swiss_title": "Warum Schweiz (Zürich)?",
      "swiss_bold": "Zürich (Region: eu-central-2)",
      "swiss_desc_part1": "Unsere Server befinden sich im Technologiezentrum von",
      "swiss_desc_part2": ". Die Schweiz bietet eine einzigartige politische und rechtliche Stabilität mit Datenschutzgesetzen, die den DSGVO-Schutz weiter ausbauen und sicherstellen, dass Geschäftsdokumente vor externen Einflüssen oder willkürlichen Beschlagnahmungen geschützt sind.",
      "backup_title": "Betriebskontinuität & Backup",
      "backup_desc_part1": "Wir nutzen ein System von",
      "backup_desc_part2": "das eine zeitpunktbezogene Datenwiederherstellung ermöglicht und Schutz vor menschlichen Fehlern oder technischem Versagen garantiert. Alle Dokumente werden mit geografischer Redundanz archiviert, und Backups werden mit Schlüsseln verschlüsselt, die über",
      "backup_desc_part3": "AWS KMS verwaltet werden.",
      "rls_title": "Datensegregation RLS",
      "rls_desc_part1": "Die PostgreSQL-Datenbank verwendet",
      "rls_desc_part2": "Technologie. Dies stellt sicher, dass es auf Code-Ebene physisch unmöglich ist, dass ein Benutzer eines Unternehmens die Datensätze eines anderen sieht, selbst im Falle eines Anwendungsfehlers.",
      "cert_header": "Cloud-Zertifizierungen",
      "cert_iso": "Internationale Standards für das Informationssicherheitsmanagement in der Cloud.",
      "cert_soc": "Zertifizierung interner Kontrollen für Sicherheit, Verfügbarkeit und Vertraulichkeit.",
      "cert_gdpr": "EU-Konformität für die Übertragung und Verarbeitung sensibler personenbezogener Daten.",
      "cert_csa": "Höchste Stufe der spezifischen Sicherheit für Cloud Service Provider (SaaS).",
      "cert_dr": "Tägliche geo-replizierte Backups zur Sicherstellung der Kontinuität in jedem Szenario.",
      "quote": "Unsere Infrastruktur ist nicht nur konform; sie ist weltweit führend beim Schutz von HR-Daten.",
      "click_hint": "Klicken Sie auf die oben stehenden Badges, um die offiziellen Zertifizierungen des Anbieters zu überprüfen."
    },
    "section04": {
      "title": "Ihre Rechte",
      "subtitle": "Ausübung der durch die DSGVO garantierten rechtlichen Befugnisse",
      "rights": {
        "access_t": "Recht auf Auskunft",
        "access_d": "Sie können eine Bestätigung über die Verarbeitung Ihrer Daten anfordern und eine vollständige digitale Kopie erhalten.",
        "forget_t": "Recht auf Vergessenwerden",
        "forget_d": "Antrag auf dauerhafte Löschung personenbezogener Daten, sobald der rechtliche Zweck der Verarbeitung abläuft.",
        "port_t": "Übertragbarkeit",
        "port_d": "Herunterladen von Dokumenten in einem strukturierten Format (PDF) zur Übertragung an einen anderen Verantwortlichen.",
        "limit_t": "Einschränkung",
        "limit_d": "Antrag auf Einschränkung der Verarbeitung im Falle der Bestreitung der Richtigkeit der Daten."
      },
      "exercise_text": "Um eines der genannten Rechte auszuüben oder eine Datenschutzverletzung (Data Breach) zu melden, kann sich die betroffene Person direkt über die entsprechende E-Mail-Adresse an den Verantwortlichen wenden. Anfragen werden innerhalb von maximal 30 Tagen bearbeitet."
    },
    "footer": {
      "contact_label": "Kontakt für rechtliche Anfragen",
      "locations": "Orizon AIX • Brescia, Italien • Zürich, CH",
      "update_tag": "Aktualisiert im März 2026",
      "disclaimer": "Diese Dokumentation unterliegt einer jährlichen Überprüfung. Die weitere Nutzung der Plattform impliziert die automatische Annahme aller Bedingungen. Jede wesentliche Änderung wird durch eine interne Mitteilung kommuniziert.",
      "secured_switzerland": "Stolz gesichert in der Schweiz."
    },
    "section05": {
      "title": "Zahlungssicherheit",
      "subtitle": "Transaktionsschutz und Zero-Storage-Datenschutzrichtlinie",
      "points": {
        "stripe_t": "Zero-Storage-Richtlinie",
        "stripe_d": "Orizon DESK speichert Ihre Kartendaten nicht und hat keinen Zugriff darauf. Alle Prozesse sind isoliert.",
        "pci_t": "PCI-DSS-Standard",
        "pci_d": "Transaktionen werden über Dodo Payments abgewickelt, die den höchsten Bankenstandards entsprechen.",
        "crypto_t": "SSL-Verschlüsselung",
        "crypto_d": "Die gesamte Kommunikation ist durch 256-Bit-Verschlüsselung und PKI-Sicherheitsprotokolle geschützt.",
        "methods_t": "Zahlungsmethoden",
        "methods_d": "Wir unterstützen VISA, MasterCard, Klarna, Amazon Pay sowie biometrische Zahlungen über Apple und Google Pay."
      },
      "payment_text": "Alle Geldtransaktionen werden über externe, hochsichere Gateway-Anbieter abgewickelt. Orizon Desk verwendet Ihre Daten ausschließlich für Verknüpfungszwecke innerhalb der Plattform, während Finanzdaten durch undurchdringliche Verschlüsselungsschichten von Drittanbietern geschützt sind."
    },

    "section06": {
  "title": "Rückerstattung und Widerruf",
  "subtitle": "Deine Rechte gemäß der EU-Richtlinie 2011/83/EU — 14-tägige Rückgabegarantie",
  "intro": "OrizonDesk respektiert alle Verbraucherrechte, die in der europäischen Gesetzgebung vorgesehen sind. Mit dem Kauf eines beliebigen Plans über unsere Plattform hast du Anspruch auf eine Rückerstattung unter den unten angegebenen Bedingungen.",
  "points": {
    "period_t": "Widerrufsfrist",
    "period_d": "Du hast das Recht, vom Vertrag innerhalb von 14 Kalendertagen ab dem Datum der Zahlungsbestätigung zurückzutreten, ohne dass du einen Grund angeben musst.",
    "how_t": "Wie stelle ich einen Antrag",
    "how_d": "Sende eine E-Mail an [info@orizon-aix.com](mailto:info@orizon-aix.com) mit dem Betreff 'RÜCKERSTATTUNGSANTRAG' und gib die Payment ID der Transaktion an. Wir antworten innerhalb von 48 Stunden.",
    "conditions_t": "Bedingungen für die Rückerstattung",
    "conditions_d": "Eine Rückerstattung ist möglich, wenn das Konto nach der Aktivierung nicht aktiv genutzt wurde, um Mitarbeiter, Dokumente oder Unternehmensdaten hinzuzufügen.",
    "timeline_t": "Zeitraum für die Gutschrift",
    "timeline_d": "Nach Genehmigung des Antrags werden die Gelder innerhalb von 5–10 Werktagen auf die ursprüngliche Zahlungsmethode zurücküberwiesen."
  },
  "exceptions_title": "Ausnahmen vom Widerrufsrecht",
  "exceptions_desc": "Das Widerrufsrecht gilt nicht, wenn der digitale Dienst vollständig aktiviert und mit deiner ausdrücklichen Zustimmung genutzt wurde, gemäß Art. 16(m) der Richtlinie 2011/83/EU. Bei aktiver Nutzung der Plattform prüfen wir den Antrag individuell und bieten gegebenenfalls eine teilweise Rückerstattung oder eine Verlängerung des Abonnements an.",
  "contact_block": "Bei Fragen zu Rückerstattungen kontaktiere uns unter [info@orizon-aix.com](mailto:info@orizon-aix.com) oder über das Support-Formular innerhalb der Plattform. Jeder Antrag wird individuell und mit größtmöglicher Transparenz bearbeitet.",
  "eu_note": "Diese Richtlinie entspricht der EU-Richtlinie 2011/83/EU über Verbraucherrechte und der geltenden nationalen Gesetzgebung."
}
  },


  "payments": {
    "no_permission": "Sie haben keine Berechtigung, auf den Zahlungsverlauf zuzugreifen.",
    "back": "Zurück",
    "title": "Zahlungs- und Lizenzhistorie",
    "subtitle": "Übersicht über Transaktionen, aktive Lizenzen und Verwaltungsdaten",
    "table": {
      "period": "Gültigkeitszeitraum",
      "admin_email": "Admin / E-Mail",
      "package_id": "Paket & ID",
      "amount": "Betrag",
      "status_pdf": "Status / PDF",
      "from": "Bezahlt:",
      "to": "Läuft ab:",
      "paid_by": "Bezahlt von",
      "online": "Online",
      "no_transactions": "Keine Transaktionen aufgezeichnet"
    },
    "footer": {
      "note": "Alle Lizenzen werden automatisch sofort nach der Zahlungsbestätigung aktiviert. Für Rechnungen oder weitere Fragen kontaktieren Sie den Support mit der Transaktions-ID.",
      "system_status": "Systemstatus",
      "verified": "Verified & Secured"
    }
  },

  "trash": {
    "title": "Papierkorb",
    "subtitle": "Gelöschte Dateien verwalten: Wiederherstellen oder endgültig löschen",
    "placeholder_search": "Datei oder Benutzer suchen...",
    "filter_all": "Alle",
    "filter_today": "Heute",
    "filter_7days": "7 Tage",
    "table_doc": "Dokument",
    "table_size": "Größe",
    "table_owner": "Besitzer",
    "table_removed_by": "Gelöscht von",
    "table_date": "Datum und Uhrzeit",
    "table_actions": "Aktionen",
    "no_files": "Keine Dateien gefunden",
    "total": "Gesamt",
    "info_auto_on": "Automatisches Löschen ist AKTIVIERT. Dateien, die älter als 30 Tage sind, werden automatisch entfernt.",
    "info_auto_off": "Dateien bleiben im Papierkorb, bis sie manuell gelöscht werden.",
    "modal_restore_title": "Datei wiederherstellen?",
    "modal_delete_title": "Endgültig löschen?",
    "modal_restore_desc": "Möchten Sie die Datei {{name}} von {{owner}} wiederherstellen?",
    "modal_delete_desc": "Sind Sie sicher, dass Sie die Datei {{name}} von {{owner}} endgültig löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "modal_cancel": "Abbrechen",
    "modal_confirm": "Bestätigen"
  },
  "settings_trash": {
    "delete_label": "Auto-Löschen",
    "days_30": "30 Tage"
  },


  "premium_payments": {
    "back": "Zurück",
    "badge": "OrizonDesk PREMIUM",
    "price": "230 €",
    "price_monthly": "24.99 €",
    "price_period": "/ JÄHRLICH",
    "price_period_monthly": "/ MONATLICH",
    "feature_employees": "50 Mitarbeiter",
    "feature_cloud": "15GB Cloud",
    "feature_audit": "Audit-Log",
    "feature_support": "Priorisierter Support",
    "step1": {
      "title": "Rechnung und Daten",
      "subtitle": "Fülle das Formular aus, um das Premium-Paket zu aktivieren",
      "label_name": "Vorname",
      "label_surname": "Nachname",
      "label_company": "Firmenname",
      "label_email": "E-Mail",
      "label_phone": "Telefon",
      "placeholder_name": "Dein Vorname",
      "placeholder_surname": "Dein Nachname",
      "placeholder_company": "Name des Unternehmens",
      "placeholder_email": "admin@firma.de",
      "placeholder_phone": "+49",
      "terms_part1": "Ich akzeptiere die",
      "terms_link": "Allgemeinen Geschäftsbedingungen",
      "terms_part2": "und die Datenschutzrichtlinie",
      "btn_next": "Zur Zahlung",
      "error_generic": "Ein Fehler ist aufgetreten.",
      "error_email_exists": "Diese E-Mail ist bereits im System registriert.",
      "error_server": "Serverfehler. Bitte versuche es später erneut."
    },
    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "PREMIUM-PAKET für",
      "total_label": "GESAMTBETRAG:",
      "total_amount": "230.00 €",
      "total_amount_monthly": "24.99 €",
      "summary_title": "Datenzusammenfassung",
      "summary_name": "Vor- und Nachname",
      "summary_company": "Firma",
      "summary_email": "E-Mail",
      "summary_phone": "Telefon",
      "summary_package": "Paket",
      "summary_package_value": "Premium — 365 Tage",
      "summary_package_value_monthly": "Premium — 30 Tage",
      "btn_pay": "Zur Zahlung — 230 €",
      "btn_pay_monthly": "Zur Zahlung — 24.99 €",
      "ssl_label": "Sichere Zahlung über Dodo Payments · SSL-verschlüsselt",
      "btn_back": "← Zurück zur Datenbearbeitung",
      "loading": "Sichere Zahlung wird geöffnet ...",
      "error_checkout": "Fehler bei der Zahlung. Bitte versuche es erneut.",
      "error_expired": "Die Zahlungssitzung ist abgelaufen. Bitte versuche es erneut.",
      "error_open": "Fehler beim Öffnen der Zahlung. Bitte versuche es erneut."
    },
    "footer_ssl": "SSL-verschlüsselte Transaktion · Dodo Payments"
  },
  "payment_success": {
    "loading": "Premium-Paket wird aktiviert ...",
    "badge": "OrizonDesk PREMIUM",
    "title": "Premium aktiviert!",
    "subtitle": "Überprüfe deine E-Mails",
    "subtitle2": "für die Zugangsdaten und die Kontoaktivierung.",
    "receipt_title": "Transaktionsbestätigung",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Paket",
    "receipt_package_value": "Premium — 365 Tage",
    "receipt_package_value_monthly": "Premium — 30 Tage",
    "receipt_status": "Status",
    "receipt_status_value": "Bezahlt & Verifiziert",
    "btn_home": "Zur Startseite",
    "error_title": "Aktivierungsfehler",
    "error_subtitle": "Die Zahlung war erfolgreich, aber die Aktivierung wurde nicht abgeschlossen.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Fehler",
    "error_contact": "Bewahre die Payment ID auf und kontaktiere uns unter",
    "error_status_failed": "Zahlung fehlgeschlagen. Status:"
  },
  "basic_payments": {
    "back": "Zurück",
    "badge": "OrizonDesk BASIC",
    "price": "75 €",
     "price_monthly": "7.99 €",
    "price_period": "/ JÄHRLICH",
  "price_period_monthly": "/ MONATLICH",
    "feature_employees": "10 Mitarbeiter",
    "feature_cloud": "5GB Cloud",
    "feature_qr": "QR-Code-Badge",
    "feature_support": "E-Mail-Support",
    "step1": {
      "title": "Rechnung und Daten",
      "subtitle": "Fülle das Formular aus, um das Basic-Paket zu aktivieren",
      "label_name": "Vorname",
      "label_surname": "Nachname",
      "label_company": "Firmenname",
      "label_email": "E-Mail",
      "label_phone": "Telefon",
      "placeholder_name": "Dein Vorname",
      "placeholder_surname": "Dein Nachname",
      "placeholder_company": "Name des Unternehmens",
      "placeholder_email": "admin@firma.de",
      "placeholder_phone": "+49",
      "terms_part1": "Ich akzeptiere die",
      "terms_link": "Allgemeinen Geschäftsbedingungen",
      "terms_part2": "und die Datenschutzrichtlinie",
      "btn_next": "Zur Zahlung",
      "error_generic": "Ein Fehler ist aufgetreten.",
      "error_email_exists": "Diese E-Mail ist bereits im System registriert.",
      "error_server": "Serverfehler. Bitte versuche es später erneut."
    },
    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "BASIC-PAKET für",
      "total_label": "GESAMTBETRAG:",
      "total_amount": "75.00 €",
      "total_amount_monthly": "7.99 €",
      "summary_title": "Datenzusammenfassung",
      "summary_name": "Vor- und Nachname",
      "summary_company": "Firma",
      "summary_email": "E-Mail",
      "summary_phone": "Telefon",
      "summary_package": "Paket",
      "summary_package_value": "Basic — 365 Tage",
      "summary_package_value_monthly": "Basic — 30 Tage",
      "btn_pay": "Zur Zahlung — 75.00 €",
      "btn_pay_montlhy": "Zur Zahlung — 7.99 €",
      "ssl_label": "Sichere Zahlung über Dodo Payments · SSL-verschlüsselt",
      "btn_back": "← Zurück zur Datenbearbeitung",
      "loading": "Sichere Zahlung wird geöffnet ...",
      "error_checkout": "Fehler bei der Zahlung. Bitte versuche es erneut.",
      "error_expired": "Die Zahlungssitzung ist abgelaufen. Bitte versuche es erneut.",
      "error_open": "Fehler beim Öffnen der Zahlung. Bitte versuche es erneut."
    },
    "footer_ssl": "SSL-verschlüsselte Transaktion · Dodo Payments"
  },
  "basic_payment_success": {
    "loading": "Basic-Paket wird aktiviert ...",
    "badge": "OrizonDesk BASIC",
    "title": "Basic aktiviert!",
    "subtitle": "Überprüfe deine E-Mails",
    "subtitle2": "für die Zugangsdaten und die Kontoaktivierung.",
    "receipt_title": "Transaktionsbestätigung",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Paket",
    "receipt_package_value": "Basic — 365 Tage",
    "receipt_package_value_monthly": "Basic — 30 Tage",
    "receipt_status": "Status",
    "receipt_status_value": "Bezahlt & Verifiziert",
    "btn_home": "Zur Startseite",
    "error_title": "Aktivierungsfehler",
    "error_subtitle": "Die Zahlung war erfolgreich, aber die Aktivierung wurde nicht abgeschlossen.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Fehler",
    "error_contact": "Bewahre die Payment ID auf und kontaktiere uns unter",
    "error_status_failed": "Zahlung fehlgeschlagen. Status:"
  },
  "enterprise_payments": {
    "back": "Zurück",
    "badge": "OrizonDesk ENTERPRISE",
    "price": "615 €",
    "price_monthly": "59.99 €",
    "price_period": "/ JÄHRLICH",
    "price_period_monthly": "/ MONATLICH",
    "feature_employees": "Unbegrenzt",
    "feature_cloud": "100GB Cloud",
    "feature_audit": "Erweitertes Audit",
    "feature_support": "Dedizierter Support",
    "step1": {
      "title": "Rechnung und Daten",
      "subtitle": "Fülle das Formular aus, um das Enterprise-Paket zu aktivieren",
      "label_name": "Vorname",
      "label_surname": "Nachname",
      "label_company": "Firmenname",
      "label_email": "E-Mail",
      "label_phone": "Telefon",
      "placeholder_name": "Dein Vorname",
      "placeholder_surname": "Dein Nachname",
      "placeholder_company": "Name des Unternehmens",
      "placeholder_email": "admin@firma.de",
      "placeholder_phone": "+49",
      "terms_part1": "Ich akzeptiere die",
      "terms_link": "Allgemeinen Geschäftsbedingungen",
      "terms_part2": "und die Datenschutzrichtlinie",
      "btn_next": "Zur Zahlung",
      "error_generic": "Ein Fehler ist aufgetreten.",
      "error_email_exists": "Diese E-Mail ist bereits im System registriert.",
      "error_server": "Serverfehler. Bitte versuche es später erneut."
    },
    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "ENTERPRISE-PAKET für",
      "total_label": "GESAMTBETRAG:",
      "total_amount": "615.00 €",
      "total_amount_monthly": "59.99 €",
      "summary_title": "Datenzusammenfassung",
      "summary_name": "Vor- und Nachname",
      "summary_company": "Firma",
      "summary_email": "E-Mail",
      "summary_phone": "Telefon",
      "summary_package": "Paket",
      "summary_package_value": "Enterprise — 365 Tage",
      "summary_package_value_monthly": "Enterprise — 30 Tage",
      "btn_pay": "Zur Zahlung — 615 €",
      "btn_pay_monthly": "Zur Zahlung — 59.99 €",
      "ssl_label": "Sichere Zahlung über Dodo Payments · SSL-verschlüsselt",
      "btn_back": "← Zurück zur Datenbearbeitung",
      "loading": "Sichere Zahlung wird geöffnet ...",
      "error_checkout": "Fehler bei der Zahlung. Bitte versuche es erneut.",
      "error_expired": "Die Zahlungssitzung ist abgelaufen. Bitte versuche es erneut.",
      "error_open": "Fehler beim Öffnen der Zahlung. Bitte versuche es erneut."
    },
    "footer_ssl": "SSL-verschlüsselte Transaktion · Dodo Payments"
  },
  "enterprise_payment_success": {
    "loading": "Enterprise-Paket wird aktiviert ...",
    "badge": "OrizonDesk ENTERPRISE",
    "title": "Enterprise aktiviert!",
    "subtitle": "Überprüfe deine E-Mails",
    "subtitle2": "für die Zugangsdaten und die Kontoaktivierung.",
    "receipt_title": "Transaktionsbestätigung",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Paket",
    "receipt_package_value": "Enterprise — 365 Tage",
    "receipt_package_value_monthly": "Enterprise — 30 Tage",
    "receipt_status": "Status",
    "receipt_status_value": "Bezahlt & Verifiziert",
    "btn_home": "Zur Startseite",
    "error_title": "Aktivierungsfehler",
    "error_subtitle": "Die Zahlung war erfolgreich, aber die Aktivierung wurde nicht abgeschlossen.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Fehler",
    "error_contact": "Bewahre die Payment ID auf und kontaktiere uns unter",
    "error_status_failed": "Zahlung fehlgeschlagen. Status:"
  },


  "inventory": {
    "back": "Zurück",
    "new_table": "Neue Tabelle",
    "title": "Inventar & Lager",
    "subtitle": "Verwalten Sie Ihre Ressourcen und erstellen Sie benutzerdefinierte Datensätze.",
    "stats": {
        "total": "Tabellen",
        "total_desc": "Aktive Tabellen",
        "records": "Datensätze",
        "records_desc": "Gesamtzeilen in allen Tabellen",
        "last_update": "Aktualisiert",
        "last_update_desc": "Datum des letzten Eintrags"
    },
    "active_tables": "Aktive Tabellen",
    "open_record": "Register öffnen",
    "no_tables": {
      "title": "Keine Tabellen erstellt",
      "desc": "Erstellen Sie Ihre erste benutzerdefinierte Inventartabelle, um mit der Dateneingabe zu beginnen.",
      "btn": "Jetzt starten"
    }
  },

  "inventory_table": {
    "back": "Zurück",
    "search_placeholder": "Suchen...",
    "btn_new_entry": "Neuer Eintrag",
    "export_excel": "Tabelle als Excel exportieren (.xlsx)",
    "settings_title": "Spalten- und Tabelleneinstellungen",
    "add_row_title": "Neue Zeile zur Tabelle hinzufügen",
    "actions": "Aktionen",
    "loading": "Laden...",
    "confirm_delete_row": "Diese Zeile löschen?",
    "confirm_delete_column": "Spalte \"{{name}}\" löschen?",
    "error_prefix": "Fehler: ",
    "table_default_name": "Tabelle",
    "status_true": "Wahr",
    "status_false": "Falsch"
  },

  "create_table_modal": {
    "title": "Neue Tabelle",
    "system_info": "System: AWS (Supabase) (ISO 8601)",
    "label_table_name": "Tabellenname",
    "placeholder_table_name": "z.B. LAGER_A",
    "label_columns": "Spaltenkonfiguration",
    "placeholder_col_name": "Feldname",
    "label_dropdown": "Dropdown aktivieren",
    "btn_cancel": "Abbrechen",
    "btn_create": "Tabelle erstellen",
    "btn_creating": "Erstellen...",
    "alert_empty_name": "Bitte geben Sie einen Tabellennamen ein!",
    "alert_error": "Fehler: ",
    "types": {
      "text": "Text",
      "number": "Zahl",
      "date": "Datum (JJJJ-MM-TT)",
      "boolean": "Boolean (Wahr/Falsch)"
    }
  },

  "insert_line": {
    "header": {
      "title": "Neuer Datensatz",
      "loading_structure": "Datenbankstruktur wird geladen...",
      "table_label": "Tabelle: "
    },
    "validation": {
      "invalid_date": "Muss JJJJ-MM-TT sein",
      "invalid_number": "Muss eine Zahl sein"
    },
    "inputs": {
      "dropdown_placeholder": "Auswählen oder eingeben...",
      "true": "WAHR",
      "false": "FALSCH"
    },
    "footer": {
      "cancel": "Abbrechen",
      "save": "Speichern"
    }
  },

  "settings_columns": {
    "title": "Feldkonfiguration",
    "subtitle": "Direkte Hinzufügung zur Datenbank",
    "label_new_field": "Neues Feld",
    "placeholder_name": "Name der neuen Spalte...",
    "label_dropdown": "Dropdown aktivieren",
    "btn_add": "Feld hinzufügen",
    "btn_adding": "Hinzufügen...",
    "label_existing_fields": "Vorhandene Felder",
    "status_dropdown_on": "● Dropdown Aktiv",
    "status_dropdown_off": "○ Dropdown aktivieren",
    "btn_close": "Einstellungen schließen",
    "types": {
      "text": "Text",
      "number": "Zahl",
      "date": "Datum (JJJJ-MM-TT)",
      "boolean": "Boolean (Wahr/Falsch)"
    }
  },

  "update_info": {
    "header": {
      "edit_title": "Datensatz bearbeiten",
      "view_title": "Detaillierte Informationen",
      "edit_subtitle": "Werte bearbeiten und speichern",
      "view_subtitle": "Datensatzansicht aus der Tabelle"
    },
    "types": {
      "boolean": "[ Boolean ]",
      "date": "[ Datum ]",
      "number": "[ Zahl ]",
      "text": "[ Text ]"
    },
    "labels": {
      "negative_value": "Wert ist unter null",
      "last_update": "Zuletzt geändert",
      "active": "Aktiv (Wahr)",
      "inactive": "Inaktiv (Falsch)",
      "true": "WAHR",
      "false": "FALSCH"
    },
    "footer": {
      "cancel": "Abbrechen",
      "save_changes": "Änderungen speichern",
      "close_view": "Ansicht schließen"
       }
    },



"ferie": {
  "modal_title": "Urlaubsantrag",
  "type_single_day": "Ein Tag",
  "type_multi_day": "Mehrere Tage",
  "type_hours": "Stunden",
  "date_label": "Datum",
  "from_label": "Von",
  "to_label": "Bis",
  "from_time_label": "Von Uhrzeit",
  "to_time_label": "Bis Uhrzeit",
  "weekend_included": "Wochenende Inklusive",
  "type_label": "TYP",
  "shift_label": "Schicht",
  "shift_daily": "Ganztägig",
  "shift_first": "Erste Schicht",
  "shift_second": "Zweite Schicht",
  "shift_third": "Dritte Schicht",
  "shift_other": "Sonstiges",
  "note_label": "Notiz (optional)",
  "note_placeholder": "Notiz hinzufügen...",
  "cancel_btn": "Abbrechen",
  "submit_btn": "Antrag Senden",
  "new_request_btn": "Neuer Antrag",
  "errors": {
    "select_date": "Bitte wählen Sie ein Datum.",
    "select_range": "Bitte wählen Sie Von und Bis.",
    "select_date_time": "Bitte wählen Sie Datum und Uhrzeit.",
    "submit_error": "Fehler beim Senden des Antrags."
  },
  "admin": {
    "page_title": "Urlaubsverwaltung",
    "requests_title": "Urlaubsanträge der Mitarbeiter",
    "search_placeholder": "Mitarbeiter suchen...",
    "all_statuses": "Alle Status",
    "approve_btn": "Genehmigen",
    "reject_btn": "Ablehnen",
    "edit_btn": "Bearbeiten",
    "save_changes": "Änderungen Speichern",
    "new_request_title": "Neuer Antrag (Urlaub)",
    "select_employee_label": "Mitarbeiter",
    "select_employee_placeholder": "Mitarbeiter auswählen...",
    "auto_accept_notice": "Dieser Antrag wird als bereits genehmigt gespeichert.",
    "errors": {
      "select_employee": "Wählen Sie einen Mitarbeiter."
    }
  },
  
  "my_requests_title": "Meine Urlaubsanträge",
  "all_years": "Alle Jahre",
  "all_months": "Alle Monate",
  "reset_btn": "Zurücksetzen",
  "no_requests": "Keine Anträge gesendet",
  "days_label": "Tage",
  "details_tooltip": "Details",
  "load_more_btn": "Mehr Laden",
  "details_title": "Antragsdetails",
  "time_label": "Uhrzeit",
  "days_column_label": "Tage",
  "yes": "Ja",
  "no": "Nein",
  "timeline_title": "Verlauf",
  "timeline_sent": "Antrag gesendet",
  "timeline_answered_by": "Beantwortet von",
  "timeline_answer_date": "Antwortdatum",
  "delete_btn": "Antrag Löschen",
  "delete_confirm_text": "Sind Sie sicher? Diese Aktion kann nicht rückgängig gemacht werden.",
  "confirm_delete_btn": "Löschen Bestätigen",
  "status_accepted": "Angenommen",
  "status_rejected": "Abgelehnt",
  "status_pending": "Ausstehend",
  "months": {
    "01": "Januar", "02": "Februar", "03": "März", "04": "April",
    "05": "Mai", "06": "Juni", "07": "Juli", "08": "August",
    "09": "September", "10": "Oktober", "11": "November", "12": "Dezember"
  }
}


        }
      },
      en: {
        translation: {
          "header": {
            "notifications": "Notifications", "settings": "Settings", "help": "Help", "my_profile": "My Profile", "logout": "Logout", "change_lang": "Change Language", "loading": "Loading..."
          },

          "auth": {
  "access_portal": "Portal Access",
  "login": "Login",
  "email": "Email",
  "password": "Password",
  "forgot_password": "Forgot password?",
  "errors": {
    "email_req": "Email is required",
    "pass_req": "Password is required",
    "invalid_credentials": "Email or password is incorrect"
  
},
"company_inactive": {
  "title": "Company Inactive",
  "desc": "Access to OrizonDesk for this company has been suspended. This usually happens when the trial period has ended or the subscription has expired.",
  "contact_support": "Contact Support",
  "renew_btn": "Renew Subscription",
"renew_hint": "Only administrators can renew the subscription"
},

  "reset_title": "Reset Password",
  "reset_desc": "Enter your email to receive reset instructions.",
  "send_link": "Send Reset Link",
  "back_to_login": "Back to Login",
  "success_msg": "Email sent successfully!",
  "update_password": {
    "title": "New Password",
    "desc": "Enter your new password below.",
    "new_password": "New password",
    "confirm_password": "Confirm password",
    "button": "Update Password",
    "success": "Password updated successfully!",
    "error_match": "Passwords do not match"
  }
},

          "hero": {
            "welcome": "Welcome to", 
            "subtitle": "Digitalize your employee management. Eliminate paper and manage payslips, contracts, and company documents in one secure portal.",
            "cta_button": "Access the Portal", "gdpr_note": "Secure system, GDPR compliant for digital preservation"
          },
          "cta": {
            "title": "Bring your company into the digital future", 
            "description": "Join companies that have eliminated paper with OrizonDesk Portal for smart document management.",
            "button_contact": "Contact Orizon Team", "feature_card": "Immediate activation", "feature_setup": "5-minute setup", "feature_support": "Technical support",
            "button_learn_more": "What is OrizonDesk?"
          },
          "features": {
            "main_title": "Why Go Digital with OrizonDesk",
            "main_subtitle": "The complete SaaS solution to eliminate paper folders and automate document distribution",
            "security_title": "Secure Archive",
            "security_desc": "Payslips and sensitive documents protected by end-to-end encryption and secure access.",
            "speed_title": "Fast Distribution",
            "speed_desc": "Instant delivery of documents to employees with one click, eliminating paper waste.",
            "privacy_title": "Total Compliance",
            "privacy_desc": "Full adherence to GDPR and current privacy and data protection regulations.",
            "support_title": "Dedicated Support",
            "support_desc": "Specialized assistance to accompany your company in the digital transition from paper."
          },
          "footer": {
            "rights": "All rights reserved.",
            "gdpr_text": "Compliant with GDPR and privacy regulations",
            "privacy": "Privacy",
             "terms": "Terms of Service",
            "contact": "Contact"
            },

        "landing": {
            "seo_title": "OrizonDesk - Secure Authentication | Document Digitalization",
            "seo_description": "Secure platform for managing payslips and company documents. Go paperless and manage employees digitally in compliance with GDPR.",
             "footer_privacy": "Privacy",
              "footer_terms": "Terms of Service",
            "footer_contact": "Contact",
            "footer_rights": "All rights reserved.",
            "footer_gdpr": "Compliant with GDPR and privacy regulations"
        },
        "testimonials": {
            "title": "What Our Clients Say",
            "subtitle": "Real testimonials from companies that have chosen OrizonDesk Portal for their secure employee document management"
        },

        "dashboard": {
  "welcome_card": {
    "loading": "Loading...",
    "morning": "Good morning",
    "afternoon": "Good afternoon",
    "evening": "Good evening",
    "subtitle": "Manage {{azienda}}'s documents in total security."
  }
},

"dipendente": {
  "welcome_card_dipendente": {
    "loading_dipendente": "Loading...",
    "morning_dipendente": "Good morning",
    "afternoon_dipendente": "Good afternoon",
    "evening_dipendente": "Good evening",
    "subtitle_dipendente": "Access and download your documents from {{azienda}} with total security."
  }
},


"owner_welcome": {
  "loading": "Loading...",
  "morning": "Good morning",
  "afternoon": "Good afternoon",
  "evening": "Good evening",
  "role_subtitle": "You are logged in as CEO of {{azienda}}."
},
"create_company": {
    "back": "Back",
    "title": "Register a New Company",
    "subtitle": "Enter the data to create the new company portal",
    "admin_section": "Administrator Details",
    "company_section": "Company Details",
    "plan_section": "Plan Details",
    "success": "Company and administrator registered successfully!",
    "button": "Create Company",
    "labels": {
      "name": "First Name",
      "surname": "Last Name",
      "cf": "Tax ID / SSN",
      "phone": "Phone",
      "email": "Access Email",
      "company_name": "Company Name",
      "address": "Address",
      "vat": "VAT Number",
      "plan": "Select Plan",
      "start": "Contract from",
      "end": "Contract to",
      "max_emp": "Max. Employees:",
      "cloud_space": "Cloud Space:"
    },
    "plans": {
      "basic": "BASIC (10 employees / 5GB)",
      "premium": "PREMIUM (50 employees / 15GB)",
      "enterprise": "ENTERPRISE (∞ employees / 100GB)"
    },
    "info": {
      "password_auto": "The Tax ID (SSN) will be used as the initial password for access."
    },
    "errors": {
      "email_req": "Email is required",
      "cf_req": "Tax ID is required",
      "name_req": "First name is required",
      "company_req": "Company name is required",
      "date_req": "Expiration date is required"
    }
  },

"hero_owner": {
  "title": "Expand Your Business",
  "subtitle": "Create a new company in the Orizon system. You will be able to manage new employees, documents, and permissions for each individual entity.",
  "button": "Register New Company"
},

  "home_superadmin": {
    "sections": {
      "quick_actions": "Quick Actions"
    },
    "stats": {
      "active_sessions": "My Documents",
      "total_employees": "Total Employees",
      "pending_notif": "Pending Notifications",
      "total_aziende": "Total Companies",
      "avg_time": "PLAN STATUS",
    "check_usage": "check resource usage",
      "vs_last_month": "vs last month"
    },
    "actions": {
      "profile": { "title": "Manage Profile", "desc": "Update your personal information" },
      "settings": { "title": "System Settings", "desc": "Configure application preferences" },
      "create_employee": { "title": "Register Employee", "desc": "Create a new employee portal" },
      "support": { "title": "Help & Support", "desc": "Access the documentation and contact support" },
      "trash": { "title": "Recycle Bin", "desc": "Manage deleted files" },
      "holidays_management": { "title": "Vacation Management", "desc": "Approve or reject employee requests" },
      "inventory": { "title": "Inventory System", "desc": "Manage your table" }
    }
  },
  "home_dipendente": {
    "stats": {
      "my_documents": "My Documents",
      "monthly_hours": "Monthly Hours",
      "pending_notif": "Notifications",
      "avg_session": "Avg. Session",
      "vs_last_month": "vs last month"
    },
    "actions": {
      "notifications": { "title": "Notification Center", "desc": "Review your recent notifications" }
    },
    "activities_title": "Recent Activity",
    "activities_subtitle": "Your latest actions in the application",
    "no_activities": "No recent activity to display",
    "activities": {
      "login_title": "Access Granted",
      "login_desc": "You have accessed the system from a new device"
    }
  },

"create_employee": {
  "back": "Back",
  "title": "Register New Employee",
  "subtitle": "User will be automatically associated with:",
  "section_title": "Personal Information",
  "labels": {
    "name": "First Name",
    "surname": "Last Name",
    "cf": "Tax Code / ID",
    "email": "Email",
    "phone": "Phone"
  },


  "placeholders": {
    "cf": "Enter Tax Code"
  },
  "submit_btn": "Create Employee Portal",
  "success_msg": "Registration portal invitation sent successfully.",
  "errors": {
    "email_req": "Email is required",
    "cf_req": "Tax Code is required",
    "name_req": "First name is required",
    "no_company": "Error: Impossible to identify the source company.",
    "limit_title": "Limit reached",
"limit_reached": "The company has reached the maximum limit of {{max}} employees.",
"upgrade_now": "View status and upgrade"
  }
},

"legal": {
  "back": "Go back",
  "title": "Legal Information & Privacy",
  "version": "Orizon Desk Portal • Version 1.2.1 • 2026",
  "terms": {
    "title": "Terms of Use",
    "p1": "Orizon Desk Portal is a closed business platform intended exclusively for company employees and management. By accessing the portal, the user agrees to comply with internal digital communication rules.",
    "li1": "Sharing access data (email and password) with third parties is prohibited.",
    "li2": "Any attempt of unauthorized access to parts of the system for which the user does not have permission is considered a breach of labor discipline.",
    "li3": "The portal may be used exclusively for viewing personal documents, work records, and internal company communication."
  },
  "privacy": {
    "title": "Transparency and Access",
    "sub": "Who has access to your documents?",
    "user_title": "Employee",
    "user_desc": "Has full visibility of their payslips, CUD, medical certificates... Can view and download them at any time.",
    "admin_title": "Administrators",
    "admin_desc": "Authorized HR and accounting staff can upload, update, or delete documents. This access is necessary for the digital distribution of documentation.",
    "note": "Privacy Note: Company administrators access documents exclusively within the scope of their professional duties. Every access to documentation is system-logged to prevent abuse."
  },
  "security": {
    "title": "Technical Data Protection",
    "enc_t": "Data Encryption",
    "enc_d": "All documents are encrypted during transfer (SSL) and at rest on the server (AES-256). Your password is 'hashed' and no one can see it in its original form.",
    "infra_t": "Database Infrastructure (AWS & Google Cloud)",
    "infra_d": "Data is stored on high-security servers meeting GDPR and SOC2 standards. We use Row-Level Security (RLS) to ensure the database rejects any unauthorized request."
  },
  "rights": {
    "title": "Your Rights",
    "r1": "Right of access to data",
    "r2": "Right to rectify inaccurate information",
    "r3": "Right to account deletion",
    "r4": "Right to data portability"
  },
  "contact_info": "For any additional information regarding your rights, please contact:",
  "rights_reserved": "© 2026 Orizon AIX. All rights reserved."
},

"contact": {
  "back": "Go back",
  "title": "Contact Us",
  "subtitle": "Have a question? We are here to help.",
  "success_title": "Sent Successfully!",
  "success_desc": "Your message has been sent. We will get back to you as soon as possible.",
  "label_name": "Full Name",
  "label_email": "Email Address",
  "label_subject": "Subject",
  "label_message": "Your Message",
  "placeholder_name": "Your full name",
  "placeholder_subject": "Question regarding OrizonDesk portal...",
  "placeholder_message": "Type your inquiry here...",
  "btn_send": "Send Message",
  "info_email": "Direct Email",
  "info_web": "Website"
},

"profile": {
    "loading": "Loading...",
    "no_data": "No data found.",
    "full_name": "Full Name",
    "email": "Business Email",
    "phone": "Phone",
    "not_specified": "Not specified",
    "cf": "Tax Code / ID",
    "role": "Role",
    "employee": "Employee",
    "reg_date": "Registration Date",
    "last_access": "Last Access",
    "first_session": "First session",
    "unique_id": "Unique Identifier (ID)",
    "change_password": "Change Password"
  },

 "profile_page": {
  "title": "My Profile",
  "back": "Back",
  "qr_badge": "My QR Badge",
  "my_holidays": "My Holidays"
},

 "change_password": {
    "title": "Change Password",
    "subtitle": "Update your login credentials",
    "security_section": "Account Security",
    "labels": {
      "old": "Current Password",
      "new": "New Password",
      "confirm": "Confirm Password"
    },
    "errors": {
      "mismatch": "Passwords do not match",
      "wrong_old": "Current password is incorrect"
    },
    "success": "Password updated successfully!",
    "submit_btn": "Save Changes"
  },

  "dipendenti_list": {
  "loading": "Loading employees...",
  "title": "Staff Management",
  "subtitle": "View company employees",
  "search_placeholder": "Search employee...",
  "no_results": "No employees found.",
  "filter_active": "Active",
  "filter_inactive": "Inactive",
  "table": {
    "name": "Employee",
    "email": "Email",
    "role": "Role",
    "actions": "Actions"
  }
},

"months": {
    "january": "January", "february": "February", "march": "March", "april": "April", "may": "May", "june": "June",
    "july": "July", "august": "August", "september": "September", "october": "October", "november": "November", "december": "December"
  },
  "timbrature": {
    "archive_title": "My Timecards Archive",
    "history_title": "Attendance History",
    "no_data": "No timecards found for this period.",
    "filters": {
      "month": "Month",
      "year": "Year",
      "view": "View",
      "loading": "Loading..."
    },
    "stats": {
      "ord": "Ordinary Hours",
      "straord": "Overtime Hours",
      "monthly_total": "Monthly Total",
      "total": "Total"
    },
    "table": {
      "name": "First Name",
      "surname": "Last Name",
      "date": "Date",
      "entry": "Entry",
      "exit": "Exit",
      "ord_short": "Ord. (8h)",
      "straord_short": "Overtime"
    }
  },

  "categ": {
  "title": "New Category",
  "title2": "New Category",
  "name": "Category Name",
  "placeholder": "Enter name...",
  "hint": "Available for all employees of this company.",
  "error_duplicate": "Error: This category already exists for this company!",
  "error_generic": "An error occurred",
  "manager_title": "Manage Categories",
  "add_new": "Add New",
  "your_list": "Your Categories",
  "no_custom": "No custom categories found",
  "error_delete": "Error during deletion",
  "confirm_delete": "Are you sure you want to delete this category?",
  
    "input_placeholder": "Category name...",
    "custom_list": "Custom categories:",
    "add": "Add"
},

  "settings": {
  "title": "Settings",
  "theme_title": "Personalize",
  "dark_mode": "Dark Mode",
  "light_mode": "Light Mode",
  "subtitle": "Customize your experience",
  "group_notifications": "Notifications & Alerts",
  "group_security": "Security & Access",
  "group_preferences": "App Preferences",
  "push_label": "Push Notifications",
  "push_desc": "Receive real-time alerts",
  "email_label": "Weekly Reports",
  "email_desc": "Hours summary via email",
  "bio_label": "Biometrics",
  "delete_label": "Auto-Delete",
  "delete_desc": "Automatically delete files from trash after 30 days",
  "bio_desc": "Fast FaceID/Fingerprint unlock",
  "logout_label": "Auto Log-out",
  "logout_desc": "Exit after 30 min of inactivity",
  "dark_label": "Dark Mode",
  "dark_desc": "High contrast interface",
  "gps_label": "GPS Accuracy",
  "gps_desc": "Improve location tracking",
  "version": "App Version",
  "reset": "Reset all preferences"
},




  "months": {
    "Gennaio": "January",
    "Febbraio": "February",
    "Marzo": "March",
    "Aprile": "April",
    "Maggio": "May",
    "Giugno": "June",
    "Luglio": "July",
    "Agosto": "August",
    "Settembre": "September",
    "Ottobre": "October",
    "Novembre": "November",
    "Dicembre": "December"
  },
  "myDocuments": {
    "title": "Documents Archive",
    "auditLogButton": "Audit Monitoring",
    "subtitle": "View and download your documents, certificates, and payslips.",
    "backHome": "Back to Home",
    "searchPlaceholder": "File name, type, course...",
    "searchLabel": "Search in your archive",
    "filterAnno": "Year",
    "filterTipo": "Type",
    "filterAll": "All",
    "table": {
      "document": "Document",
      "type": "Category",
      "details": "Details / Expiry",
      "download": "Download",
      "uploadedOn": "Uploaded on",
      "expires": "Expires",
      "noDocs": "No documents found."
    },
    "types": {
      "bustaPaga": "Payslip",
      "cu": "Tax Certificate (CU)",
      "contratto": "Contract",
      "visitaMedica": "Medical Visit",
      "certificatoCorso": "Course Certificate",
      "altro": "Other"
    }
  },

  "qrBadge": {
  "title": "My QR Badge",
  "loading": "Fetching data...",
  "instructions": "Show this code to the scanner <br /> to clock in your presence",
  "notGenerated": "Badge not yet generated",
  "contactAdmin": "Contact administration to activate your QR code.",
  "download": "Download Image",
  "close": "Close"
},

"qrAdmin": {
  "title": "Corporate Badge",
  "sync": "Syncing...",
  "notFound": "Badge not found",
  "download": "Download Badge",
  "regenerate": "Regenerate Badge",
  "generateNow": "Generate Now",
  "confirmNew": "Do you want to generate a new QR Badge?",
  "confirmOverwrite": "Do you want to overwrite the existing badge?",
  "success": "Badge updated successfully!",
  "securityError": "Error (Security Policy): Make sure your account has UPDATE permissions in storage."
},

"attendance": {
  "filterTitle": "Attendance Register",
  "month": "Month",
  "year": "Year",
  "btnLoad": "Load Attendance",
  "loading": "Loading...",
  "history": "ATTENDANCE HISTORY",
  "noData": "No data found for the selected period.",
  "stats": {
    "ord": "Total Ordinary",
    "stra": "Total Overtime",
    "total": "Grand Total"
  },
  "table": {
    "date": "Date",
    "entry": "Entry",
    "exit": "Exit",
    "ord_short": "Ordinary (8h)",
    "stra_short": "Overtime",
    "total": "Total"
  }
},

"company_modal": {
    "header_subtitle": "COMPANY DETAILS",
    "address_label": "ADDRESS",
    "registered_label": "REGISTERED"
  },

  

  "companies": {
    "title": "Company List",
    "total": "Total",
    "search_placeholder": "Search companies...",
    "col_name": "Company",
    "col_actions": "Details",
    "no_data": "No companies found."
  },
  "company_modal": {
    "header_subtitle": "COMPANY DETAILS",
    "address_label": "ADDRESS",
    "registered_label": "REGISTERED"
  },

  "orizon_desk": {
    "back": "Back to portal",
    "hero_title_1": "What is the",
    "hero_title_2": "OrizonDesk",
    "hero_title_3": "portal?",
    "hero_subtitle": "Digital revolution in human resource management",
    "main_desc_title": "Goodbye paper, welcome Cloud",
    "main_desc_text": "OrizonDesk Portal is a centralized digital platform designed to transform the way companies communicate with their employees. Our goal is clear: total elimination of paper documentation and transition to a secure, fast, and transparent digital environment.",
    "for_companies": "For companies",
    "for_companies_desc": "Automation of HR processes, data security, and time savings.",
    "for_workers": "For workers",
    "for_workers_desc": "Instant access to personal documents and work records via mobile device.",
    "feature_1_title": "Digital Archive",
    "feature_1_li1": "Pay stubs (Bustepaga)",
    "feature_1_li2": "Certificates and training",
    "feature_1_li3": "Employment contracts",
    "feature_1_li4": "HR notifications",
    "feature_2_title": "Attendance Tracking",
    "feature_2_desc": "Clock-in system via QR code. Workers use their mobile device to check in and out of work.",
    "feature_2_li1": "Automatic hour calculation",
    "feature_2_li2": "Overtime tracking",
    "feature_2_li3": "Employee hour overview",
    "cta_title": "Start digitalization today",
    "cta_subtitle": "The procedure is simple and fast",
    "step_1_title": "Contact us",
    "step_1_desc": "Choose a package based on the number of workers and required Cloud storage.",
    "step_2_title": "Company Activation",
    "step_2_desc": "Receive administrative credentials and create your employee profiles.",
    "step_3_title": "Workers are ready",
    "step_3_desc": "Employees receive a confirmation email, log in, and instantly see their documents and hours.",
    "footer_contact_text": "Contact our team for a quote",
    "footer_rights": "All rights reserved."
  },

  "common": {
    "loading": "Loading...",
    "nd": "N/A",
    "read": "READ",
  "unread": "UNREAD",
    "close": "CLOSE",
    "not_available": "Not available",
     "loading": "Loading...",
    "all": "All",
    "actions": "Actions",
    "annual": "Annual",
    "edit": "Edit",
    "save": "Save",
    "saving": "Saving...",
    "cancel": "Cancel",
    "close": "Close",
    "delete": "Delete",
    "preview": "Preview",
    "download": "Download",
    "downloading": "Downloading...",
    "load_more": "Load more",
    "nd": "N/A",
    "read": "READ",
    "unread": "UNREAD",
    "yes": "Yes",
    "no": "No"
  },
  "employee": {
    "back_to_list": "Back to Employee List",
    "generate_qr": "Generate QR Badge",
    "info_title": "Employee Information",
    "not_active": "Not Active"
  },
  "docs": {
     "title": "Company Documents",
    "subtitle": "Digital management and archiving of company documents",
     "refid": "Reference No. / ID",
    "refid_placeholder": "E.g. CON-2026-001 or Transaction No.",
    "course_name": "Course Name",
    "course_placeholder": "E.g: Workplace Safety",
    "valid_from": "Valid From",
    "valid_to": "Valid To",
    "notes": "Notes / Description",
    "notes_placeholder": "Specify what this is about...",
    "no_notes": "No notes added.",
    "year": "Year",
    "month": "Month",
    "select_pdf_img": "Select PDF or Image",
    "upload_btn": "Upload Document",
    "uploading": "Uploading...",
    "filter_archive": "Filter Archive",
    "search_placeholder": "Search by name, type, reference no...",
    "list_title": "Uploaded Documents List",
    "col_name": "Document Name",
    "col_type": "Type",
    "col_ref": "Reference ID",
    "col_period": "Period / Validity",
    "col_date": "Upload Date",
    "expires": "Expires",
    "no_docs_found": "No documents found for the selected criteria.",
    "select_file_alert": "Select a file!",
    "missing_company": "Missing company data.",
    "upload_success": "Document uploaded successfully!",
    "upload_error": "Error during upload",
    "confirm_delete_title": "Confirm Deletion",
    "confirm_delete": "Are you sure you want to permanently delete this document? This will also remove the file from storage.",
    "confirm_delete_category": "Do you want to delete this category?",
    "category_exists": "This category already exists!",
    "category_error": "Error",
    "delete_success": "Document deleted successfully!",
    "delete_error": "Error during deletion",
    "download_error": "Unable to download the file.",
    "preview_error": "Error while loading the preview.",
    "update_success": "Document updated successfully!",
    "update_error": "Error during update",
    "edit_modal_title": "Edit Document",
    "info_modal_title": "Document Details",
    "edit_subtitle": "Edit parameters",
    "info_subtitle": "Data overview",
    "new_upload": "New Upload",
    "type": "Document Type",

     "types2": {
      "contract": "Contract",
      "course": "Certificate",
      "other": "Other"
    },

    "types": {
      "payslip": "Payslip",
      "cu": "Tax Certification (CU)",
      "contract": "Contract",
      "medical": "Medical Visit",
      "course": "Course Certificate",
      "other": "Other"
    },
    "course_name": "Course Name",
    "course_placeholder": "Ex: Safety at Work",
    "valid_from": "Valid From",
    "valid_to": "Valid To",
    "notes": "Notes / Description",
    "notes_placeholder": "Specify what it is...",
    "year": "Year",
    "month": "Month",
    "select_pdf_img": "Select PDF or Image",
    "upload_btn": "Upload Document",
    "uploading": "Uploading...",
    "filter_archive": "Filter Archive",
    "search_placeholder": "Search by name, type, date...",
    "list_title": "List of Uploaded Documents",
    "col_name": "Document Name",
    "col_type": "Type",
    "col_period": "Period/Validity",
    "col_date": "Upload Date",
    "expires": "Expires",
    "no_docs_found": "No documents found for selected criteria.",
    "select_file_alert": "Please select a file!",
    "upload_success": "Document uploaded successfully!",
    "upload_error": "Error during upload",
    "confirm_delete": "Are you sure you want to delete this document?",
    "delete_error": "Error during deletion",
    "download_error": "Unable to download file."
  },

  "employee_modal": {
    "title_info": "Employee Information",
    "title_edit": "Edit Employee",
    "first_name": "First Name",
    "last_name": "Last Name",
    "tax_code": "Tax Code",
    "email": "Email",
    "phone": "Phone",
    "created_at": "Created At",
    "last_login": "Last Login",
    "never": "Never",
    "alert_success": "Data updated successfully!",
    "alert_error": "Update error"
  },

  "notifikacije": {
    "title_not": "DOCUMENTS TO READ",
    "empty": "ALL READ!",
    "view_all": "GO TO MY DOCUMENTS"
  },

  "sidebar": {
    "dashboard": "Dashboard",
    "profile": "Profile",
    "settings": "Settings",
     "my_holidays": "My Holidays",
    "version": "V2.4.0 OrizonDesk"
  },

   "adminHome": {
    "categories": {
      "dipendenti": {
        "title": "EMPLOYEES",
        "subtitle": "Attendance, Documents & Shifts",
        "description": "Staff management, employment contracts, personal documents, attendance, shifts and clock-in reports."
      },
      "azienda": {
        "title": "COMPANY",
        "subtitle": "Profile & Documents",
        "description": "Archive and manage official company documents, lease agreements and internal administration."
      },
      "partner": {
        "title": "PARTNERS",
        "subtitle": "Clients & Suppliers",
        "description": "Complete registry of business partners, supply contracts, invoices and order history."
      }
    },
    "partnerModal": {
    "title": "Business Partners",
    "subtitle": "Select an option to continue",
    "newPartner": {
      "title": "NEW PARTNER",
      "desc": "Add a new client or supplier to the database with full details."
    },
    "allPartners": {
      "title": "ALL PARTNERS",
      "desc": "View and manage the complete list of partners and their related documents."
    }
  },
    "common": {
      "accessSection": "Go to section"
    }
  },
  

  "create_partner": {
  "back": "Back",
  "title": "New Business Partner",
  "subtitle": "Add a new partner for company:",
  "success_msg": "Partner saved successfully!",
  "manage_categories_btn": "Manage Categories",
  "select_placeholder": "-- Select type / category --",
  "default_types_group": "Default Types",
  "db_categories_group": "Database Categories",
  "submit_btn": "Save Partner",
  "my_partners_btn": "My Partners",

  "sections": {
    "basic": "1. Basic Information",
    "location": "2. Contact & Location",
    "banking": "3. Banking & Contact Person"
  },

  "labels": {
    "naziv": "Partner Name *",
    "tip": "Partner Type / Category",
    "pib_jib": "Tax ID / TIN",
    "pdv": "VAT Number",
    "broj_registracije": "Company Registration Number",
    "adresa": "Address",
    "postanski_broj": "Postal Code",
    "grad": "City",
    "drzava": "Country",
    "email": "Email",
    "telefon": "Phone",
    "web": "Website",
    "naziv_banke": "Bank Name",
    "bankovni_racun": "Bank Account (IBAN)",
    "kontakt_osoba": "Contact Person",
    "kontakt_telefon": "Contact Person Phone",
    "napomena": "Notes"
  },

  "types": {
    "dobavljac": "Supplier",
    "klijent": "Customer",
    "obostrano": "Customer / Supplier"
  },

  "placeholders": {
    "naziv": "e.g., ACME Ltd.",
    "pib_jib": "e.g., 12345678901",
    "pdv": "e.g., GB123456789",
    "napomena": "Enter additional notes about the partner..."
  },

  "errors": {
    "no_company": "Company not found",
    "name_req": "Partner name is required"
  },

  "category_modal": {
    "title": "Manage Categories",
    "existing_list": "Existing Categories",
    "no_categories": "No categories created yet.",
    "delete": "Delete category",
    "add_new": "Add New Category",
    "name_label": "Category Name *",
    "name_placeholder": "e.g., Subcontractor",
    "desc_label": "Category Description",
    "desc_placeholder": "Optional category description...",
    "save_btn": "Save Category",
    "close": "Close",
    "duplicate_error": "A category with this name already exists.",
    "save_error": "Error creating category",
    "delete_error": "Error deleting category",
    "confirm_delete": "Are you sure you want to delete this category?"
  }
},
  
"listapartner": {
  "back": "Back",
  "title": "Business Partners",
  "subtitle": "Manage your company's clients and suppliers",
  "new_partner": "New Partner",
  "filter_archive": "Search Partners",
  "search_placeholder": "Search by name, Tax ID, city, email...",
  "type": "Partner Type",
  "list_title": "Partner List",
  "no_partners_found": "No partners found for the selected criteria.",
  "col_name": "Partner Name",
  "col_piva": "Tax ID / VAT No.",
  "col_type": "Type",
  "col_location": "City / Address",
  "col_contact": "Contact",
  "col_date": "Creation Date",
  "view_documents": "Partner Documents",
  "select_placeholder": "-- Select --",
  "pdv": "VAT Number",
  "broj_registracije": "Registration Number",
  "adresa": "Address",
  "postanski_broj": "Postal Code",
  "grad": "City",
  "drzava": "Country",
  "email": "Email",
  "telefon": "Phone",
  "web": "Website",
  "naziv_banke": "Bank Name",
  "bankovni_racun": "Bank Account (IBAN)",
  "kontakt_osoba": "Contact Person",
  "kontakt_telefon": "Contact Person Phone",
  "napomena": "Note",
  "no_notes": "No notes added.",
  "update_success": "Partner updated successfully!",
  "update_error": "Error updating partner",
  "delete_error": "Error deleting partner",
  "edit_modal_title": "Edit Partner",
  "info_modal_title": "Partner Details",
  "edit_subtitle": "Edit data",
  "info_subtitle": "Data overview",
  "confirm_delete_title": "Confirm Deletion",
  "confirm_delete": "Are you sure you want to permanently delete this partner?",
  "confirm_delete_docs_warning": "WARNING: This action will permanently delete all {{count}} documents for this partner as well (from the database and server). This operation CANNOT be undone.",
  "confirm_delete_no_docs_warning": "WARNING: This operation CANNOT be undone.",
  "errors": {
    "name_req": "Partner name is required"
  },
  "types": {
    "dobavljac": "Supplier",
    "klijent": "Client",
    "obostrano": "Client / Supplier"
  }
},

"dettagli_partner": {
  "back": "Back",
  "gestione_documenti": "Document Management for",
  "subtitle": "Digital management and archiving of partner documents",
  "new_upload": "New Upload",
  "filter_archive": "Filter Archive",
  "search_placeholder": "Search by name, type, ref. no....",
  "year": "Year",
  "month": "Month",
  "type": "Type",
  "list_title": "Uploaded Documents List",
  "no_docs_found": "No documents found for the selected criteria.",
  "col_name": "Document Name",
  "col_ref": "Reference ID",
  "col_type": "Type",
  "col_period": "Period / Validity",
  "col_date": "Upload Date",
  "valid_from": "Valid From",
  "valid_to": "Valid To",
  "refid": "Ref. No. / ID",
  "refid_placeholder": "E.g., INV-2026-001",
  "notes": "Notes / Description",
  "notes_placeholder": "Specify what this document is about...",
  "no_notes": "No notes added.",
  "select_pdf_img": "Select PDF or Image",
  "select_file_alert": "Please select a file!",
  "uploading": "Uploading...",
  "upload_btn": "Upload Document",
  "upload_success": "Document uploaded successfully!",
  "upload_error": "Error during upload",
  "download_error": "Unable to download file.",
  "preview_error": "Error loading preview.",
  "update_success": "Document updated successfully!",
  "update_error": "Error during update",
  "delete_error": "Error during deletion",
  "missing_company": "Company data missing.",
  "missing_partner": "Partner not found.",
  "edit_modal_title": "Edit Document",
  "info_modal_title": "Document Details",
  "edit_subtitle": "Edit parameters",
  "info_subtitle": "Data overview",
  "confirm_delete_title": "Confirm Deletion",
  "confirm_delete": "Are you sure you want to permanently delete this document? This action will also remove the file from the storage server.",
  "categ_title2": "New Category",
  "categ_input_placeholder": "Category name...",
  "categ_custom_list": "Custom categories:",
  "categ_add": "Add",
  "category_exists": "This category already exists!",
  "category_error": "Error",
  "confirm_delete_category": "Do you want to delete this category?",
  "types": {
    "contract": "Contract",
    "invoice": "Invoice",
    "other": "Other"
  }
},

  "deactivate_modal": {
  "title": "Deactivate Employee",
  "subtitle": "You are about to deactivate access for user:",
  "reason_label": "Reason for deactivation (required)",
  "placeholder": "e.g. Termination of employment, disciplinary action...",
  "warning_login": "The user will no longer be able to log in to the system.",
  "warning_data": "All data and documents will remain saved in the archive.",
  "confirm_btn": "Confirm Deactivation",
  "cancel_btn": "Cancel",
  "error": "Error during deactivation",
  "success_deactivate": "Employee successfully deactivated"
},

"activate_modal": {
  "title": "Employee Activation",
  "subtitle": "Reactivating access for:",
  "reason_label": "Activation note (optional)",
  "placeholder": "E.g. Return from leave, new contract...",
  "warning_login": "User will get immediate access to the system.",
  "confirm_btn": "Activate",
  "cancel_btn": "Cancel",
  "success_activate": "Employee is active again!",
  "history_title": "Deactivation History",
  "deactivated_on": "Deactivated on:",
  "previous_reason": "Previous reason:",
  "no_history": "No previous deactivation data found"
},

"not_active_page": {
  "title": "Account Deactivated",
  "message": "Your access to the system has been temporarily deactivated by the administration.",
  "contact": "If you believe this is an error, please contact your supervisor.",
  "back_home": "Back to Home"
},

"pricing": {
  "monthly": "Monthly",
  "annual": "Annual",
  "save_discount": "Save 20%",
  "month": "month",
  "year": "year",
  "popular": "Most Popular",
  "choose_plan": "Choose Plan",
  "what_you_get": "What's included in the plan:",
  "confirm": "Confirm & Continue",
  "close": "Close",
  "basic_features": [
    "Up to 10 employees",
    "HR Archive (Payslips, contracts, training)",
    "Dynamic QR time tracking system",
    "Clients & Suppliers Module",
    "Document expiration notifications"
  ],
  "premium_features": [
    "Up to 50 employees",
    "Everything in Basic plan",
    "Audit Log system (Download tracking)",
    "Multi-location & department management",
    "Priority support"
  ],
  "enterprise_features": [
    "Unlimited employees",
    "Everything in Premium plan",
    "Custom API access & integrations",
    "Dedicated account manager",
    "On-site onboarding & setup"
  ],
  "descriptions": {
    "Basic": "Ideal for small businesses and trades. Includes a complete HR archive, an advanced dynamic QR system for tracking working hours, and a clients & suppliers module.",
    "Premium": "Perfect for fast-growing companies. Includes an advanced Audit Log to track document access and support for multiple separate locations.",
    "Enterprise": "A fully tailored solution for large organizations with unlimited employees, a dedicated account manager, and direct API integrations."
  },
  "badge_text": "Free Trial",
  "free_trial_btn": "Start 30-Day Free Trial",
  "free_trial_subtitle": "No credit card required. Setup in just 2 minutes.",
  "start_test_btn": "Start Testing"
},

"test_page": {
  "back": "Back to offers",
  "title": "Free Trial",
  "subtitle": "Try OrizonDesk for 30 days at no cost",
  "success_title": "Request sent successfully!",
  "success_desc": "Thank you for your interest. We have sent an email with the account activation link. Please check your inbox.",
  "basic_info": "Up to 10 employees • 5GB cloud storage • All modules included",
  "gratis": "30 Days Free",
  "label_name": "First Name",
  "label_surname": "Last Name",
  "label_company": "Company Name",
  "label_email": "Work Email",
  "label_phone": "Phone Number",
  "label_note": "Additional Note (Optional)",
  "placeholder_name": "e.g. John",
  "placeholder_surname": "e.g. Doe",
  "placeholder_company": "e.g. Orizon AIX Ltd.",
  "placeholder_email": "name@company.com",
  "placeholder_phone": "+1 555 000 0000",
  "placeholder_note": "Do you have specific requirements?",
  "terms_part1": "I accept the",
  "terms_link": "terms of use",
  "terms_part2": "and data processing.",
  "btn_send": "Start free trial",
  "footer_note": "OrizonDesk reserves the right to verify data before approving the trial period.",
  "brand_subtitle": "OrizonDesk Digital Systems",
  "error_email_exists": "This email address is already registered. Please sign in or use another email."
},


"common1": {
    "back": "Back"
  },
  "status": {
    "section_title": "Resource & Subscription Status",
    "section_subtitle": "Overview of current usage and system limitations.",
    "employees_label": "Employees",
    "storage_label": "Cloud Storage",
    "expires_in": "License time remaining",
    "upgrade_btn": "UPGRADE PLAN",
    "current_plan": "Current Plan",
    "days_suffix": "Days",
    "history_btn": "Payment History",
    "trash_btn": "Free up storage"
  },

 "upgrade": {
  "modal_title": "Plan Management",
  "current_status": "Current plan",
  "current_expires": "Expires on",
  "current_workers": "Active employees",
  "current_storage": "Used storage",
  "tab_upgrade": "Upgrade",
  "tab_renew": "Renewal",
  "tab_custom": "Custom Offer",
  "recommended": "Recommended",
  "recommended_renewal": "Renew same plan",
  "plan_basic_title": "Basic Package",
  "plan_basic_price": "75 € / year",
  "plan_basic_workers": "10 employees",
  "plan_basic_storage": "5GB Cloud",
  "plan_basic_feat1": "QR Code Badge",
  "plan_basic_feat2": "Email support",
  "plan_premium_title": "Premium Package",
  "plan_premium_price": "230 € / year",
  "plan_premium_workers": "50 employees",
  "plan_premium_storage": "15GB Cloud",
  "plan_premium_feat1": "Audit Log System",
  "plan_premium_feat2": "Priority support",
  "plan_enterprise_title": "Enterprise Package",
  "plan_enterprise_price": "615 € / year",
  "plan_enterprise_workers": "Unlimited",
  "plan_enterprise_storage": "100GB Cloud",
  "plan_enterprise_feat1": "Custom API access",
  "plan_enterprise_feat2": "Dedicated manager",
  "pay_now": "Pay now",
  "select_plan": "Choose this plan",
  "current_plan_badge": "Current plan",
  "downgrade_badge": "Downgrade",
  "upgrade_badge": "Upgrade",
  "review_title": "Plan change summary",
  "review_from": "Current plan",
  "review_to": "New plan",
  "review_workers": "Employees",
  "review_storage": "Cloud storage",
  "review_price": "Price",
  "review_period": "Duration",
  "review_period_val": "365 days",
  "review_proceed": "Proceed to payment",
  "review_back": "← Back to selection",
  "downgrade_error_title": "Downgrade not possible",
  "downgrade_error_workers": "You currently have {current} registered employees. The {plan} plan accepts max {max} employees. Remove employees from the company before proceeding.",
  "downgrade_error_storage": "You are using {current}GB of storage. The {plan} plan offers max {max}GB. Free up space by deleting documents (including from trash) before proceeding.",
  "downgrade_error_both": "You have too many employees ({workers}) and too much storage used ({storage}GB) for the selected plan.",
  "divider_text": "or customize manually",
  "custom_title": "Custom Configuration",
  "custom_subtitle": "Select the parameters and our team will send you an offer",
  "cloud_storage": "Cloud Storage",
  "employee_count": "Number of employees",
  "license_duration": "License Duration",
  "unlimited": "UNLIMITED",
  "year_one": "YEAR",
  "year_multi": "YEARS",
  "send_request": "SEND QUOTE REQUEST",
  "success_title": "Request sent!",
  "success_thanks": "Thank you for your trust.",
  "success_desc_1": "Our team will analyze your configuration and contact you in",
  "success_desc_2": "the shortest possible time",
  "success_desc_3": "to finalize the offer.",
  "renewal_success_title": "Payment processing",
  "renewal_success_desc": "Your plan will be updated as soon as the payment is confirmed. A confirmation email will be sent to your address.",
  "feat_audit": "Audit Log System",
  "feat_support": "Priority support",
  "feat_api": "Custom API access",
  "feat_manager": "Dedicated manager",
  "select_btn": "SELECT",
  "premium_title": "Premium Package",
  "premium_price": "230 € / year",
  "premium_subtitle": "Up to 50 employees and advanced features",
  "enterprise_title": "Enterprise Package",
  "enterprise_price": "615 € / year",
  "enterprise_subtitle": "Unlimited employees and API access",
  "loading_check": "Loading data ...",
  "error_fetch": "Error loading data. Please try again.",
  "checkout_error": "Error opening payment. Please try again.",
  "plan_basic_price_eur":      "75 €",
"plan_premium_price_eur":    "230 €",
"plan_enterprise_price_eur": "615 €",
"billing_annual": "Annual",
  "billing_monthly": "Monthly",
  "review_period_annual": "365 days",
  "review_period_monthly": "30 days",
  "receipt_cycle": "Billing cycle",

  "plan_basic_price_km_monthly":      "15.99 KM",
  "plan_premium_price_km_monthly":    "44.99 KM",
  "plan_enterprise_price_km_monthly": "119.99 KM",
  "plan_basic_price_eur_monthly":     "7.99 €",
  "plan_premium_price_eur_monthly":   "44.99 €",
  "plan_enterprise_price_eur_monthly":"119.99 €",


},
"renewal_success": {
  "loading": "Processing payment ...",
  "title": "Plan Updated!",
    "receipt_cycle": "Billing cycle",
  "subtitle": "Your plan has been successfully",
  "subtitle2": "updated. Confirmation sent via email.",
  "badge_renewed": "Plan renewed",
  "badge_upgraded": "Plan upgraded",
  "badge_downgraded": "Plan downgraded",
  "receipt_title": "Change Confirmation",
  "receipt_payment_id": "Payment ID",
  "receipt_plan": "Plan",
  "receipt_valid": "Valid until",
  "receipt_status": "Status",
  "receipt_status_val": "Active",
  "btn_home": "Go to Dashboard",
  "error_title": "Update error",
  "error_subtitle": "Payment successful but plan not updated. Please contact support.",
  "error_label_id": "Payment ID",
  "error_label_msg": "Error",
  "error_contact": "Contact us at",
  "error_status_failed": "Payment failed. Status:"
},

"invite_setup": {
  "title": "You're invited!",
  "desc": "Complete your account setup by setting a password",
  "new_password": "Create Password",
  "confirm_password": "Confirm Password",
  "button": "Activate my account",
  "success": "Account activated successfully! Welcome to the team.",
  "error_match": "Passwords do not match",
    "error_too_short": "Password must be at least {{min}} characters long",
  "passwords_match": "Passwords match",
  "error_session_title": "Invalid or Expired Link",
  "error_session_expired": "This invitation link is no longer valid or has already been used. Please ask your administrator to send you a new invitation.",
  "back_to_login": "Back to Login"
},

"company_inactive": {
  "title": "Company Inactive",
  "desc": "Access to OrizonDesk for your company has been suspended. This usually happens when the trial period or subscription has expired.",
  "contact_support": "Contact OrizonDesk Support",
  "renew_btn": "Renew Subscription",
"renew_hint": "Only administrators can renew the subscription"
},

"userLog": {
  "noPermission": "You do not have permission to access the audit logs.",
  "back": "Back",
  "title": "Activity Audit Log",

  "loadMore": "Load more",
  "subtitle": "Tracking user activities, document downloads, and system changes",
  "table": {
    "time": "Action Time",
    "user": "User (Executor)",
    "action": "Action / Type",
    "document": "Document / File",
    "device": "Device",
    "noActivity": "No activities recorded",
    "system": "System"
  },
  "footer": {
    "gdprNote": "This log is immutable and serves as official proof of access to sensitive documents in accordance with GDPR regulations.",
    "policy": "Audit Policy",
    "status": "Active Monitoring"
  }
},


  "legal": {
    "back": "Back",
    "title_part1": "Legal &",
    "title_part2": "Compliance",
    "header_subtitle": "Orizon Desk Portal • Infrastructure & Privacy • v1.2.5 • 2026",
    "stats": {
      "residency": "Data Residency",
      "storage": "DB Infrastructure",
      "encryption": "Encryption Standard",
      "gdpr": "GDPR Compliance",
      "db": "Database",
      "security": "Security Protocol",
      "monitoring": "Monitoring",
      "identity": "Identity"
    },
    "stats_vals": {
      "residency": "Zurich (CH) Switzerland",
      "gdpr": "Full EU Standards"
    },
    "section01": {
      "title": "Terms and Conditions",
      "subtitle": "SaaS Agreement and Military-Grade Integrity Guarantees",
      "p1_part1": "Orizon Desk is a closed digital ecosystem, regulated by strict security protocols. Access is strictly limited to authorized personnel, and every interaction is protected by architecture",
      "p2_part1": "To ensure maximum protection, the system constantly monitors access points:",
      "p2_bold": "each session is linked to the user's IP address",
      "p2_part2": "to prevent external intrusions, brute-force attacks, or unauthorized use of credentials from unknown locations.",
      "p3": "Orizon AIX commits to 99.9% service availability. Data contained within the portal is treated with the highest level of industrial confidentiality.",
      "integrity_title": "System Integrity",
      "integrity_bold": "We utilize military-grade security protocols",
      "integrity_desc": "to prevent identity theft or data loss. Integrity is guaranteed by checksum algorithms that constantly verify that no file has been modified, even accidentally.",
      "feature1_title": "Bcrypt Password Hashing",
      "feature1_desc": "Passwords are never stored in plain text, making decryption impossible even in the event of direct database access.",
      "feature2_title": "SSL/TLS 1.3",
      "feature2_desc": "Every bit of information traveling between your browser and our servers in Zurich is protected by the most advanced encryption protocol available today.",
      "user_resp_title": "User Responsibility",
      "user_resp_desc": "The user is the guardian of their credentials. Orizon Desk implements automatic account lockout after 5 failed attempts and IP address tracking to detect attacks.",
      "monitor_title": "Real-Time Monitoring",
      "monitor_desc": "Our threat detection system constantly analyzes traffic to identify suspicious patterns. Every downloaded document generates a unique cryptographic timestamp."
    },
    "section02": {
      "title": "Privacy Policy",
      "subtitle": "Compliance with EU Regulation 2016/679 and International Standards",
      "gdpr_text1": "In accordance with Art. 13 of the GDPR, we inform you that the processing of personal data is solely aimed at managing the employment relationship and digitalizing company documentation. We do not sell or share your data with third parties for commercial purposes.",
      "gdpr_text2": "Processed data includes: personal identifiers, contractual data, bank coordinates (if on the payroll), and system access logs. Processing is necessary for the fulfillment of legal and contractual obligations.",
      "cards": {
        "purpose_t": "Purpose",
        "purpose_d": "HR digitalization, archiving of payslips and unique certificates.",
        "retention_t": "Retention",
        "retention_d": "Data is stored for 10 years in accordance with European fiscal regulations.",
        "security_t": "Security",
        "security_d": "Granular Role-Based Access Control (RBAC). An administrator can only see resources specifically assigned to them."
      },
      "audit": {
        "header": "Full Traceability: What is a Log Audit?",
        "p1_part1": "Every single action within the Orizon Desk portal is recorded in an immutable",
        "p1_part2": ". This means the system creates a digital 'black box' that stores: who accessed, from which IP address, at what time, and which document was viewed or downloaded.",
        "p2_part1": "This feature is crucial for your security: it guarantees",
        "p2_bold": "non-repudiation",
        "p2_part2": "of actions and allows verification at any time that sensitive documents (such as payslips) were viewed exclusively by the legitimate owner or authorized HR personnel, eliminating the risk of hidden access.",
        "tag1": "Immutable Timestamp",
        "tag2": "IP Tracking Protection",
        "tag3": "Data Access Transparency"
      },
      "cookies": {
        "title": "Cookie Notice",
        "desc": "Orizon Desk Portal exclusively uses 'Technical Cookies' necessary for session functioning and authentication security. We do not use profiling cookies or third-party advertising trackers (such as Facebook Pixel or Google Analytics) to guarantee your maximum privacy."
      }
    },
    "section03": {
      "title": "Infrastructure & Cloud",
      "subtitle": "Data Location Zurich (Switzerland) and AWS S3 Technology",
      "aws_title": "AWS S3 Cloud Storage",
      "aws_desc_part1": "Every uploaded file is hosted on",
      "aws_desc_part2": "Data is not stored on a vulnerable physical server, but in a distributed infrastructure designed for 99.99% durability. Each file is individually encrypted at rest (At-Rest Encryption).",
      "swiss_title": "Why Switzerland (Zurich)?",
      "swiss_bold": "Zurich (Region: eu-central-2)",
      "swiss_desc_part1": "Our servers are located in the technological hub of",
      "swiss_desc_part2": ". Switzerland offers unique political and legal stability, with data protection laws that further extend GDPR protections, ensuring business documents are protected from external influence or arbitrary seizure.",
      "backup_title": "Operational Continuity & Backup",
      "backup_desc_part1": "We utilize a system of",
      "backup_desc_part2": "that allows point-in-time data recovery, guaranteeing protection against human error or technical failure. All documents are archived with geographic redundancy, and backups are encrypted with",
      "backup_desc_part3": "keys managed via AWS KMS.",
      "rls_title": "Data Segregation RLS",
      "rls_desc_part1": "The PostgreSQL database uses",
      "rls_desc_part2": "technology. This ensures that at the code level, it is physically impossible for a user from one company to see the records of another, even in the event of an application error.",
      "cert_header": "Cloud Certifications",
      "cert_iso": "International standards for managing information security in the cloud.",
      "cert_soc": "Certification of internal controls for security, availability, and confidentiality.",
      "cert_gdpr": "EU compliance for the transfer and processing of sensitive personal data.",
      "cert_csa": "Highest level of specific security for Cloud Service Providers (SaaS).",
      "cert_dr": "Daily geo-replicated backups to ensure continuity in any scenario.",
      "quote": "Our infrastructure is not just compliant; it is a global leader in HR data protection.",
      "click_hint": "Click on the badges above to verify official provider certifications."
    },
    "section04": {
      "title": "Your Rights",
      "subtitle": "Exercising Legal Powers Guaranteed by GDPR",
      "rights": {
        "access_t": "Right of Access",
        "access_d": "You can request confirmation of your data processing and receive a full digital copy.",
        "forget_t": "Right to be Forgotten",
        "forget_d": "Request for permanent deletion of personal data once the legal purpose of processing expires.",
        "port_t": "Portability",
        "port_d": "Download documents in a structured format (PDF) for transfer to another controller.",
        "limit_t": "Restriction",
        "limit_d": "Request to restrict processing in case the accuracy of the data is contested."
      },
      "exercise_text": "To exercise any of the stated rights or to report a Data Breach, the data subject can directly contact the Data Controller via the dedicated email address. Requests are processed within a maximum of 30 days."
    },
    "footer": {
      "contact_label": "Contact for Legal Inquiries",
      "locations": "Orizon AIX • Brescia, Italy • Zurich, CH",
      "update_tag": "Updated March 2026",
      "disclaimer": "This documentation is subject to annual review. Continued use of the platform implies automatic acceptance of all terms. Any significant changes will be communicated via internal notice.",
      "secured_switzerland": "Proudly Secured in Switzerland."
    },
    "section05": {
      "title": "Payment Security",
      "subtitle": "Transaction Protection and Zero-Storage Privacy Policy",
      "points": {
        "stripe_t": "Zero-Storage Policy",
        "stripe_d": "Orizon DESK does not store nor have access to your card details. All processes are isolated.",
        "pci_t": "PCI-DSS Standard",
        "pci_d": "Transactions are processed via Dodo Payments, compliant with the highest banking standards.",
        "crypto_t": "SSL Encryption",
        "crypto_d": "Complete communication is protected by 256-bit encryption and PKI security protocols.",
        "methods_t": "Payment Methods",
        "methods_d": "We support VISA, MasterCard, Klarna, Amazon Pay, and biometric payments via Apple and Google Pay."
      },
      "payment_text": "All monetary transactions are carried out through external, high-security gateway providers. Orizon Desk uses your data exclusively for linking purposes within the platform, while financial data is protected by impenetrable layers of third-party encryption."
    },
    "section06": {
  "title": "Refunds and Withdrawal",
  "subtitle": "Your rights under EU Directive 2011/83/EU — 14-day refund guarantee",
  "intro": "OrizonDesk respects all consumer rights provided for under European legislation. By purchasing any plan through our platform, you are entitled to a refund under the conditions set out below.",
  "points": {
    "period_t": "Withdrawal period",
    "period_d": "You have the right to withdraw from the contract within 14 calendar days from the date of payment confirmation, without having to provide any reason.",
    "how_t": "How to submit a request",
    "how_d": "Send an email to [info@orizon-aix.com](mailto:info@orizon-aix.com) with subject 'REFUND REQUEST' indicating the Payment ID of the transaction. We will respond within 48 hours.",
    "conditions_t": "Refund conditions",
    "conditions_d": "A refund is possible if the account has not been actively used to add employees, documents, or company data after activation.",
    "timeline_t": "Refund timeline",
    "timeline_d": "After the request is approved, funds are returned to the original payment method within 5–10 business days."
  },
  "exceptions_title": "Exceptions to the right of withdrawal",
  "exceptions_desc": "The right of withdrawal does not apply if the digital service has been fully activated and used with your explicit consent, pursuant to Art. 16(m) of Directive 2011/83/EU. In case of active use of the platform, we will evaluate the request individually and, if necessary, offer a partial refund or a subscription extension.",
  "contact_block": "For any questions regarding refunds, contact us at [info@orizon-aix.com](mailto:info@orizon-aix.com) or via the support form within the platform. Each request is handled individually and with the utmost transparency.",
  "eu_note": "This policy is compliant with EU Directive 2011/83/EU on consumer rights and applicable local legislation."
}
  },

  "payments": {
    "no_permission": "You do not have permission to access payment history.",
    "back": "Back",
    "title": "Payment & License History",
    "subtitle": "Overview of transactions, active licenses, and administrative data",
    "table": {
      "period": "Validity Period",
      "admin_email": "Admin / Email",
      "package_id": "Package & ID",
      "amount": "Amount",
      "status_pdf": "Status / PDF",
      "from": "Paid:",
      "to": "Expires:",
      "paid_by": "Paid by",
      "online": "Online",
      "no_transactions": "No transactions recorded"
    },
    "footer": {
      "note": "All licenses are automatically activated immediately after payment confirmation. For invoices or additional questions, contact support with the transaction ID.",
      "system_status": "System Status",
      "verified": "Verified & Secured"
    }
  },

  "trash": {
    "title": "Document Trash",
    "subtitle": "Manage deleted files: restore them or delete permanently",
    "placeholder_search": "Search file or user...",
    "filter_all": "All",
    "filter_today": "Today",
    "filter_7days": "7 Days",
    "table_doc": "Document",
    "table_size": "Size",
    "table_owner": "Owner",
    "table_removed_by": "Removed By",
    "table_date": "Date and Time",
    "table_actions": "Actions",
    "no_files": "No files found",
    "total": "Total",
    "info_auto_on": "Auto-delete is ACTIVE. Files older than 30 days will be automatically removed.",
    "info_auto_off": "Files will remain in the trash until manually deleted.",
    "modal_restore_title": "Restore File?",
    "modal_delete_title": "Delete Permanently?",
    "modal_restore_desc": "Do you want to restore the file {{name}} by {{owner}}?",
    "modal_delete_desc": "Are you sure you want to permanently delete the file {{name}} by {{owner}}? This action is irreversible.",
    "modal_cancel": "Cancel",
    "modal_confirm": "Confirm"
  },
  "settings_trash": {
    "delete_label": "Auto-Delete",
    "days_30": "30 Days"
  },



  "inventory": {
  "back": "Back",
  "new_table": "New Table",
  "title": "Inventory and Warehouse",
  "subtitle": "Manage your resources and create custom records.",
  "stats": {
    "total": "Tables",
    "total_desc": "Active tables",
    "records": "Records",
    "records_desc": "Total rows in all tables",
    "last_update": "Updated",
    "last_update_desc": "Date of last entry"
  },
  "active_tables": "Active Tables",
  "open_record": "Open record",
  "no_tables": {
    "title": "No table created",
    "desc": "Create your first custom inventory table to start entering data.",
    "btn": "Start now"
  }
},

"inventory_table": {
  "back": "Back",
  "search_placeholder": "Search...",
  "btn_new_entry": "New Entry",
  "export_excel": "Export table to Excel (.xlsx)",
  "settings_title": "Column and table settings",
  "add_row_title": "Add new row to table",
  "actions": "Actions",
  "loading": "Loading...",
  "confirm_delete_row": "Delete this row?",
  "confirm_delete_column": "Delete column \"{{name}}\"?",
  "error_prefix": "Error: ",
  "table_default_name": "Table",
  "status_true": "True",
  "status_false": "False"
},

"create_table_modal": {
  "title": "New Table",
  "system_info": "System: AWS (Supabase) (ISO 8601)",
  "label_table_name": "Table Name",
  "placeholder_table_name": "e.g. WAREHOUSE_A",
  "label_columns": "Column Configuration",
  "placeholder_col_name": "Field name",
  "label_dropdown": "Enable Dropdown",
  "btn_cancel": "Cancel",
  "btn_create": "Create Table",
  "btn_creating": "Creating...",
  "alert_empty_name": "Enter the table name!",
  "alert_error": "Error: ",
  "types": {
    "text": "Text",
    "number": "Number",
    "date": "Date (YYYY-MM-DD)",
    "boolean": "Boolean (True/False)"
  }
},

"insert_line": {
  "header": {
    "title": "New Record",
    "loading_structure": "Loading database structure...",
    "table_label": "Table: "
  },
  "validation": {
    "invalid_date": "Must be YYYY-MM-DD",
    "invalid_number": "Must be a number"
  },
  "inputs": {
    "dropdown_placeholder": "Choose or type...",
    "true": "TRUE",
    "false": "FALSE"
  },
  "footer": {
    "cancel": "Cancel",
    "save": "Save"
  }
},

"settings_columns": {
  "title": "Field Configuration",
  "subtitle": "Direct addition to database",
  "label_new_field": "New Field",
  "placeholder_name": "New column name...",
  "label_dropdown": "Enable Dropdown",
  "btn_add": "Add Field",
  "btn_adding": "Adding...",
  "label_existing_fields": "Existing Fields",
  "status_dropdown_on": "● Dropdown Active",
  "status_dropdown_off": "○ Enable Dropdown",
  "btn_close": "Close Settings",
  "types": {
    "text": "Text",
    "number": "Number",
    "date": "Date (YYYY-MM-DD)",
    "boolean": "Boolean (True/False)"
  }
},

"update_info": {
  "header": {
    "edit_title": "Edit Record",
    "view_title": "Detailed Information",
    "edit_subtitle": "Edit values and save",
    "view_subtitle": "Viewing record from table"
  },
  "types": {
    "boolean": "[ Boolean ]",
    "date": "[ Date ]",
    "number": "[ Number ]",
    "text": "[ Text ]"
  },
  "labels": {
    "negative_value": "Value is below zero",
    "last_update": "Last modified",
    "active": "Active (True)",
    "inactive": "Inactive (False)",
    "true": "TRUE",
    "false": "FALSE"
  },
  "footer": {
    "cancel": "Cancel",
    "save_changes": "Save Changes",
    "close_view": "Close view"
  }
},

 "premium_payments": {
    "back": "Back",
    "badge": "OrizonDesk PREMIUM",
    "price": "230 €",
    "price_monthly": "24.99 €",
    "price_period": "/ ANNUAL",
    "price_period_monthly": "/ MONTHLY",
    "feature_employees": "50 Employees",
    "feature_cloud": "15GB Cloud",
    "feature_audit": "Audit Log",
    "feature_support": "Priority Support",
    "step1": {
      "title": "Invoice & Details",
      "subtitle": "Fill out the form to activate the Premium Package",
      "label_name": "First Name",
      "label_surname": "Last Name",
      "label_company": "Company Name",
      "label_email": "Email",
      "label_phone": "Phone",
      "placeholder_name": "Your first name",
      "placeholder_surname": "Your last name",
      "placeholder_company": "Company name",
      "placeholder_email": "admin@company.com",
      "placeholder_phone": "+1",
      "terms_part1": "I accept the",
      "terms_link": "Terms and Conditions",
      "terms_part2": "and the Privacy Policy",
      "btn_next": "Proceed to Payment",
      "error_generic": "An error occurred.",
      "error_email_exists": "This email is already registered in the system.",
      "error_server": "Server error. Please try again later."
    },
    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "PREMIUM PACKAGE for",
      "total_label": "TOTAL TO PAY:",
      "total_amount": "230.00 €",
      "total_amount_monthly": "24.99 €",
      "summary_title": "Details Summary",
      "summary_name": "First and Last Name",
      "summary_company": "Company",
      "summary_email": "Email",
      "summary_phone": "Phone",
      "summary_package": "Package",
      "summary_package_value": "Premium — 365 days",
      "summary_package_value_monthly": "Premium — 30 days",
      "btn_pay": "Proceed to Payment — 230 €",
      "btn_pay_monthly": "Proceed to Payment — 24.99 €",
      "ssl_label": "Secure payment via Dodo Payments · SSL Encrypted",
      "btn_back": "← Back to Edit Details",
      "loading": "Opening secure payment ...",
      "error_checkout": "Error during payment. Please try again.",
      "error_expired": "Payment session expired. Please try again.",
      "error_open": "Error opening payment. Please try again."
    },
    "footer_ssl": "SSL Encrypted Transaction · Dodo Payments"
  },
  "payment_success": {
    "loading": "Activating Premium Package ...",
    "badge": "OrizonDesk PREMIUM",
    "title": "Premium Activated!",
    "subtitle": "Check your email",
    "subtitle2": "for login credentials and account activation.",
    "receipt_title": "Transaction Confirmation",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Package",
    "receipt_package_value": "Premium — 365 days",
    "receipt_package_value_monthly": "Premium — 30 days",
    "receipt_status": "Status",
    "receipt_status_value": "Paid & Verified",
    "btn_home": "Go to Home",
    "error_title": "Activation Error",
    "error_subtitle": "Payment was successful, but activation was not completed.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Error",
    "error_contact": "Save the Payment ID and contact us at",
    "error_status_failed": "Payment failed. Status:"
  },
  "basic_payments": {
    "back": "Back",
    "badge": "OrizonDesk BASIC",
    "price": "75 €",
    "price_monthly": "7.99 €",
    "price_period": "/ ANNUAL",
    "price_period_monthly": "/ MONTHLY",
    "feature_employees": "10 Employees",
    "feature_cloud": "5GB Cloud",
    "feature_qr": "QR Code Badge",
    "feature_support": "Email Support",
    "step1": {
      "title": "Invoice & Details",
      "subtitle": "Fill out the form to activate the Basic Package",
      "label_name": "First Name",
      "label_surname": "Last Name",
      "label_company": "Company Name",
      "label_email": "Email",
      "label_phone": "Phone",
      "placeholder_name": "Your first name",
      "placeholder_surname": "Your last name",
      "placeholder_company": "Company name",
      "placeholder_email": "admin@company.com",
      "placeholder_phone": "+1",
      "terms_part1": "I accept the",
      "terms_link": "Terms and Conditions",
      "terms_part2": "and the Privacy Policy",
      "btn_next": "Proceed to Payment",
      "error_generic": "An error occurred.",
      "error_email_exists": "This email is already registered in the system.",
      "error_server": "Server error. Please try again later."
    },
    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "BASIC PACKAGE for",
      "total_label": "TOTAL TO PAY:",
      "total_amount": "75.00 €",
      "total_amount_monthly": "7.99 €",
      "summary_title": "Details Summary",
      "summary_name": "First and Last Name",
      "summary_company": "Company",
      "summary_email": "Email",
      "summary_phone": "Phone",
      "summary_package": "Package",
      "summary_package_value": "Basic — 365 days",
      "summary_package_value_monthly": "Basic — 30 days",
      "btn_pay": "Proceed to Payment — 75.00 €",
      "btn_pay_monthly": "Proceed to Payment — 7.99 €",
      "ssl_label": "Secure payment via Dodo Payments · SSL Encrypted",
      "btn_back": "← Back to Edit Details",
      "loading": "Opening secure payment ...",
      "error_checkout": "Error during payment. Please try again.",
      "error_expired": "Payment session expired. Please try again.",
      "error_open": "Error opening payment. Please try again."
    },
    "footer_ssl": "SSL Encrypted Transaction · Dodo Payments"
  },
  "basic_payment_success": {
    "loading": "Activating Basic Package ...",
    "badge": "OrizonDesk BASIC",
    "title": "Basic Activated!",
    "subtitle": "Check your email",
    "subtitle2": "for login credentials and account activation.",
    "receipt_title": "Transaction Confirmation",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Package",
    "receipt_package_value": "Basic — 365 days",
    "receipt_package_value_monthly": "Basic — 30 days",
    "receipt_status": "Status",
    "receipt_status_value": "Paid & Verified",
    "btn_home": "Go to Home",
    "error_title": "Activation Error",
    "error_subtitle": "Payment was successful, but activation was not completed.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Error",
    "error_contact": "Save the Payment ID and contact us at",
    "error_status_failed": "Payment failed. Status:"
  },
  "enterprise_payments": {
    "back": "Back",
    "badge": "OrizonDesk ENTERPRISE",
    "price": "615 €",
    "price_monthly": "59.99 €",
    "price_period": "/ ANNUAL",
    "price_period_monthly": "/ MONTHLY",
    "feature_employees": "Unlimited",
    "feature_cloud": "100GB Cloud",
    "feature_audit": "Advanced Audit",
    "feature_support": "Dedicated Support",
    "step1": {
      "title": "Invoice & Details",
      "subtitle": "Fill out the form to activate the Enterprise Package",
      "label_name": "First Name",
      "label_surname": "Last Name",
      "label_company": "Company Name",
      "label_email": "Email",
      "label_phone": "Phone",
      "placeholder_name": "Your first name",
      "placeholder_surname": "Your last name",
      "placeholder_company": "Company name",
      "placeholder_email": "admin@company.com",
      "placeholder_phone": "+1",
      "terms_part1": "I accept the",
      "terms_link": "Terms and Conditions",
      "terms_part2": "and the Privacy Policy",
      "btn_next": "Proceed to Payment",
      "error_generic": "An error occurred.",
      "error_email_exists": "This email is already registered in the system.",
      "error_server": "Server error. Please try again later."
    },
    "step2": {
      "title": "ORIZON DESK",
      "subtitle": "ENTERPRISE PACKAGE for",
      "total_label": "TOTAL TO PAY:",
      "total_amount": "615.00 €",
      "total_amount_monthly": "59.99 €",
      "summary_title": "Details Summary",
      "summary_name": "First and Last Name",
      "summary_company": "Company",
      "summary_email": "Email",
      "summary_phone": "Phone",
      "summary_package": "Package",
      "summary_package_value": "Enterprise — 365 days",
      "summary_package_value_monthly": "Enterprise — 30 days",
      "btn_pay": "Proceed to Payment — 615 €",
      "btn_pay_monthly": "Proceed to Payment — 59.99 €",
      "ssl_label": "Secure payment via Dodo Payments · SSL Encrypted",
      "btn_back": "← Back to Edit Details",
      "loading": "Opening secure payment ...",
      "error_checkout": "Error during payment. Please try again.",
      "error_expired": "Payment session expired. Please try again.",
      "error_open": "Error opening payment. Please try again."
    },
    "footer_ssl": "SSL Encrypted Transaction · Dodo Payments"
  },
  "enterprise_payment_success": {
    "loading": "Activating Enterprise Package ...",
    "badge": "OrizonDesk ENTERPRISE",
    "title": "Enterprise Activated!",
    "subtitle": "Check your email",
    "subtitle2": "for login credentials and account activation.",
    "receipt_title": "Transaction Confirmation",
    "receipt_payment_id": "Payment ID",
    "receipt_package": "Package",
    "receipt_package_value": "Enterprise — 365 days",
    "receipt_package_value_monthly": "Enterprise — 30 days",
    "receipt_status": "Status",
    "receipt_status_value": "Paid & Verified",
    "btn_home": "Go to Home",
    "error_title": "Activation Error",
    "error_subtitle": "Payment was successful, but activation was not completed.",
    "error_label_id": "Payment ID",
    "error_label_msg": "Error",
    "error_contact": "Save the Payment ID and contact us at",
    "error_status_failed": "Payment failed. Status:"
  },


"ferie": {
  "modal_title": "Vacation Request",
  "type_single_day": "One Day",
  "type_multi_day": "Multiple Days",
  "type_hours": "Hours",
  "date_label": "Date",
  "from_label": "From",
  "to_label": "To",
  "from_time_label": "From Time",
  "to_time_label": "To Time",
  "weekend_included": "Weekend Included",
  "type_label": "TYPE",
  "shift_label": "Shift",
  "shift_daily": "Full Day",
  "shift_first": "First Shift",
  "shift_second": "Second Shift",
  "shift_third": "Third Shift",
  "shift_other": "Other",
  "note_label": "Note (optional)",
  "note_placeholder": "Add a note...",
  "cancel_btn": "Cancel",
  "submit_btn": "Send Request",
  "new_request_btn": "New Request",
  "errors": {
    "select_date": "Select a date.",
    "select_range": "Select From and To.",
    "select_date_time": "Select date and time.",
    "submit_error": "Error while submitting the request."
  },
  "admin": {
    "page_title": "Vacation Management",
    "requests_title": "Employee Vacation Requests",
    "search_placeholder": "Search employee...",
    "all_statuses": "All Statuses",
    "approve_btn": "Approve",
    "reject_btn": "Reject",
    "edit_btn": "Edit",
    "save_changes": "Save Changes",
    "new_request_title": "New Request (Vacation)",
    "select_employee_label": "Employee",
    "select_employee_placeholder": "Select an employee...",
    "auto_accept_notice": "This request will be saved as already accepted.",
    "errors": {
      "select_employee": "Select an employee."
    }
  },

  "my_requests_title": "My Vacation Requests",
  "all_years": "All Years",
  "all_months": "All Months",
  "reset_btn": "Reset",
  "no_requests": "No requests submitted",
  "days_label": "days",
  "details_tooltip": "Details",
  "load_more_btn": "Load More",
  "details_title": "Request Details",
  "time_label": "Time",
  "days_column_label": "Days",
  "yes": "Yes",
  "no": "No",
  "timeline_title": "History",
  "timeline_sent": "Request sent",
  "timeline_answered_by": "Answered by",
  "timeline_answer_date": "Answer date",
  "delete_btn": "Delete Request",
  "delete_confirm_text": "Are you sure? This action cannot be undone.",
  "confirm_delete_btn": "Confirm Deletion",
  "status_accepted": "Accepted",
  "status_rejected": "Rejected",
  "status_pending": "Pending",
  "months": {
    "01": "January", "02": "February", "03": "March", "04": "April",
    "05": "May", "06": "June", "07": "July", "08": "August",
    "09": "September", "10": "October", "11": "November", "12": "December"
  }
}
        }
      }
    },
    fallbackLng: 'it',
    debug: false,
    interpolation: { escapeValue: false }
  });

export default i18n;